import {
  motion,
  useScroll,
  useTransform,
  useAnimation,
} from "framer-motion/dist/framer-motion";
import { useRef } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
// import DoughnutComp from "./DoughnutComp";
import IranRetail from "../../images/IranRetail.svg";
import { useInView } from "react-intersection-observer";
import { useState, useEffect } from "react";

const retailVariants = {
  visible: {
    opacity: 1,
    x: "0vw",
    scale: 1,
    transition: { duration: 0.3, ease: "linear", delay: 0.2 },
  },
  hidden: {
    opacity: 0,
    x: "-20vw",
    scale: 0.5,
    transition: { duration: 0.3, ease: "linear", delay: 0.2 },
  },
};

const Retail = () => {
  const controls = useAnimation();
  const [viewRef, inView] = useInView();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (inView && !shown) {
      controls.start("visible");
      setShown(true);
    } else if (!inView && shown) {
      controls.start("hidden");
      setShown(false);
    } else {
      controls.start("hidden");
      setShown(false);
    }
    // eslint-disable-next-line
  }, [controls, inView]);

  const ref = useRef(null);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end end"],
  });
  const el1 = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 0.2, 0.35],
    // Into these values:
    [-700, -700, 0]
  );
  const el2 = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 0.35, 0.45],
    // Into these values:
    [-700, -700, 0]
  );
  const el3 = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 0.6, 1],
    // Into these values:
    [0, 0, 460]
  );
  const el3x = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 0.6, 1],
    // Into these values:
    [0, 0, -480]
  );
  const el3scale = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 0.6, 1],
    // Into these values:
    [1, 1, 4.6]
  );
  const el4 = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 0.35, 0.5],
    // Into these values:
    [-700, -700, 0]
  );
  const el5 = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 0.45, 0.6],
    // Into these values:
    [-700, -700, 0]
  );
  const opacity = useTransform(
    scrollYProgress,
    // Map x from these values:
    [0, 1],
    // Into these values:
    [1, 0.2]
  );

  return (
    <div className="color-dk-r">
      <div className="row m-0 ">
        <div className="stickyRowHeaders col-lg-4 col-12 d-flex align-items-center justify-content-center text-center bg-color-gr">
          <div className="d-lg-none d-inline">
            <div>Online Retail, Worldwide vs. Iran</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-200, 100]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Online Retail</div>
                <div> Worldwide vs. Iran</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>
        <div
          style={{ overflow: "hidden" }}
          ref={ref}
          className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-lg-5 px-3 pt-3 pb-5 bg-color-w "
        >
          <div>
            <svg
              style={{ overflow: "visible" }}
              version="1.1"
              id="world"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 1000 800"
            >
              <motion.polygon
                style={{ y: el2 }}
                className="WMst0"
                points="819.5,427 820.8,425.4 823.1,425.3 824.2,424.3 827.1,429.7 827.2,435.1 825.8,436.6 822.8,436.9 
	821.4,438.5 819.8,437.9 818.9,436.6 819.3,431.7 818,430.7 819.5,429.4 "
              />

              <motion.path
                style={{ y: el5 }}
                className="WMst1"
                d="M285.6,489.2l3.2-0.1l0.9-1.2l-4.2-0.4L285.6,489.2z M158.8,413.4l2.5,1.6l-1.2,1.6L158.8,413.4z M132.2,384.6
	l1.6,4l-5-0.5l-2.1-0.9l1.5,5.9l1,0.9l-0.7,1.9l0.3,2.6l-1.1,8.5l-0.6,2l1.5,4.8l-0.1,2.6l-0.9,1.4l1.5,2.2l0.3,3.2l3.3,3.9l0.5,2.4
	l1.6,1.1l-0.4,1.7l3.5,4v1.9l3,0.5l3.2,2.2l1.5,0.4l1.6,1.8l0.4,1.8l6.6-0.6l-0.2,0.7l10.2,3.7h7.9v-1.4h4.6l4.4,3.8l1.1,3.1l3.4,2
	l1.2-0.8l0.5-1.6l1-0.4l2.2,0.4h0l0.5,0.3h0l0.1,0.2l0.1,0l0.1,0l0.2,0.3l0.1,0.1l0.3,0.2l1.1,1.2l1,2.4l2.2,2.3l0.2,1.5v0.1
	l0.3,0.4l0.2,0.3l0.4,1.3l1.6,0.5l0.1,0.1l0,0l0.3,0.2h0l0.2,0.2h0.1l1.7,0.2l0.6,0.5l0.4-0.3l0.1,0h0.1l0,0l0,0l-0.6-2.9l1.2-3.7
	l1.2-1.4l3.1-0.9l1.7-2.1l3.9-0.7l2.8,0.7l1.5-0.9l1.8,1.7l2.4-0.5l1.5-1l0.3-1.2l1.8-1l3.3,0.6l2-1.1l2.3,0.4l1.3,1.2l1.1,1.4
	l2.8-0.7l1-0.7l3.4,3.5l0.3,0.9l-0.7,2.6l0.4,1.2l2.3,2.9l0.2,1.4l1.3,0.6l0.4,2.1l2-0.1l0.8-2.1l0.3-2.7l-1.9-4.6l0.3-1l-2-4.1
	l-0.9-3l1.8-3.5l1.4-1.7l1.3-0.4l2.2-1.9l1.6-2.2l1.6-0.1l0.7-1.4l2.1-1.3l2.3-2.1l1-2.5l-0.8-2.6l-1.2-1.5l0.6-1.8l-0.8-3.5
	l0.2-1.6l1,1.6l-0.5,1l1.3,1.9l2-1.6l0-2.7l0.9,0l2-2.1l0.3-2.2l1.7-2.7l2.8-0.7l2.5-0.1l2.3-1.5l-1.1-1.9l1.3-3.9l0.8-1.5l2.5-1.4
	l1.6-1.7l3,0.2l2.1-1.2l-0.9-1.4l-0.4,0.1l0-0.1l-0.2-0.3l0-0.1l0.1-1.2l-0.2,0l-0.3-0.1l-0.1,0l-0.1-0.1l-0.3-0.6l-0.2-5.1
	l-1.2-1.1l-1.7,0.7l-0.1,0l-0.4-0.8l-0.5-0.2l-2.1,3.3l-0.7,3.1l-3.6,3.4h-1.8l-0.1,0l-3,0h0l-3.5,0h0l-0.1,0l-0.2,0v0l-0.9,0.3
	l-0.6,0.3l-0.1,0.1l-0.1,0.1l-0.3,0.3l-0.7,0.7l-0.8,0.8l-0.1,0.1l-0.9,0.8l0.6,2.1l-1.8,1.1l-2,0.2l-2.4-0.6l-1.9,0.4l0.1,0.1
	l0,0.3l-0.1,0.3l0.1,0.2v0.1l0.1,0.1l0,0l0.2,0.3v0l-0.7,1.2l-6.2,3l-1,0.9l-2.7-0.1l-2.1-0.7l1-2v0l0.1-0.1l0.1-0.1l0.2-0.1
	l0.9-0.8l0.3-0.2l0-0.1l0.1-0.6l0-0.1l0.2-0.6l-0.9-3.7l-0.8-0.3l-1.8,1.8l-0.5-1.4l1.5-1.6l-0.5-3.7l-4-1.6l0.1,1.5l-1.7,0.7
	l-2,1.9l-0.8,4.2l1,2.9l-0.3,1.9l-1.2,2l-1.8,0.6l-1.2-2.4l-0.2-3.6l1.2-5l-0.4-1.6l1.8-2.7l4-1.7l1.7,0.3l2.2-1.3l-0.4-0.6l-0.2,0
	h0l-0.3,0.2l-1.5-1.2l-3.2,0.4l-1.9,1l-1.5-0.3l-2.3-2.8l-6,2.5l-0.9-1.6l-2.9,1.1l2.6-3.5l3.7-1.8l-1.9-0.4l-0.1,0H221l-0.6,0
	l-1.2,0l-0.1,0.1l-0.4,0.1l-0.2,0.1l-0.1-0.1l-0.5-0.1l-0.6-0.5l-0.1-0.1l-0.3-0.3l-0.8-0.2l-0.4,0.1l-0.7-0.7l0.2-0.2l-2-0.4
	l-0.1,0l-3.7-0.9l-1.7-0.7H132.2z M17.2,358.2l0.7,1.5l1.9-0.1l0.2-2L17.2,358.2z M102.9,354.8l2.6,1.7l0.9-1l-2.2-2.6L102.9,354.8z
	 M46.5,343.5l-2.6,2.7l1.3,1l1.6,0.1l3.9-1.5l-0.8-2.5L46.5,343.5z M94.5,343.8l2,2.3l1.6-0.6l0.5-2.8l-3.9-0.9L94.5,343.8z
	 M10.7,331l1.8,2.5l0.9-0.7l-0.8-3.1L10.7,331z M0,312.5l2.8,2.3l-1.6-4.2L0,312.5z M35.4,259.2l-4.9,0.5l-3.7,4l-4.1,2.1l-1.5,2.2
	l-0.3,3.4l-2.3,2.6l-6.3,0.8l-0.6,3.6l7,6.7l0.6,2.8l5.5,0.6l0.5,3.5l1.8-1l1.9,0.8l-1.3,1.4l-1.7-1.3l-1.8,4l-0.8-0.8l-4.5,0.1
	l0-3.4l-1.8-0.2l-3.7,1.8L7.2,298l3.8,3.6l1.5,3.4l7,0.1l2.4,1.6l1.7-2.3l2.1-0.5l1.8,5.7l-1.1,2.3l-3.2-0.2l-2.6,3.5l-1.5,0.3
	l-1,1.4l-2.5,1l-2.8,4.2l-0.1,1.7l1.5,2.3l2.9,1.4l-0.4,3.1l2,2.8l3.8-1l1-1.3l1.3,3.9l-0.8,1.9l0.7,3.2l3.8-2.8l2,0.7l1.9,3
	l0.9-2.4l2.8,2.4l0,1.5l-0.6,2.9l-3,3.4l-5.6,4.4l-2.5,0.5l-2.9,3.5l2.5,0.3l1.3-1.2l4.6-2.4l2.6-0.8l1.2-2.1l2.6-0.8l6.9-7l1.7-0.4
	l1.1-2.8l0.9-5l2.4-2l2.7-5.7l1.6-0.5l1.6-2l1.4,1.4l-3.7,2.4l0.4,2l-1.6,3.3l2.5,3.1l2-3l1.3,0.6l1.2-1.3l2.3-0.4l1.3-3.1l-1-1.7
	l3.7-0.7l2.8,2.6l4.8,1.5l0.6,0.9l4.1-0.3l6.1,2.3l4.7,3.1l5.3,4.8l2.1-0.9l2.3,0.7l0.9-0.8l1.7,1l2.2,3.2l0.5,2.1l1.7,2.1l1.9,3.9
	l1.7-0.1l0.9,1.3l-0.5,2.6l1.7,1.7l1.3-2.1l0-3.1l-0.2-1l-4.8-2.7l-4.9-9.8l-3.6-3.8l-1.3-2.7l-2.5,1l-0.6,2.3l-2.4,1.4l-1.4-2.8
	l-0.2-0.2l-4.6-4.8l-0.8,0.9l-2.8-0.7V269l-6.1-3.8l-8.7,1.6l-4.7-2.2l-3.8-2.8l-3.9,2.6l-3-1.9l-0.7-3.3l-2.6-0.8l-3.3,1.3l-2-3.3
	h-2.9l-1.2-1.6L35.4,259.2z"
              />

              <motion.path
                style={{ y: el1 }}
                className="WMst2"
                d="M673.3,421.3l0.9-2l3.5-1.5l1.3,0.6l2.2-0.5l1-2.1l2.5,0l1.1-1.3l5.6-2.4l-0.1-0.6l0.2-1.9l1.6-1.7l-0.8-2.4
	l-0.3-3l-0.9-1.6l6-2l1.8-5.5l0.6-1.2l2.1,1l2.8,0.5l1.6-0.8l0.1-4.5l0.7-1.1l2-0.5l0.4-1.6l1.5-0.8l1.4-0.2l0.4,2.5l3,2.4l2.8,0.4
	l2.7,4.7l-0.1,2.8l-1,1.8l0.6,1.4l7.2,0.9l3.4,2.4l1.9,0.2l1.8,4.4l1.2,1.5l1.8-0.2l6.4,0.9l3.7-0.4l2.6,0.6l0.7,1l3.6,1.2l3.1,0.1
	l1.4,1.1l6.7-3.3l3.8,0.2l3.5-0.9l2.5-2.6l2.6-1.4l-1.5-2.5l1.1-2.5l1.7-0.3l0.9,0.8l2.4,0.5l3.1-2.7l2.6,0l1.6-1.3l0.9-2.1l2.1-0.2
	l2.6-1.5l2.8,0.5l1.7-0.2l-0.5-2.1l-3.2-3.3l-2.2,0.1l-0.7,0.8l-3.4-0.5l-0.9,0.8l-1.2-1.9l3.3-7.1l3.2,1.4l1.7-1.4h0.1l0.3-0.4
	l0-0.1h0.1l1.2-0.2l0,0l0.1-0.1h0l0.6-1.2h0v0l0-0.1v0h-0.5l0.2-0.7l0-0.1l0.6-1.2l0,0l0.5-0.8l0,0l0-0.1l0,0l0.1-0.1l0,0l0.1-0.4
	l0,0l0-0.2h0.1l0.6-1.7l1.9-2.1h0.1l-0.3-1.4l0,0l-0.9-2.2l1.3-1.6V366l0.4-0.1l0.2,0l2.6-0.6l0.2,0l0.3-0.2l0.1,0l0.2-0.2h0.1
	l0.6,0.2h0.1l0.9-0.1l0.2-0.1l0.2,0h0.3l0,0l0-0.1l0.2-0.1l0.1,0l0.3,0.1h0.1l0.8,0.1l0.2,0l0.4,0.2l0.1,0l0.4,0.4h0.1l0,0l0.4,0.1
	l0.1,0.1l0.2,0.3h0v0.1l0.4,0.1h0l0.5,0.3l0.2,0.1l0.1,0.1h0l0-0.3l0.3-0.2h0.2l1.2,0.5l0.1,0.2v0.1l0.1-0.1l0.3,0.1l0.1,0l0,0
	l0.1,0l-0.1,0.3l-0.1,0l0.1,0.3l0.1-0.1l0.5,0.3l0,0.1v0l0.2,0.1v0l0.1-0.1l0.3,0.1l0,0.1l-0.1,0.2l-0.1,0.2v0.4h0.1l0.4,0.2l0,0.1
	l0,0l0.1,0.1l0.3,0.6l0,0.2h0.2l-0.1,0.1l-0.2,0.4l0.2,0l0.1,0l0.1,0l0,0.8l0,0.2l0.5,0.8l0,0.1h0.1l0,0.2v0.3l-0.1,0.1l0.1,0.2
	l0.1,0l0.4,0.7l0,0.2l-0.1,0h-0.1l0,0.4l0.1,0.1l1.1,2.1l-0.1,0.2l0,0.1l0.1,0.6l0,0.1l0,0.2l0.1,0.3l-0.1,0.1v0.1l0.2,0.2l0.1,0
	l0.4,0.2l-0.1,0.4l-0.1,1.4l0.4,0.2v0.3l0,0.1l0.3,0.2l0.1,0.1l0.2,0.1l0.2-0.1l0.1,0.1l0.2,0.1h0.1l0.8-0.2h0.2l0.8,0.2l-0.1,0.3
	h0.1l0.4,0.1h0l0.3,0.2l0.7,0.2l0.2-0.3h0.2l0.2,0.2l0.6,0.8l0.1,0l0.8,0.9l0.2,0.1l0.1,0.1l0.4,0l0.2,0l0.2,0.2h0.2l0.3,0l0.4,2.2
	v0.2l-0.4,0.8l0,0.1l0,0l0.1,0.1l1.1,1.4l1-0.2l1,0.3l0.2,0l0.2,0l0.1,0V390l0,0l0.1,0h0l1-0.1h0l0.4,0l0-0.1l0.7-0.8v0l1.1-0.5
	l0.5,0l0.4-0.1l0.6-0.5l0.1-0.1l0.4-0.1h0l0.5-0.3h0l0.9-0.2l0.1,0l0.6,0.2l-0.1,0.3l-0.2,0.6l0,0l0,0.1l-0.2,0.4l0,0.1l0,0l0.1,0.2
	l0.1,0v0.1l0,0l0,0.2l0.1,0.1l0.1,0.1l-0.1,0.3l0,0.1l-0.1,0.1l-0.1,0.2l-0.6,0.5h-0.3l-0.4,0.5l-0.1,0.1l0.1,0.3l0.1,0.2l-0.4,0.7
	l-0.1,0.2l-0.4,2.2l0,0.1l-0.1,0.4l-0.1,0.1v0l-0.1,0.1l-1.1,1.7l0.1,0l-0.1,0.3l0.1,0l-1.6,2.5l-0.5-1.1l-1.8,0.4l-2.9,1.6l0.9,3.1
	l-0.4,4.2l-1.6,1.5l0,0L830,410l-0.2,0l-0.5-0.7v-0.2l-1.5,1.5L825,412l-1.5,2.4l-3.7-1.2h0l-0.4,0.1l0,0.1l0,0l-0.2,0.5l-0.1,0.1
	l-0.1,0.3l-1,1.2l-0.1,0l-0.1,0.3l0,0.1h-0.1l-0.1,0.1l-0.8,0.4l-0.1,0.1h-0.3l-0.4,0.3l0,0.1l-0.8,0.2l-0.4,0.3l-1.7,1.5l-0.1,0.2
	l-0.2,0.1v0l0,0l-1.8,0.2l-5.5,2.8l-0.5-2.6l2.2-2.4l-1.5-1.3l-2.2,0l-1.4,2.2l-2.9,1.5l-1.3,2.3h-3.4l-0.3,1.8l1,1.5l2.7,0.6l0,2.3
	l1.2,1.1l3.8-2.7l2.3,1.4l3.2,0.1l-2.9,2.3l-1.7,0.5l-0.8,1.5l-2.9,1.8l-1.3,2.2l1.3,1.5l1.7,0.7l1.6,3.5l0.3,2l1.1,1.3l-3,0.8
	l1.4-0.1l3.1,2.7l-1.5,2.5l2.2,1.5l-1,2.4l-0.2,2.5l-3,2.3l-0.2,1.2l-2.6,1.8l0.4,1.9l-0.9,2.3l-2.1,2.2l-0.5-0.6l-1.8,2.4l-1.3,0.3
	l-2.8,2.5l-2,1l-0.9-0.5l-2.8,0.8l-0.1,0.4l0.3,0.4l-1-0.3l0.3-0.4l-1.3,1.2l-2.7,1.1l-1.5-0.2l-1,0.9l-1.7,0l-2,1.2l0.6,2l-1.7,0.6
	l-0.7-2.1l0-1.7l-4.4-0.1l-1.9-0.1l-1.9-1.2l-0.3-1.4l0.7-1l-2.6-0.3l-1.5-1.4l-1.6,1.7l-2.1,0.9l-1.8-0.9l-0.8,1.1l-1.5-1l-0.9,1.1
	l-1.6,0.5l0.6,3.1l-1.6-0.1l-0.2-1l-2.7,0.2l-0.5-1.7l-2.2-0.3l0.9-2.8l-1.7-0.3l-0.2-2.8l-2,0.1l-1.5-2l0.6-1.2l2.5-2.4l0.2-2.1
	l-0.2-2.9l-2.7-2.8l-0.6-0.1l0,0l-0.4,0.9l-1.9-1.2l-1.4-2.3l-2.4,0.9l-1.7-0.7l-2.1,1.7l-3.4,1.9l-0.6,1.1l-2.5-0.1v0l0-0.1
	l-0.6-0.7l-2.1,0.2l-2.7-0.4l-1.9,2.6l-0.2-2.1l-2,0.4l0,0l-2.6,0.1l-1.2-0.9l-2,0.6l-1.1-1.1l-1.4-0.3l-4.2-2.6l-0.8-1.2l-3.1-1.6
	l-0.2-0.9l-3,0.5l-2.3-1.2l-0.9-1.2l-3-1.1l0.3-3.5l1.6-1l-2.1-3.2l0.2-0.2l0.8-2l-2.3-1.4l-1.4-2.4l-2.5-0.7l-1.7-0.6l-0.6-2.6
	l-1.5-1.2l-2.3-0.2l0.9-0.7l0.3-1.9l-0.9-2.3l-1.4-0.7L673.3,421.3z M746,429.1l-0.5,1.7l2.6,0.6l-1.2-2.2L746,429.1z M812.5,365.5
	L812.5,365.5L812.5,365.5L812.5,365.5z M820.2,374.9l-0.1-0.1l0-0.1l0.2,0L820.2,374.9L820.2,374.9z M830.2,410.2l0.1,0.1h0
	L830.2,410.2z M830.3,410.3l0.1,0.2v0L830.3,410.3L830.3,410.3z M813.1,419.4L813.1,419.4L813.1,419.4L813.1,419.4z M770.4,487.8
	l-0.5-2.5l2.4-1.5l3.2-0.9l0.7,0.4l-1.1,3.6l-2.3,1.7L770.4,487.8z"
              />

              <motion.polygon
                style={{ y: el3, x: el3x, scale: el3scale }}
                className="WMst3"
                points="593.9,420.7 595,422.2 595.6,422.7 597.6,423.5 598.7,423.4 601.9,420.9 601.9,420.9 603.7,421.6 
	602.8,423.5 605.2,424.9 605.5,427.3 606.3,428.4 608.8,428.6 610.2,430.3 612.9,431.3 617.5,430.5 619.3,430.6 619.2,428.7 
	621.1,428.4 623.2,426.1 625.7,426.2 628.1,425.5 628.8,426.7 631.4,427.7 634,428.1 634.6,429.4 635.9,429.8 636.8,431.2 
	639,431.1 639.1,433.5 639.2,433.6 639.3,434.7 638.5,437.9 637.2,439.8 637.4,442.9 638.2,445.9 638.2,448.2 639.3,448.4 
	639.5,448.4 640.7,448.8 640.8,450.3 638.2,453.4 640.9,457.3 643.5,458.4 643.4,459.1 643.5,461.6 645,462 644.6,463.4 
	642.5,463.6 641,464.6 640.3,467.9 639.7,468.2 636.7,467.2 633.3,467.2 628.4,466 627.5,462.3 627,461.8 624.1,462.2 621.4,463.9 
	620.1,463.2 618.5,463.2 615.7,461.4 613.7,459.6 612.1,459.5 610.1,454.6 608.7,453.2 606.1,452.5 604.4,453.2 604.3,453.1 
	604.2,453.1 603.5,451.9 603.5,451.9 602,449.8 602.2,447.6 601.1,445.1 597.5,443.4 597.7,442.5 595.6,440.1 595.7,438.5 
	597,436.5 597.1,434.8 594,430.7 593.9,429.4 593.4,427.4 592.3,426.8 592.5,425.1 591.8,421.6 593.9,420.7 593.9,420.7 "
              />

              <motion.path
                style={{ y: el4 }}
                className="WMst4"
                d="M450.1,358l0.4-0.6l3.3-0.6l1.3,2.5l0.2,1.8l-2.1,0.9l-2-1.5l-1,1.4l-0.1-0.1h0l-1.9-1.2l-0.1-0.1l0.8-0.5
	l0.1,0l1.1-1.6l0-0.1l0-0.2L450.1,358z M455,346.8l-0.5-3.3l2.2-4l1.5,0.9l1.3-0.8l2.2,1.5l-0.2,3l3.6,0.2l0.6,1.2l-2.1,4.5
	l-0.3,2.5l2.8,2.3l1.2,4.6l1.7,0.6l1.4,1.7l1.2,4.7l3.7,1.7l-0.3,2.8l-1.6,1.3l-0.3,2l-1.8,2.6l-2.8,0l-1.7-0.8l-1.8,1.4l-3.9-0.5
	l-0.4,2.1l-2.8-0.8l-1.4,1.9l-0.8-0.7l3.4-4.6l1.1-2l-3,0.2l-0.5-1.1l2.5-1.8l0.8-1.3l0.2-3.6l1.5-0.1l1.3-1.8l-2.2-3.6l-3.7-1.9
	l1-2.8l-0.7-2.2l-1.2,0.8l-1.3-6.4L455,346.8z"
              />

              <motion.g style={{ opacity: opacity }}>
                <polygon
                  className="WMst5"
                  points="282.2,505.5 282.5,505.8 282,505.2 	"
                />
                <polygon
                  className="WMst5"
                  points="496.6,392.6 496.9,392.6 496.7,391.8 	"
                />
                <polygon
                  className="WMst5"
                  points="457.3,362.2 458.2,361.7 458.4,360.6 	"
                />
                <path
                  className="WMst5"
                  d="M859,546.3l4.2,1.7l2.7,0.6l1.4,1l1.5,0.2l3.5,2.6l-0.1,1.7l1.9,0.4l3.1,1.2l0.8,1.6l-2.5,0.2l0.7,2.1l2.6,1.7
		l0.3,1.4l1,1.4l1.9-0.2l-0.1,1.4l1.7,1.4l2.1,0.8l-1.1,1.1l-1.2-1l-5.6-0.7l-1.2-1.7l-2-1.4l-1.4-2.6l-1.9-0.4l-3.2-1.7l-0.2,1.2
		l-1.3,1.2l-1.6,0.6l0.7,1.6l-1.9,0.8l-1.1-0.7l-3.3,0.1L859,546.3z M898.7,555.8l1.4,1.2l-0.9,1l-2.4-2.6l0.9-1.1L898.7,555.8z
		 M885,556.3l-2.2,0.1l-3.4-1.5l0.1-0.9l2.2,0.4l4.6-0.2l1.2-1.6l0.4-1.9l2.5,0.3l-0.9,3.1l-2.5,1.4L885,556.3z"
                />
                <polygon
                  className="WMst5"
                  points="464.4,436.4 465.7,437.6 466.2,443.4 467.7,444.9 467.3,446.2 462.6,446.2 462.7,447.3 460.4,447.8 
		460.3,450.9 458.6,451.3 454.5,454.2 450.8,454.5 446.6,457 446.6,460.3 446.2,460.3 446.3,462.4 444.4,462.4 443.2,463.2 
		441.3,462.6 439.4,463.2 438.3,465.4 437.4,466.2 437.3,467.6 434.8,470.2 434.5,471.5 432.5,472.2 431.4,476.1 430.4,478.5 
		429,479.3 423.5,479.3 424.1,476.9 425,476.4 427,471.7 429.5,469.3 429.6,467.5 430.6,464.8 433.1,463.1 434.1,460.4 434.9,459.4 
		438.7,458.3 442.3,455.1 443.8,452.8 443.2,451 443.3,448.5 444.9,446 444.9,444.8 447,442.5 451.7,439.9 453.2,437.3 454.1,434 
		455.6,433.6 456.5,435.3 458.6,436.1 460.2,435.7 	"
                />
                <polygon
                  className="WMst5"
                  points="494.2,526 494.2,526 494.2,525.9 494.2,525.8 494.2,525.8 494.8,523.2 497.4,520.5 499.6,519.5 
		501.1,521.3 502.2,521 503.2,519.7 504.2,516 505.7,515.1 505.9,513.4 506.9,512.8 508.3,508.9 510.8,507.4 510.9,505.6 
		509.9,505.1 509.8,505 509.3,503 509.9,503 510.5,503.4 510.6,503.5 510.6,503.6 511.4,504.4 511.4,504.5 511.5,505.6 511.5,505.6 
		511.6,505.7 511.8,505.7 512,506.1 511.9,506.2 512,506.5 512.1,506.6 512.1,506.8 512,506.8 512,506.9 512,506.9 512,507.1 
		512.1,507.2 512.2,507.3 512.2,507.4 512,507.6 512,507.7 512,509.4 512,509.5 512.2,509.8 512.2,510 513.5,511.5 513.6,511.6 
		509.6,511.6 509,512.7 510.4,514.3 512.1,515.4 513.4,518.1 513.1,518.5 512.4,519.3 510.8,523 510.5,524.7 512,528.2 514.7,530.9 
		515.1,533.1 515.1,533.1 514.9,533.1 514.8,533.1 514.9,534 514.9,534 512,533.7 510.7,533.1 507.1,533.2 506.8,532.9 502.6,532.8 
		501.8,533.2 497.5,532.8 497.9,530.7 496.9,528.8 495.2,527.9 	"
                />
                <polygon
                  className="WMst5"
                  points="497.4,536.3 497.4,536.3 497.5,536.4 501.7,536.4 501.8,533.2 502.6,532.8 506.8,532.9 507.1,533.2 
		507,535.5 509.7,535.3 510.4,536.5 508.7,538.5 508.8,539.8 510.5,540.8 510.2,544.3 509.3,546 504.9,545.5 502.8,545.8 502.3,547 
		503.4,548.2 501.1,550 500.6,549 497.1,545.8 496,544.3 494.8,541.5 496.1,540.2 496.2,538.2 	"
                />
                <polygon
                  className="WMst5"
                  points="585.9,528.3 588.5,527.5 589.3,526.5 591.2,525.7 594.4,525.7 595.6,524 602.7,517.2 599.9,517.2 
		591.9,514.5 589.8,512.7 588.2,509.9 588.8,508.9 589.7,507.6 592,510.1 594.3,510.5 596.7,509.2 598.4,509.8 601.1,508.4 
		603.1,508.5 604.2,508 606.6,507.9 609,507.2 610.4,506.1 611.8,506.5 611.2,508.1 611.5,510 610.7,510.8 610.5,513.3 608.6,516.6 
		607.7,517.4 605.3,522.8 602.6,526.9 597.2,532.5 593.4,534.8 590.4,537.4 586.4,541.5 585,543.7 583.4,541.4 583.4,531.4 	"
                />
                <path
                  className="WMst5"
                  d="M297.9,601.7l1-3.5l0-1.5l1.5-2.7l4.9-1h2.5l2.5,1.6l0,1v0l0,0.2l0.1,0l0.5,1.2l0.1,0l0.1,0.7l0.1,0.1
		l-0.2,1.1l0.1,0l-0.1,1.1l0.1,0.1l-0.1,0.2l0,0.1l0,0.4l-0.1,0.1v0.1l1.7,0.7l4.1,0.1l1.2,4.9l2.1-0.4l1,0.7l0.1,0.1l0,0.7
		l-0.1,0.4l-0.1,0.1l-0.7,2.9v0.5l0,0.1l-0.6,3.2l-0.1,0l-0.9,0.9h-0.2l-0.6,0.2l-0.1,0.2l-0.2,0.4l-0.1,0.3l-0.4,0.3l-1.2-0.9
		l-2.3,0.9l-0.1,0.1l-0.3,0l-0.1,0l-0.9-0.2l0,0.1H312l-0.1-0.1v0h0l0,0l0,0l-0.5-0.2l-0.1,0v0l-0.6-0.2l-0.4,0l-0.5,0v0l0,0v-0.1
		l-0.8,0.1l0.2-0.9l0.1-0.1l0-0.1v0l0.5-0.2l0-0.1l0-0.1l0.1-0.1l0.1-0.6l0-0.1l0.2-1l0-0.1l1-1.3l0.1-0.1l0.2-0.3h0.1l0.1,0.1
		l0-0.1l0.1-0.3l0-0.2l-0.8-1.1l-3.5-1.4l-2.5-1.8l-2.6-0.6l-3.3-3.3v-0.1l-0.1-0.1l-0.2-0.4l0,0l-0.1-0.1l-0.1-0.1h0l0,0h0
		l-0.2-0.1l0,0l-0.2-0.1l0,0l-0.1-0.1H298l0,0L297.9,601.7z M310.8,600.8L310.8,600.8L310.8,600.8L310.8,600.8z M314.2,617.6v0.1
		l0,0h0l0,0l0,0l-0.1,0.1v0l0,0v-0.1l-0.1-0.1v0v0.1l0,0l0,0v0l0,0l-0.1,0.1v0l0,0v0l-0.1,0h-0.1v0v0l0,0l0,0l0,0l0,0v-0.1l0,0h-0.1
		v0l-0.1-0.1l-0.1,0h0l-0.1-0.1h0l0,0l0.1,0h-0.1l0.1-0.1l0.1,0.1L314.2,617.6L314.2,617.6z"
                />
                <polygon
                  className="WMst5"
                  points="815.2,565.2 814.8,563.8 815.5,562.8 819.2,562.5 819,563.8 	"
                />
                <polygon
                  className="WMst5"
                  points="569.4,433.6 570.1,434 571.5,430.5 573.6,431.2 575.3,430.4 579.3,430.9 582.8,429.5 587.2,429.5 
		585.7,431.3 584.2,432.1 584.5,434.5 584.1,437.3 584,437.5 583.4,438.7 577.4,442.1 572,445.6 569,444.1 569,442.2 569.9,440.6 
		571.4,439.4 570.5,437.7 569.6,437.9 	"
                />
                <polygon
                  className="WMst5"
                  points="523.8,412.6 523.8,412.4 523.8,412.3 524.6,409.8 525.8,410 527.2,412.6 527.3,415.5 527.6,416.1 
		528.3,416.2 528.3,416.5 528.2,417.7 526.3,420.4 525.6,420.5 524.1,418.1 524.3,416.1 	"
                />
                <path
                  className="WMst5"
                  d="M816.1,506.3l-1,0.4l-1.8-1.3l-0.3-1l2.4,0L816.1,506.3z M803.6,501.9l1.8,1.1v1.4l-1.7,0.3l-0.7-1.9
		L803.6,501.9z M805.9,499.9l1.4,0.8l1.3-1.2l2,1.3l-0.6,1.3l-1.5,0.1l-2.5-1.6l-2,1l-1.2-1.7l1-1.4l-2.4-0.2l-0.9-4.2l1.9-2l-0.3-2
		l0.6-2.3l0.8-0.5l2.8,1.1l1.8,3.2L807,494l-1.5,1l-0.5,1.6l1,1.8V499.9z M807.2,509.9l-0.2-3l2.8,1.5l-1.5,1.3L807.2,509.9z
		 M808.6,513.4l-0.9-1.3l1.3-0.7l-0.2-1.2l1.1-1.3l1.1,0.6l-1.3,3.2L808.6,513.4z M796.8,513.7l-0.8-0.2l2.4-3l0.6,1L796.8,513.7z
		 M816.3,520l0.6,2.5l-1.1,1.5l-3.5-2.3l-0.3-1.5l0.8-1.3l-1.6-1.2l-1.9,1l-1-0.9l2.1-2.6l2.3,1.4l1.4-0.8l0.2-1.4l2,0.1l1.2-1.4
		l1,1.8l0.1,2.6l0.7,1.7l-0.9,1l-1.2-1.2L816.3,520z"
                />
                <polygon
                  className="WMst5"
                  points="300.9,494.1 301.4,494.1 301.9,494.1 301.1,493.3 	"
                />
                <path
                  className="WMst5"
                  d="M277.7,550.8l1.3-7.3h0.1l-0.1,0l0-0.2l0.1-0.2v-0.3l-0.1-0.1l-0.5-2l-1.2-0.9l0-2.1l2.5-0.8l0,0v0l-0.1,0
		l-0.2-0.4l0,0l-0.1,0h0l0,0h-0.3l-0.1,0l-0.5-0.1l0,0l-0.1,0l0,0l-0.3,0H278v-1.7l4.6,0l2.1-1.4l1.5,2.7l2,1.3l5.6-2.5l0.2-0.9
		l1.6-1.3l-1.5-0.7l-0.7-1.1l0.7-2.1l5.6-0.7l1.7-1.2l0.9,0.1l0.7-1.8l0,0l2,0.3l-0.4,1.6l1.4,0.4l0.4,1.2l-1,1l-0.3,1.8l0.8,3.2
		l2.4,1.6l1.4-1.2l2.1-0.3l0.6-0.8l2.3,0.1l1.4-1.6l1.6,0.3l1.1-0.5l1.1,0.7l1.3,0.6l1-0.7l2.1,0.5l1.1-1l1.5-3.1l0,0l0.8-1l1.7,0.4
		l0.1,2.1l1.2,3l1.9,0.9l0.2,1.4l-2.5,2.8l0.4,0.7l-1.5,1.1l-0.2,1.4l-2.1,1.1l-6.9,1.9l-2.2-0.1l-0.5-0.5l0.4,1.1l1.4-0.4l1.4,1
		l1.6-1.6l4.2-1.1l0.8,0.1l1.9-1l0.4-0.9l2.2-2.2l2,0.4l3.2-0.1l1.1,1.2l4.9,1.3l1.5-0.1l3.4,2.4l-1,0.9l1.1,1.8l2.8-1.7l3.3,1.3
		l2.6,0.2l3.5-0.1l4.2,2.4l3.6,3.4l1.5,0.5l1.8-0.2l1.5,0.5l1.6,4.8l0,1.8l-0.9,3.6l-1.7,2.2l-0.7,1.1l-3.1,2.8l-1.6,3.2l-1.4,1.8
		l-1.7,0.7l-0.5,4.7l0.6,3l-1,3.7l0.2,1.5l-1.6,2.4l-0.1,3l-1.1,1.1l-0.7,2.1l-0.9,0.6l-0.9,1.9l0.2,1.3l-1.8,0.8l-0.7,1.6l-4.8,0.8
		l-0.7-0.4l-2.3,0.5l-2,1.6l-2.7,1l-4.5,3.2l-1.4,2.7l-0.4,2.4l0.3,3.7l-0.5,2l-2.6,2.4l-3,5.8l0.1-2.5l-1.8,0.9l-0.2,1.4l-2.1,2.1
		l0.4,1.4l-1.4,3l-2.1,2.2L323,637l1-3.1l-0.5-0.2l0,0l-1.1-1.6l-2.3-2l-1.8-0.6l-0.9-1.4l-1.2-0.1l-2.2-2.2l-0.7,0v0.1l-1.4,0.2
		l0,0l1-1.3l0.3-0.1l1.1-1.3l0.1-0.4l0.1-0.1l0.1-0.2h0l1.5-1.6v-0.1l0.2-0.3h0.1v-0.1l0-0.1l0-0.1h0.4l-0.1-0.4l0.1,0l0.2-0.2
		l0-0.1l0.4-0.1l0.1-0.1l0.2-0.3l0.1,0l0.1-0.1l0.1,0l0.3-0.1l0.1,0l0-0.1l0.3-0.1l-0.1-0.1h0.1l0,0l0.2-0.1l0.1-0.1V618l0.2,0l0,0
		l0-0.1l0.4,0l0.1-0.1l0.5-0.3l0.1,0l0,0l0,0l0.2,0.1v-0.1l1.3-0.8l0.1,0.1l0.6-2.9l-1.1-1.9l-0.1,0h-0.1l-0.1-0.1l-0.2,0l-0.1,0.1
		l0,0l0,0.1l-0.1-0.1h0l-0.2,0.1l0,0.1l-0.3,0h-0.1l-0.1-0.1v-0.5l0.9-1.7l-0.1-1.2l0.1-0.5l0-0.7l-0.1-0.1l-1-0.7l-2.1,0.4
		l-1.2-4.9l-4.1-0.1l-1.7-0.7v0l0.1-0.1l0-0.4l0-0.1l0.1-0.2l-0.1-0.1l0.1-1.1l-0.1,0l0.2-1.1l-0.1-0.1l-0.1-0.7l-0.1,0l-0.5-1.2
		l-0.1,0l0-0.2l0.1-0.1l0-1.1l1.2-2.1v-0.1l0.3-1.9l0-0.1l-0.3-1.5l-0.1-0.3l0-0.1l0,0l-0.1-0.2v0l0,0l-0.4-0.3l-0.5-0.1l0-0.1
		l-0.9-1.4l0.4-1.9h-5.1l-0.3-4.7l-0.4-1.8l0,0l-0.1-0.2h-0.1l0-0.1h0l0.1-0.1l-0.1-0.1h-0.1l-0.1-0.1l-0.1,0l-0.2-0.1h0v0l-1.2-0.6
		l-1.9,0l-1-1.2l-1.7-0.3l-1-1.1l-2.9-0.4l-0.2,0l-1.9-1.3l0,0h-0.2l-0.1,0l0,0v-0.1l-0.2-0.7l-0.1,0l0,0.1l-0.1-0.4V571l0-0.1
		l-0.2-0.1l-0.2-2.4l0-0.2l-0.1-0.1l0-0.1v0l0.3-1.7l0,0l-1.3-0.3l-2.3,0.4l-3,2.3l-0.9-0.1l-1.4,1.2l-1.7-0.4v0l-0.3,0v0h-0.3l0,0
		h-0.5l-2.9,0.1l0.1-4h0.1l0,0l0-0.1l0,0l0.1-0.1l0,0l-1.9,1.3l-2.7,0.1l-0.5-1.4l-2.3-0.2l0.7-1.2l-1.6-1.7l-1.2-2.3l0.7-1.9
		l1.6-0.9l-0.3-1.3l1-2.5l2.7-1.7l4.5-0.6l0,0.1l0.2,0.1l0.1,0l0.1-0.1l0.1-0.1l0.1,0h0.1l0.1,0.1l-0.1,0l0.1,0.2l0.1-0.1
		L277.7,550.8L277.7,550.8z M306.4,542.5l-2-0.1l1,1.5L306.4,542.5z M318.8,618.5L318.8,618.5v-0.2V618.5L318.8,618.5L318.8,618.5z
		 M320.8,608.2L320.8,608.2L320.8,608.2L320.8,608.2z M290.2,568.1L290.2,568.1L290.2,568.1L290.2,568.1z"
                />
                <path
                  className="WMst5"
                  d="M562.1,577.9l1.3,1.4l1.8-0.3l0.7,2.5l-0.9,1.8l0.5,1l2,1.7l0.4-1.8l1.2-0.4l0.2-1.7l-0.1-1.1l0.1-0.7v-0.4
		l-2.8-3.4l-0.5-3.6l0.7-1.8l4.5,0.4l0.1,0.1l2.8-0.4l1-1l0.1,0h0.3l0.2,0l0.4,0.3l0.1,0l0.1,0.1h0.1l0.1-0.1l0-0.1l0,0l0.1,0
		l0.2-0.2h0.1l0.2-0.1l0.1-0.1l0.1-0.1l0.9-0.1h0.2l0.4-0.3l0.2-0.1l0.2-0.1h0l0.1-0.1l0,0l0.2,0l0.9-0.4l0.1-0.1l0.1-0.1l0.1,0
		l0.8-0.6l0.6,0.9l-0.7,1.4l0.5,1.9l-0.3,1.1l0.5,4.6l0.5,1.3l-0.4,2.2l-2.1,3.2l-7.1,3.4l-1.2,1l-1.6,2.6l-1.2,0.2l-2.7,2.6
		l-0.6,2.1l1.3,1.1l-0.3,0.9l1.4,2.6l0.1,2.4l-0.7,2.2l0.4,1.4l-1,1.3l-5.8,2.4l-1.3,1.7l1,1.1l0,1.6h-1.5l-0.5-0.1l-0.4-2.7
		l0.1-2.4l-0.1-2.6l-1.2-2.5l-0.7-3.1l3-3.2h0.2l0-2l1-1l-0.1-1.8l0.7-3.8l-0.1-2.9l-0.7-1.8l-2.5-0.8l-1.7-1.1l-2.4,0v-1.1l0-0.1
		l-0.1,0l-0.1-0.1v-0.1l-0.4-1.4L562.1,577.9z M578.6,569.9L578.6,569.9L578.6,569.9L578.6,569.9z M579.2,569.5L579.2,569.5
		L579.2,569.5L579.2,569.5z"
                />
                <path
                  className="WMst5"
                  d="M533,403.8l0.5,1l-0.1,0.2l0,0l0.1,0.2l0.1,0l0.6,0.1l0,0l0.1,0l0.2-0.1h0.7l0.1,0l0.2,0.1h0.2l0.3,0l0.2,0.1
		l1.4,0.3l0.1-0.1l0.1-0.1l2.3,0.2l0.1,0.1h0.8l0.1-0.1l0.3-0.1l0.2-0.2l0.2-0.1l0.6-0.7l0.3-0.1l0.8-0.2l0.7-0.1l0.3-0.2l0.1,0
		l0.2,0l4.5,1.5l-0.3,1.4l-1.4,0.7l-0.6,2.8l0.8,1.6l-2.1-0.4l-1.8,0.4l-0.7,1l-0.6,1.3l-1.9,0.3l-2.5-1.1l-4.4,0.8l-0.2-2.5
		l-1.4-1.1l1.8-3.3l-1.8-2.3L533,403.8L533,403.8z M536,405.4L536,405.4L536,405.4L536,405.4z"
                />
                <polygon
                  className="WMst5"
                  points="299.9,491.9 300.5,491.8 300,491.6 	"
                />
                <polygon
                  className="WMst5"
                  points="611.8,469.9 610.5,469.2 610.3,466.9 611.7,464.9 612.8,465.7 612.3,466.9 612.8,468.4 	"
                />
                <polygon
                  className="WMst5"
                  points="271.1,478.1 271.6,477.9 271.2,477.8 	"
                />
                <polygon
                  className="WMst5"
                  points="522.3,397.2 522.5,397.2 524.4,396.1 525.8,396.2 525.9,396.2 526.3,396.3 527.8,397.8 529.3,401.4 
		529.4,401.6 531.1,402.3 531.2,402.4 531.2,402.5 531.5,402.8 531.6,402.8 531.6,402.7 531.7,402.6 531.8,402.4 532.4,401.9 
		532.5,402 532.7,402.2 533,402.3 533,402.6 532.9,402.5 532.7,402.5 532.6,402.7 532.4,402.8 532.4,402.9 532.5,403.2 532.9,403.7 
		532.9,403.8 532.1,405.3 533.9,407.7 532.1,411 530,411.2 529.4,409.4 527.9,407.4 527,408.5 527,408.5 527,408.5 526.5,409 
		525.9,408.5 523.4,406.4 523.8,404.7 523.9,404.8 524.4,404.3 524.3,404.3 523.8,403.7 523.7,403.7 523.4,402.4 523.4,402.3 
		523.7,401.8 523.7,401.7 523.8,401.4 523.8,401.3 522.9,401.3 522.9,399.4 522.8,399.4 522.8,399.2 522.9,399.1 522.9,398.8 
		523.1,398.8 523.1,398.8 523.1,398.7 522.9,398.7 522.6,398.7 522.5,398.5 522.5,398.5 522.5,398.5 522.6,398.4 522.6,398.4 
		522.6,398.3 522.6,398.3 522.6,398.3 522.6,398.3 522.7,398.2 522.7,398.2 522.7,398.2 522.7,398.1 522.7,398.1 522.7,398.1 
		522.7,398.1 522.6,398.1 522.5,397.9 522.5,397.8 522.5,397.7 522.5,397.7 522.5,397.7 522.4,397.6 522.4,397.4 522.4,397.4 
		522.4,397.4 522.3,397.3 522.3,397.2 	"
                />
                <polygon
                  className="WMst5"
                  points="256.2,489.5 258.6,489.1 258.6,487.9 255.9,487.6 	"
                />
                <polygon
                  className="WMst5"
                  points="216.3,498.9 216.4,496.9 217.8,494.6 221.2,494.6 221.2,494 221.3,494 221.4,493.8 221.4,493.8 
		220.8,493.4 220.8,493.4 220.6,493 219.8,492.3 219.8,492.3 219.7,489.6 224.8,489.6 224.7,495.1 225.5,495.1 227.3,495.6 
		224.8,497.4 224.2,499.3 223.7,499.6 223.8,499.8 222.1,501.2 219.3,500.7 	"
                />
                <polygon
                  className="WMst5"
                  points="446,412.6 446.1,412.6 446.2,412.4 447.6,411.7 450,412.8 452.4,412.3 452.3,414.9 452.2,414.9 
		452.2,414.9 451.8,415.4 451.8,415.5 451.8,418.2 450.5,424.3 450.5,424.4 450.3,424.6 450.3,424.9 450.9,425.9 449.9,427.7 
		449.9,427.7 450,429.2 448.7,429.9 446.7,429.4 445.9,424.7 444.3,423.7 444.5,421.7 445.5,420.9 446.6,416 	"
                />
                <path
                  className="WMst5"
                  d="M543.1,413.2l0.7-1l1.8-0.4l2.1,0.4l0.5,3.3l-2,0.4l-1.8,1.4l-2.1-0.5L543.1,413.2z M585,413.9l2.7,0.3
		l0.9-0.6l1.8,1.7l0.7,1.7l-0.1,0.3l0,1.7l1.8,0.3l1.2,1.1l0.1,0.1l0,0v0.1h0l-2.1,0.9l0.7,3.5l-0.2,1.7l1.1,0.6l0.4,2l-1.3,0.6
		l-3.2-1.4l-2.2,0.9l-4.4-0.1l-3.5,1.5l-4-0.5l-1.6,0.8l-2.1-0.7l-1.4,3.5l-0.7-0.4l-0.4-1.3l-3.1-1.7l-1.9,2l-3.2,0.7l-2.2-1.8
		l-2.8-1.1l-1.1,0.1l-0.5,2.2l-2,0.3l-3.4-2.6l-2.7-0.7l-0.8-0.9l0.2-2.2l-1.8-0.4l0.4-1.9l-0.3-2.2l-1.5-0.7l0.3-1.8l1.6-1.5
		l3.3,0.2l3.6-1.6l-0.2-1.5l5.7,0.4l2.8-2.3l2.9-1.1l3.8,0.3l1.5,0.8l2.2,0.1l4,2.4l2.3,0.4l2.9-0.7l2.1,0.7L585,413.9z
		 M593.9,420.7L593.9,420.7L593.9,420.7L593.9,420.7z"
                />
                <polygon
                  className="WMst5"
                  points="594.8,575 595,574.3 594.6,574.3 	"
                />
                <path
                  className="WMst5"
                  d="M504.1,555l0.7-1.9l1.8-1.1v-0.1l0.9,0.8l2.7-1.8l0.3,1.6l0.1,0.1l0.1,0.1l0.1,0l0.6-0.4l0-0.1l0.9-1.1
		l0.2-0.1l0.1-0.1l0.9-0.7l0.3-0.1l0.9-1.2l0.1-0.2l0.2-0.4l0-0.3v0l0-2.6l0.8-1.1h0l0.9-1.6l0.1-0.1l1.8-1.3l0,0l0.5-0.4l0.6-0.8
		l0.1-0.1l-0.1,0.1l-0.4,0.1l-0.1-0.5l0-0.2l0.1-0.1l0-0.1l0.1-0.2l0.1-0.4l0.1-0.1l0.3-0.3l0.1-0.5l-0.1-0.1l-0.1-0.2v-0.3l0-0.3
		l-0.1-0.2v0l0-0.2l0.1-0.2l0.1,0v0l0.1-0.1l0-0.1l0.1-0.5l0.1-0.2l0-0.1l0.1-0.5v-0.1l0.1-1.4l0-0.1l0.1-0.2l0.2-0.2l0-0.2l0.1-0.1
		l0.1-0.1l0.2-0.3l0.1-0.1l0.1-0.2v0l0.1-0.2l0.1-0.3l0.1-0.1V531l0.1-0.2l0.1-0.1l0.1-0.1v-1l-0.1-0.6v-0.2l0.1-0.3l0.1,0l0-0.4
		l0-0.1l0-0.1l-0.1-0.1l0.6-0.9l0-0.1l0.7-0.9l0-0.1l0-0.1l0.2-0.1l0.2-0.1l0.2-0.2l0.8-0.3l0.4,0l0.2,0.1l0.1,0l0.2,0.3l0.1,0h0
		l0.2,0l0.2,0.2l0.2,0l0.2,0.2l0.1,0.1l0.2,0.1l0.1,0.2l0.1,0.2l0.1,0.1l0.3,0.3h0.6l0,0l0.7,0.1l0.2,0.2l0.1,0l0.2,0l0.1-0.1h0.1
		l0.2,0.2h0.6l0.2-0.1l0.4,0.1l0.1,0.1l0.4,0.1l1.1,0.2l0.3-0.4l0-0.1l0.1-0.1l0.1-0.1l0-0.1l0.2-0.2l0.1-0.1l0.5-0.8l1.5,0.6
		l2.3-0.9l2.8-0.2l0.4-0.9l3,0.8l1.7-0.4l0.9,0.5l2.6,2l1.1-0.7l1.2,0.6l1.2-0.9l1.5,1.9l1.8,1.2v0l-0.3,2.9l1.5,0.7l-2.1,1.8
		l-0.1,0.9l-0.7,0.6l-0.1,0.1l-0.5,0.3l0,0l-0.8,2.5l-0.1,1L552,543l-1,0.8l-1,2.1l0.4,0.7l0.1,0.1l0.5,1.2v0l0,0.5l-0.4,2.6
		l0.1,2.1l0.9,1.5l-0.6,1.3l1.4,2.5l1.2,0.8l1.1,2.8l-4.5,0.5l-1.4,1.5l0.4,1.4l0.2,1.8l-0.1,0v0l-0.4,3.1l0,0.1v1.2l0,0.1l0.8,0.5
		l0.1,0.1l1,1.1l0,0l0.4,0l0.1,0.1l1.4-0.7l-0.6,2.9l-1.6,0.6l-1.5-2.5l-4.3-1.5l-2.5-0.1l-1.8-0.9l0.1-1.2l-2.5,0.8l-1.2-1.6
		l-2.2,0.6l-1.9-0.2l-0.9-3.1l-1.1-1.4l0.2-3.4l0,0l-0.3-0.4l0,0l0-0.5v-0.1l0-1.3l-3.4-0.2l-0.7-0.6h-2l-0.5,2.8l-2.3-0.2l-1.2,0.5
		l-1.6-0.2l0,0l-0.1-0.1l-0.1-0.1l-0.4-0.7l0,0v-0.2l-0.1,0l-0.4-0.4l0.1-0.1l-0.7-1.1l-0.1-0.1L517,558h-0.1l-0.4-1.5l0,0l-0.7-1.3
		l-0.1,0l-8.4,0l-0.3,0l-0.5,0l-1.9,0.4L504.1,555z M513.6,550.1L513.6,550.1L513.6,550.1L513.6,550.1z M519.1,540.9L519.1,540.9
		L519.1,540.9L519.1,540.9z M520.7,532.3L520.7,532.3L520.7,532.3L520.7,532.3L520.7,532.3z M521.8,528.4L521.8,528.4L521.8,528.4
		L521.8,528.4z M521.8,528L521.8,528L521.8,528L521.8,528z"
                />
                <polygon
                  className="WMst5"
                  points="784.7,475.9 784.4,476.3 785.4,476.6 785.1,476.2 785.2,475.8 	"
                />
                <polygon
                  className="WMst5"
                  points="510.5,434 510.4,433.7 509.9,433.4 	"
                />
                <polygon
                  className="WMst5"
                  points="550.5,546.7 550.5,546.6 552.4,546.9 553.8,545.7 554.1,545.6 554.6,545.8 555.4,547.3 553.2,550.9 
		552.2,551.4 550.9,548.4 551,547.9 551,547.9 	"
                />
                <polygon
                  className="WMst5"
                  points="511.3,376.7 512,376 514.6,377.8 516.5,380 517.3,379.5 521,380.7 521,380.7 522.4,382.4 519.8,384.9 
		517.8,385.2 517.1,386.2 517,385.8 514.1,385.1 511.8,384.9 511.7,385 510.7,386.2 508.6,385.6 505.3,382.8 504.5,380.3 
		504.5,380.3 504.5,380.3 504.5,380.3 504.5,379.3 510.4,375.9 	"
                />
                <path
                  className="WMst5"
                  d="M565.5,447.9l-0.6,1.2l-0.1-0.3L565.5,447.9z M568.4,445.3l0,2l-0.4,0.9l-1.3,0.4l0.5-3.6L568.4,445.3z"
                />
                <polygon
                  className="WMst5"
                  points="306.4,503.2 306.7,502.8 306.4,502.6 	"
                />
                <path
                  className="WMst5"
                  d="M501.1,550l2.3-1.7l-1.2-1.2l0.6-1.2l2-0.3l4.5,0.5l0.9-1.7l0.3-3.6l-1.7-1l-0.1-1.3l1.7-2l-0.7-1.2l-2.7,0.2
		l0.1-2.3l3.6-0.1l1.4,0.6l2.8,0.3V534l-0.1-0.8h0.1l0.2,0v0l1.3-3.6l2.3-0.5l3.1,0.6v0.9l-0.1,0.1l-0.1,0.1l-0.1,0.2v0.1l-0.1,0.1
		l-0.1,0.3l-0.1,0.2v0l-0.1,0.2l-0.1,0.1l-0.2,0.3l-0.1,0l-0.1,0.1l0,0.3l-0.2,0.2l-0.1,0.2l0,0.1l-0.1,1.4v0.1l-0.1,0.5l0,0.1
		l-0.1,0.2l-0.1,0.5l0,0.1l-0.1,0.1l0,0.1l-0.1,0.2l0,0.2v0l0.1,0.2l0,0.3v0.3l0.1,0.2l0.1,0.1l-0.1,0.5l-0.3,0.3l-0.1,0.1l-0.1,0.4
		l-0.1,0.2l0,0.1l-0.1,0.1l0,0.2l0.1,0.5l-0.1,0.6l-0.5,0.5l-1.8,1.3h0l-0.1,0.1l-1.8,2.4l0.1,2.9v0l0,0.3l-0.2,0.4l-0.1,0.2
		l-0.9,1.2l-0.2,0l0,0l-0.9,0.7l-0.1,0.1l-0.2,0.1l-0.9,1.1l0,0.1l-0.6,0.4l-0.1,0l-0.1-0.1l-0.1-0.1l-0.3-1.6l-2.7,1.8l-0.9-0.8
		v0.1l-0.9-0.8l-2.1,1.8l-0.6-1.3L501.1,550z M519.7,536.2L519.7,536.2L519.7,536.2L519.7,536.2z"
                />
                <path
                  className="WMst5"
                  d="M507.9,398.9l4.5,0.2l1.4-1.6l0-1.5l1.3-0.6l0.1,0l1.1-0.4l2.1,2l1.1,0.6l0.1,0l1.2,0.1l0.1,0l1.6-0.5h0.1v0
		h-0.1l0,0l0.2,0l-0.1,0.2l-0.1,0l0.1,0.1l0,0.2l0.1,0.1v0l0.1,0.1v0.1v-0.1l0.1,0.2l0,0v0l0,0l0,0.1l0,0l0,0.1h0l-0.1,0.1v0v0h0
		v0.1h0l0,0v0l0,0h0l0.1,0.1h0.3l0.2,0.1l0,0.1l0,0h-0.2l0,0.3l-0.1,0.1v0.2l0.1,0l0,1.9l-1-0.8v0l0-0.1l-0.1,0v0l0,0l-0.1,0l0,0h0
		l0,0l0,0l-0.1,0h-0.1l-0.9,0l0,0l-0.5-0.2h0l-0.3,0.2v0.1l-1.2-0.1v-0.1l-1.3-0.3h0l-0.1,0v-0.1H517v0l-3.2,1.6l1.3,2.4l2.5,2.7
		l0,0l1.2,2.2l-1.9-1.7l-2.6-1.1l-2.3-1.9l-0.8-3.6l-1.5-0.9l-1.1,2.3L507.9,398.9z M522.4,397.6l0.1,0.2l-0.1,0L522.4,397.6z
		 M521.6,400.4L521.6,400.4L521.6,400.4L521.6,400.4L521.6,400.4z M519.1,408.8l2.2,1.2l0.2,0.5L519.1,408.8z"
                />
                <path
                  className="WMst5"
                  d="M496.4,358.6l-1.7-0.3h0l-0.4-0.1l-0.1-2.6l-1.5-0.6l0.4-5.2l1.3,0l1.4-1.6l2.2-0.7l1,2.1l1.7,1.1l-4.1,5.8
		L496.4,358.6z M504.7,352.5l0.5,1.9l-1.6,3.6l-2.1-1.2l-0.1-2.4L504.7,352.5z M499.7,357.5l-1.5-0.1l-1.1-2.1l2.6-0.5L499.7,357.5z
		 M498.8,348l-2.5-0.9l1.6-2.2l1.8-0.8L498.8,348z"
                />
                <polygon
                  className="WMst5"
                  points="517.1,386.2 517.8,385.2 519.8,384.9 522.4,382.4 524.1,382.1 525,383.8 527.8,383.2 527.8,383.2 
		530.1,382.7 532.7,384.3 531.5,387.1 531.5,387.2 531.4,387.2 529.8,386.6 527,386.6 525.6,388.1 523,388.5 522.4,389.5 
		522.1,389.6 522.1,389.6 522,389.7 521.7,389.8 521.3,389.8 521.1,389.8 520.9,389.9 520.5,389.8 520.3,389.8 520.1,389.8 
		520,389.8 518.8,389.4 518.7,389.3 518.4,389 518.4,388.9 518.2,388.9 518,388.7 517.8,388.7 517.5,388.2 517.4,388.2 517,387.4 
		516.9,387.3 	"
                />
                <path
                  className="WMst5"
                  d="M746.4,521.6l1.7-0.2l1.1,2.5l2.6-1.7l2.8,2.3l0.9,1.7l-0.3,2.7l0.3,2.4l1.1,1l1.3,3.1l-2.5-0.3l-5.8-3.6
		l0-1.1l-1.6-1.7l-0.2-2.3l-0.8-1.1l0-2.4L746.4,521.6z M784.8,526.6l1.6,1.6l1-2.4l0.1,0.3l0.3-0.3l0.6-1.4l1.4-0.5l2.4-4l6.5,5.4
		l-2.7,0.5l1.2,1.5l-2.6,0.5l-0.9-0.5l-3.8,0l-0.9,1.3l0,2.1l-1.3,0.9l-1.5,3.8l-1.6,0l-1,0.6l-3.1-1l-1.8,1.6l-1.7-0.3l-1.8,0.7
		l-2.5-2.1l0-1.3l0.7,1.1l2.2,0.7l1.1-0.9l0.9-2.6l4.4-1.3L784.8,526.6z"
                />
                <polygon
                  className="WMst5"
                  points="433.8,514.3 435.5,513.3 436.2,512 439.6,511.6 441.1,513.6 442.1,515.8 442.1,515.8 442.1,515.9 
		441.2,517.8 439.4,519.3 439.4,519.4 439.3,519.4 439.2,519.5 439.2,519.6 439.2,519.7 439.2,519.7 438.9,520.1 435,517.7 	"
                />
                <path
                  className="WMst5"
                  d="M564.8,448.8l0.1,0.3l1.7,5.5l-1.8,5.5l-2.8-2.6l-0.2-1.4l-1.3-1.4l-1-3l-0.2-2.2l3.8-0.1L564.8,448.8z
		 M572.1,477.4h-10.2l-4.7-0.4l-0.5,0.4h-17.4v-22.1l-0.8-2.9l0.9-2l-0.4-1.9l0.7-0.9l2.1,0.1l9.6,2.4l2.8-1.9l1.8-0.4l2.8,1.4
		l1.3,3.8l-0.6,1.1l0.8,1.9l2.6,3.5l1,3.6l4.2,8.3l0.6,2.9l1.6,1L572.1,477.4z"
                />
                <polygon
                  className="WMst5"
                  points="712.4,383.9 713.6,382.6 716.1,382.5 717.3,380.8 722.3,378.4 723.4,377.3 726.6,377.5 724.6,378.6 
		725.5,380.4 727.9,379.3 726.9,377.7 730.2,377.9 731.2,380.2 732.2,380.2 732.2,380.2 732.2,380.4 732.3,380.4 732.3,380.4 
		734.6,380.2 738.4,381.5 740.7,380.2 741.4,378.4 740,376 740.6,374.1 743.1,371 751.9,374.5 752.4,377.5 755,379.6 757.4,379.8 
		760.8,378.3 764.8,379.1 765.9,380.4 765.9,380.4 767.4,380.5 767.4,380.6 769.5,383.3 771.3,383.2 774.1,384 781.2,382.5 784,380 
		786.2,379.4 788.4,380.7 788.8,380.8 790.7,380.2 792.1,381.1 788.8,388.2 789.9,390.1 790.8,389.3 794.2,389.7 794.9,388.9 
		797.1,388.8 800.3,392.1 800.9,394.2 799.2,394.4 796.4,393.9 793.9,395.4 791.7,395.6 790.9,397.8 789.3,399 786.6,399 
		783.6,401.8 781.2,401.3 780.2,400.5 778.5,400.8 777.5,403.3 779,405.8 776.4,407.2 773.8,409.7 770.4,410.6 766.6,410.4 
		759.8,413.7 758.5,412.6 755.4,412.5 751.7,411.3 751,410.3 748.4,409.6 744.6,410 738.2,409.1 736.4,409.4 735.2,407.9 
		733.4,403.5 731.5,403.3 728.1,400.9 720.9,400 720.3,398.6 721.3,396.8 721.4,394 718.6,389.2 715.9,388.8 712.9,386.4 	"
                />
                <polygon
                  className="WMst5"
                  points="577.4,442.1 583.4,438.7 584,437.5 584.1,437.3 584.5,434.5 584.2,432.1 585.7,431.3 587.2,429.5 
		589.4,428.6 592.6,430.1 593.9,429.4 594,430.7 597.1,434.8 597,436.5 595.7,438.5 595.6,440.1 597.7,442.5 597.5,443.4 
		601.1,445.1 602.2,447.6 602,449.8 603.5,451.9 603.5,451.9 604.2,453.1 604.3,453.1 604.4,453.2 602.6,452.9 600.4,452.9 
		598.7,455.8 593.7,455.5 588.9,451.4 588.9,450.6 580.7,446.4 578.8,445.8 	"
                />
                <path
                  className="WMst5"
                  d="M321.6,523.9l-0.9,1.1l0,0.1l-0.3,0.7l0,0.1l0,0.3l0.1,0l0,0l0,0.1l0,0.3h0v0.1l0,0.1l0,0.2l1,3.2l-0.1,0.1
		l-0.3,1.4l-1.1,1.2l-1.1-0.7l-1.1,0.5l-1.6-0.3l-1.4,1.6l-0.6-0.2l-3.7-5.4l0.6-1.8l1.3-1l0-0.1h0.2l-0.1-0.2l0-0.2h0.2l0.1,0.1
		l-0.2-0.3l-0.1-0.2l0,0l0-0.1l0.2-0.4l0.1-0.1l0.1-0.2l0,0l0.6-1.1l2.8,0.5l3-0.5l2.2,0.4L321.6,523.9z M320.5,526.6L320.5,526.6
		L320.5,526.6L320.5,526.6z"
                />
                <path
                  className="WMst5"
                  d="M552,543l0.9,0.2l1.5-1.1l0.8,1.3l0.3,2.1l-0.9,0.3l-0.5-0.1l-0.3,0l-1.5,1.2l-1.8-0.3h-0.1l-0.4-0.7l0.4-0.5
		l0,0l0.5-1.6L552,543z M550.5,546.6L550.5,546.6L550.5,546.6L550.5,546.6z"
                />
                <path
                  className="WMst5"
                  d="M285.1,400l-0.4,0.1l0-0.1l-0.2-0.3l0-0.1l0.1-1.2l-0.2,0l-0.3-0.1l-0.1,0l-0.1-0.1l-0.3-0.6l-0.2-5.1
		l-1.2-1.1l-1.7,0.7l-0.1,0l-0.4-0.8l-0.5-0.2l-2.1,3.3l-0.7,3.1l-3.6,3.4h-1.8l-0.1,0l-3,0h0l-3.5,0l-0.1,0h0l-0.2,0v0l-0.9,0.3
		l-0.6,0.3l-0.1,0.1l-0.1,0.1l-0.3,0.3l-0.7,0.7l-0.8,0.8l-0.1,0.1l-2,0.6l-1,1.3l-1.3-0.8l-4,0.8l-0.1,2.1l0.1,0.1l0,0.3l-0.1,0.3
		l0.1,0.2v0.1l0.1,0.1l0,0l0.2,0.3v0l-3.6,0.4l-0.8,0.8l-2.7-0.1l-2.9,2.5l-1.6-1.3v0l0.1-0.1l0.1-0.1l0.2-0.1l0.9-0.8l0.3-0.2
		l0-0.1l0.1-0.6l0-0.1l0.2-0.6l1.8-1.1l0-3l2.1-3.4l2.4,1.9l1.2-1.1l-1.5-2.3l-1.6-2.4l-6.3-0.8l-2.9-0.7l-0.4-0.6l-0.2,0h0
		l-0.3,0.2l-0.3-3.4l-1.2-1.1l0.4-1.5l-2.9-0.1l-1.3-3.3l-2.4,0l-2-1.1l-3.1,2.2l-1.1,1.9l-1.9-0.4l-0.1,0H221l-0.6,0l-1.2,0
		l-0.1,0.1l-0.4,0.1l-0.2,0.1l-0.1-0.1l-0.2-0.1v0l-0.2,0l-0.6-0.5l-0.1-0.1l-0.3-0.3l-0.8-0.2l-0.4,0.1l-0.7-0.7l0.2-0.2l-2-0.4
		l-0.1,0l-3.7-0.9l-0.4-2.1l-0.1,0l-0.6-0.1l-0.1,0.8l-0.4,0.7h-75.7l-1.4-1.4l-1.9-0.8L125,378l-2.5,0.2l0.2-1.7l-2,0.1l-2.5-1.2
		l-0.7-7.9l-2.3-1.6l-1.2-1.8L112,363l-0.4-3.9l0.8-2.7l-0.2-3l-0.2-1l-4.8-2.7l-4.9-9.8l-3.6-3.8l-1.3-2.7l-2.5,1l-0.6,2.3
		l-2.4,1.4l-1.4-2.8l-0.2-0.2l-4.6-4.8l-0.8,0.9l-2.8-0.7V269l5.2,1.1l5.2,4.4l6.1,2.3l-0.2-6.5l1.6-1.9l2.5,2.5l1.8-2l2.6-0.5
		l1.6-2.1l2.8-1.5l0.2,3.8l3.3-1.3l0.4,1.4l2.3-4l0.4-3.4l2.3,2.8l1.7,4.7l2.7,2.6l0.7-3.9l2.5-1.4l0,5.1l2.8-0.5l1.1-3.4l3,0.1
		l5.2,3.7l8.1,3.6l3.3,0.5l2.5-0.5l2.7,4.7l-2.8-0.4l-0.4,3.7l6,0.9l5.3-0.7l2.8-1.8l0.9,2.1l2.9,0.6l1.1-7.3l5.7-2.4l2,1.5
		l-0.1,2.5l2.8,3l2.9-1.1l3.4,3.6l6.8-1.3l2.1,1.3l2.8-2.3l1.8-3.9l2,2.5l1.9-0.9l-1,7.7l3.1-0.4l-1.6-3.1l0.6-2.4l1.7,0.4l3.1-4.5
		l-2.4-1l1-4.4l-4.1-3.3l-2.1-3.1l0.1-9.5l1.5-2.9l3.6-2.2l2.5,0.8l2,3.7l-0.1,4.2l4.1,5.5l-2.1,4.1l3.9,3.3l1.2,2.8l0.4,4.9
		l2.6-7.7l3,2.5l-0.5,6.8l3.1,6.6l2.2-1.6l2.5-10.4l1-8.1l2.3-0.6l4.5,2.2l1.4,2.9l1.6-0.5l1.3,3.9l-2,2.6l-0.4,3.7l2.5,3.3
		l-0.7,3.2l-1.8,0.3l-1.3,2.7l-4.9,2.8l-2.1-1.3l-0.9-1.8l-1.2,3l-4.1,5.6l-1.9-0.1l-1-1.9l-3.9-2.4l-0.5,0.7l2.6,3.7l5.6,0.6
		l0.1,1.3l-3.1,5.8l-1.8,1.1l-2.6-0.4l-2.6,3.4l-0.3,3.4l-1.7,0.8l-2.9-0.2l-1.5,4.3l-1.7,1.7l-2.8,8.1l-0.7,7.3l1.8,1.4l2.9,0.3
		l2.1,7.3l-0.8,2l4.3-1.6l6.3,2l2.5,2l0.8,2.5l4.9,1.5l2,1.9l6.8,0.2l1.4,1.9l-0.7,2.9l1,1.8l-0.7,4l3.8,4.2l1.6,3l1.7,0.9l1.2-2.3
		l2-1.4l0.3-2.2l-1.3-2.5l0.3-2.5l-1.8-5l4.8-3.1l3-3.5l0.4-5.6l-1.8-4.6l-3.9-3.6l2-4.4l1.9-2.7l-2.9-4.3l1.4-2.3l-1.3-6.2l1.9-1.9
		l5.4,1.8l2.3,0.1l2.8-1.4l4.9,4.5l1,3.2l2.3,0.9l1.7-0.5l1.6,6.8l-0.7,3.1l1,2.2l3,0.6l1.4,2.5l2.2,0.2l2.6-2.7l1.5-5.2l1.9-3.4
		l1.2,0.6l2.2,5.8l1.4,0.9l-0.1,3.7l1.4,2.3l2,0l1.1,9.6l2.6,1l1.8,3.5l2.2-0.7l0.6,1.9l2.6,0.2l1.1,1.9l-2.8,1.6l-4.1,1.3l0.2,1.5
		l2.5-1.1l2.1-2.5h2.5l1.2,2.3l2,0.7l1.8,5.1l-0.2,1.6l-3.4,2.9l-1.3-0.5l-3.3,1.2l-3.9,4.6l-2.2-0.3l-2.3,0.7l-3-0.7l-2.6-0.1
		l-7.4,0.3l-1.9,2l-0.6,2.1l-2.1,0.2l-2.5,2l-1.1,3.3l3.5-2.6l4.2-2l3.5-0.6l3.1,1.5l-0.2,2l-1.3,2.6l-0.4,2.1l1,4.1l3.7,2.2
		l2.2,0.5l1.5-1.2l1.2,0.8l-0.4,2.3l-2.5,1.2h-1.6l-1.4,1.4l-1.9,0.6l-2.7,2.8l-2.3-1.2l0.1-1.8l1.1-1.5l3.6-2.4l-1-1.1l-3.1,1.6
		l-2.8,0.6L285.1,400z M199,376.6l0.2,3.2l1.2-0.7L199,376.6z M201.6,366l-0.9-2l-3-0.8l-0.9,3.1l3.7,5.8l1.6-0.7l1,3.7l0.4,4
		l1.5-1.5v-2.9l-1.6-2.5L201.6,366z M191.5,312l-2.7,1.8l2.1,3l1.1-0.3L191.5,312z M189.7,345.2l-0.3-3.1l-2.3,3.9l0.9,3.4
		L189.7,345.2z M163.4,320.4l-0.3-3.3l-2.6,3.1l-2.6,0.5l-3.5-2l-1.6-1.6l-0.7,5l-1.2,3.4l-2.2-0.9l-0.6,1.3l4.2,1.6l4.4-0.9
		l1.1-2.6l1.9,0.3L163.4,320.4z M170.8,334.9l-2.7-0.1l-4,4.4l2.2,0.5l0.5-1.6l2.4-1.3L170.8,334.9z M136.1,302.5l0.4,1l3.5-3.5
		l0.5-2.9l3.4,0.8l1.5-4.7l-4.6,0.4l-2.2-1.4l1.3-3.7l-12.6,5.5l3.4,0.5l3.2-0.6l1.6,2.2l-4,2.9l0.2,1.5l2.2,2.1L136.1,302.5z
		 M226.3,382.1l1.4-1.4l-1.7-1.5l-1.2,1.9L226.3,382.1z M264.8,400.8L264.8,400.8L264.8,400.8L264.8,400.8z M198.6,271.8l2-4.8
		l5.3,5.2l0.5,2.8l-1.2,3.1l-3.3-0.6l-2.2-2.2L198.6,271.8z M237.9,120.2l-6.8-4l6.9-3.1l3.4,6.1l1.5-4.6l3.6-4.2l-0.3-7.3l6.5-2.2
		l5.3,1.3l2.6,7.8l2.6-2.8l-6.1-9.3l9.4-2.1l0.6,2.5l11.4-1.8l9.3,4.1l4,5.5l3.6-3.3l-0.2,8.6l5.4-1.3l1.4,5.4l-8.8,10.3l-6.2,3.6
		l-9.4,8l15.1-8.6l-0.4,3l-8.6,8.1l-10.1,20l-3.4,0.8l-1.4,2.3l-4.8,0.1l-0.6,2.1l-5.4-3l-0.1,3.8l7.4,1.3l0.2,2.8l-4.7-2.3
		l-0.8,5.2l4.7,0.3l0.4,3.2l-5.6,0.8l2.1,7.7l-6.8-0.1l1.8,4.7l-4.1,4.1l-4.7-0.8l-2.8-4.7l0.2,7.1l2-1.6l4.9,0.9l1.5,5l-2,5.9
		l-7.3-2.5l-3.1,1.3l-3-3l-1.8,4.5l-11-1.5l-2.1-1.9l3.1-6.4l2.3-3.2l-1.4-6.3l5,0.1l1.6,5.4l1.5-3.2l0.9-6.7l-3.6,1.3l-3.5-0.7
		l2.5-9.2l4.3-1.7l7.5,4.9l-0.5-4.5l-5-4.3l-2.2-6.9l-3.6-2l-0.1-8.3l7.3,0.7l5.9,10.6l0.8-5.6l-4.9-6.1l14.1-3.8l-5.3-1l-10.8,1.5
		l-11.8-2.5l-3.4-4.1l10-2.6l2.4-4.1l-13.3,5.2l-1.5-3.4l0.1-9.3l1.2-4.1l2,2.9l2.9-6.7l3.4,4.5l1.5-3.5L237.9,120.2z M205.2,188.6
		l2.1-1.7l6.6,1.9l-2.3,2.9l-5.3-0.4L205.2,188.6z M211.2,248.9l-2.9-0.8l-1.9-9l0.6-6.1l0.9-2.5l5-1.9l2.4,0.6l0.7,1.8l2.2-0.9
		l3.4,1l-4.9,11.3h-4.6l0.9,2.7L211.2,248.9z M222.2,176.8l-0.7,5.9l-4.9-1.1l-6-10.7l-0.2-6.5l-2,2.4l-1.7-5.6l-2.5-3.7l-0.1-4.3
		l5-15.4l1.5,1.8l0.7-7.4l5.6,2.6l3.6,11.7l4.2,0.5l1.7,2.5l2.7-0.5l0.2,3.8l3.4,8.3l1.7,0.5l2.3,5.1l-5,4.7l-0.8-1.4l-3.3,8.6
		l-1.7-2.2l-0.1,6.3L222.2,176.8z M212.8,218.9l-0.6,5l-3.7-0.4l-2.8-3.7l0.9-5.3l2.4-1.3l3.5,3.1L212.8,218.9z M247.1,213.1l1.7,2
		l0.4,9.4l-17.4,1.1l-5.3-0.3l0-4.3l-2.6,3.8l-7.1-2.6l-1.2-4.5l1.4-4.8l-3-8l-4.8,0.3L207,202l-3.7-1.2l0.2-3.1l3.2-1.2l5.4,1.7
		l1.7,3.7l10.8,4.3l-2,2.8l0.5,4.8l2.3,1.6l4.5-2.1l3.1,1.2l4.5-1.2l1.4-2.2l6.6,0.1L247.1,213.1z M200.1,176.6l1.1-3.2l7.2,5.2
		l-0.1,6.6l-5.6,2L201,184L200.1,176.6z M191.5,171.1l4.8,5.4l-1.1,10.9l-3.2-5.6l-4.2-0.5l-0.6-2.2l-3.5,2.2l-1.8-1.2l1.6-9.1
		l-4.1-0.7l0.1-4.4l6.7,0.6l1.5,6.1l1.7-3.2L191.5,171.1z M179.5,188.1l3.2,5.2l-0.5,2.6l-2.2-1.2L179.5,188.1z M162.3,176.9l4-2.9
		l3,3.1l-0.2,3.2l-4.9-1L162.3,176.9z M166.7,190.8l-6.1,1.9l-2.1-2l-0.1-5.1l9.8-2.4L166.7,190.8z M200.4,218.8l-1.8,1.4l-4.7-0.4
		l-1-4.3l-5.3-0.8l3.6-8.5l3.1,1.4l1.6-5.8l1.6,2.8l1.6-3.6l2.3,2.4l0.4,7.2l-1.2,3.3L200.4,218.8z M197.1,233.3l3.9-2.2l1.6,0.7
		l0.1,4.8l-0.8,3.3l0.7,3.8l1.9-1.5v8.3l-4.2,2.7l-1.8,2.2l-1.5-0.6l-3.8-7.4l-3.2-1l-2.7-4.3l1.7-3l2.2,3.5l2.4,0.1l1.2-2.1
		l-2.5-6.4l2.2-3.4L197.1,233.3z M178.6,238.8l-1.6-5.6l3.8-0.3l1.8,2l-2.2,6.7L178.6,238.8z M258.6,236.9l2.1,4.5l-5.8-0.5
		l-3.7,1.3l-1.6-4.4l-2-1l0.1-4.1l7.5,0.8L258.6,236.9z M265.1,281l2.8,0.1l0.3,2.1l-3.1-0.3L265.1,281z M260.8,287l-2.7-0.1
		l-0.5-1.9l0.8-4.2l1.8-1.9l3.6,1.6l-0.5,5.1L260.8,287z M152.5,219l-2.3-1.3l-1.3,1.1l-2.7-1.5l4-10.5l3.6-3.7l2,0.5l0.5,3.3
		l4.3,0.2l2.7,3.8l0.6,3.7h6.8l-1.4-6.6l-3.2-2.9l3.6-5.6l1.4,4.8l2.7,5l1.6,1.1l1.3-1.9l3.2,2.5l-1.6,8.8l-3.3,1.5l-1.5-2l-1.6,1.9
		l-1.2-1.6l-9.9,6.8l-3.2-0.1l-2.5-2.8l3.1-7.7l-2-0.7l-1.2,4.5L152.5,219z M142,193.4l6.1,0.1l1.6,1.9l1,6.4l-2.5,0.6l-1.4,3.5
		l-1.6-1.8l-0.7-4.3l-2.1,8.1l-3.9,2.9l-3.8-2.5l1.1-4.4L142,193.4z M139.8,227.6l0.7,2.4l1.8-1.7l4.7-0.2l5.8,7.4l-10.6,7.9
		l-1.7,3.8l-1.3-0.4l-1.1,6.9l-2.9,0.2l-4,3.3l-2.3-5.1l-3.6-2.6l1.1-5.5l0.1-4.9l3.1-6.3l-2.9-5.9l8.9-2.3L139.8,227.6z
		 M189.7,268.6l-0.4-2.2l-1.7,1.5l2.5,5.9l-3.1,1.6l-6.2-2.2l-3.4-0.7l-0.5-2.5l-2.2,3.8l-3.4,0.5l-1.6,1.7l-10.6,1.4l-1.8-2.3
		l-0.1-2.8l-7.7-1.7l-2.4-4.9l7.9-2.4l5.4,1l3-1.1l-6.6-3.1l-4.8,1.2l-5.5-0.2l-2.2-3.6l9.1-4.4l-8.6,1.4l-2.6-3.1l2.8-4.5l-1.2-2.5
		l3.3-3.9l7.3-4.3l2.1,2.4l1,4.6l0.9-3.3l1.2-0.1l6.7,4.1l1.3-3.9l3.6,4l1,7.4l1.3-3.7l-1.3-9.5l0.7-1.6l3.1,0.4l3.7,4l1.8,9
		l1.5,2.6l-0.5,4.9l2.6,3.7l3.8,2.3l3.3,1l0.1,4.1L189.7,268.6z M244.1,317.2l-2.6,2.5l-1.8,0.2l-0.7-1.8l1.7-2.8l4-0.1L244.1,317.2
		z M274,292.2l0.7,3.1l4.3-1.5l-0.4-2.3l-4.2-2.5l-0.8,2.5l-4.3-1l2.3-3.8l-2.4-7l-2.4-0.8l-4.4-5.2l-3.1,2.6l0.1-2.6l2.8-1.6
		l-5.6-4l-0.1-3.6l-3.4-0.9l0.4,3.4l-2.5,0.2l-0.7-1.3l-4.9-1l-1.6,2.8l-2.1-1.8l-7.6,0.1l-2-1.9l-3.6-0.6l-2.7-1.7l-1.9-4.8
		l4.1,1.3l0.6-2.8l-5.6-0.6l-0.7-5.2l0.4-3.8l1.8-6.5l2.9-5.1l4.7-2.8l4.7,1.2l-3,3.6l-2.3,6.2l1.5,2.7l0.1,5.1l2.5,1.5l-1.1-11.1
		l1.6-3.8l6.3-4.2l3.4,0.1l3.8,9.5l3.5,4.1l1.5-2.8l3.4-1.5l5.6,2.3l0.2,3.5l2.3,0.3l0.6,5.6l1.2-1.1l1.5,2.7l1.3-3.5l3.9,3.4
		l-2.6,1.6l-1.5,3.8l5.6-3.6l6.4,4.5l1.1,6l3.2,4.9l-6.3-1.6l0.1,2.9l2.2-1.3l0.4,3.6l1.4,1.4l2.5,0.3l0,2.3l2.4,1.3l2-0.5l1.6,1.7
		l0.2,2.5l2.6,1.6l0.9,1.9l3.1,0.6l1.4,3l-4,2.4l0.2,3.6l-1.6,4.5l-2.8-1.2l-3.9-6.9l-4-2.3l-1,1.3l-1.9-0.4l0.6,3.7l2,0.9l2.3,4
		l3.1,2.1l0.8,3.3l1.7,1.5l0,6.5l-1.4,2.2l-1.2-1.6l-4.4-2.9l-2.1-3.1l-3,0.1l2.8,4.4l1-0.3l4.7,5.3l-1,2.1l-4-2.1l-2.5-0.2
		l-3.7-3.1l-4-1.6l-0.8-2.2l-2.4-3.8l-2.9-3.1l-2.8,1l-5.6,0.3l-3.7-0.8l-0.3-3.4l2.3-1.4l-0.3-1.8l4.7,1.7l1.7-1.3l1.6,0.4l1-1.4
		l-0.7-4.4l3.7-3.6L274,292.2z M272.7,299.7l1.7,5l1.3-2.7L272.7,299.7z M241.2,307.7l-1.1,2.4l-1.9,0.8l-0.8,2.1l-2.9,0.7l-0.1-3.1
		l-4.2,0.7l0.6-2l2.2-1.3l-0.6-3.2l1.1-7.3l1.1-1.3l1.9,4.7l1.1-1.8l1.1,1.8l6.3,4.2l0.7,2.7l3.9,2.3l-2.5,2l-3.9-1.3L241.2,307.7z
		 M249.9,322.3l-0.5-2.3l1.7-1.7l0.8,2.3l-1.2,2.6L249.9,322.3z M293.2,380.7l4.5,1.1l-1.3,1.7L293.2,380.7z M311.7,379.5l0.6-2.1
		l2.3-2.8l1.8-1.3l0.5,2.4l-1.3,1l0.1,3l1.1,1l0.2,2.3l1.8,0.7l1.6-1.1l2.7,0.9L322,385l1.7,1.7l-1.7,3.4l2,1.2l0.2,2.9l-1.4-0.7
		l0.1-1.6l-1.2-2.6l-2.3,1.7L316,390l-9,0.3l-0.2-1.2l1.9-2.6L311.7,379.5z M303.2,396.8l-1.8,1.8l-0.6-1.9l2.6-4l0.7,1.6
		L303.2,396.8z M129.1,384.1l1.7,2.8l-0.8,0.6l-4.5-1.9l-2.9-2.4l-1.1-2.4l-1.8-1.2l-1.7,0.4l0-3.3l2.9,1.5l3.9,0.9l1.8,3.7
		L129.1,384.1z M105,362.7l2.7-0.9l-0.9,4l-1,0.2l-1.8-1.5L105,362.7z"
                />
                <polygon
                  className="WMst5"
                  points="537.6,343.5 538.7,342.9 538.9,342.9 540.2,342.4 543.8,345.4 545.8,345.3 546.4,345.3 546.4,345.3 
		546.4,345.3 548,352.1 545.5,354 543.9,354.4 543.9,354.4 543.8,354.5 543.6,354.5 542.7,353.8 542.7,353.8 540.8,352.2 
		535.7,351.1 531.4,350.8 528.5,352.6 528.5,348.8 530.3,345.1 532.8,344.1 534.6,347.5 536.4,348.1 537.7,346.6 	"
                />
                <polygon
                  className="WMst5"
                  points="296.8,488.9 296.6,488.9 296.7,489 296.8,488.9 296.8,488.9 	"
                />
                <polygon
                  className="WMst5"
                  points="465.5,407.1 468.8,409 469.6,409 469.6,409 474.4,409.9 474.5,410.5 475.2,410.3 477.2,410.8 
		479.2,410.5 479.2,412.6 476.4,414.7 473.2,415.6 470.6,419.3 469.5,421.4 471.1,423.9 468.7,425.8 468.1,427.4 465.6,429 
		464.8,430.7 463,431 458.3,430.9 456.2,431.9 455,433.3 453.8,432.7 452.7,430.2 450,429.2 449.9,427.7 449.9,427.7 450.9,425.9 
		450.3,424.9 450.3,424.6 450.5,424.4 450.5,424.3 451.8,418.2 451.8,415.5 451.8,415.4 452.2,414.9 452.2,414.9 452.3,414.9 
		452.4,412.3 450,412.8 447.6,411.7 446.2,412.4 446.1,412.6 446,412.6 445.8,410.4 444.8,408.2 447.5,406.7 448.7,405.5 
		451.3,406.2 454.4,405.9 457.7,406.9 460.7,406.5 	"
                />
                <polygon
                  className="WMst5"
                  points="569.6,437.9 570.5,437.7 571.4,439.4 569.9,440.6 569,442.2 567.2,443 	"
                />
                <polygon
                  className="WMst5"
                  points="301.3,496.7 301.7,496.3 301.1,495.8 	"
                />
                <polygon
                  className="WMst5"
                  points="589.6,571.6 590.2,571.7 589.9,570.5 	"
                />
                <polygon
                  className="WMst5"
                  points="285.6,489.2 288.8,489.1 289.7,488 285.4,487.6 	"
                />
                <polygon
                  className="WMst5"
                  points="580.7,406.9 581.3,406.2 585.1,407.6 588.6,407.7 591.6,410.1 593.2,409.3 594.9,409.5 596.3,411.4 
		598.4,412.5 597.8,413.5 597.8,413.5 598,413.5 598,413.6 598,413.6 598.2,414 598.2,414 599,414.5 599,414.5 599.1,414.6 
		599.1,414.6 599.2,414.7 599.2,414.8 598.6,415.6 595.1,414.2 594.5,414.7 590.2,415.3 588.5,413.6 587.6,414.2 585,413.9 
		585.6,411.7 584.7,409.4 	"
                />
                <path
                  className="WMst5"
                  d="M813,419.6L813,419.6L813,419.6l0.1-0.2v0L813,419.6z M813.1,419.5v-0.2l1.7-1.5l0.4-0.3l0.8-0.2l0-0.1
		l0.4-0.3h0.3l0.1-0.1l0.8-0.4l0,0l0.1-0.1l0-0.1h0.1l0-0.1l0.1-0.3l0.1,0l1-1.2l0.1-0.3l0.1-0.1l0.2-0.5l0,0l0-0.1l0.4-0.1h0
		l3.7,1.2l1.5-2.4l2.9-1.5l1.5-1.5v0.2l0.5,0.7l0.2,0l0.2,0.2l0,0.1l0,0l0.1,0.2l0.1,0.1v0.3l-0.8,0L828,413v3.1l-6.2,4.1l0.1,1.7
		l2.2,2.4l-1.1,1.1l-2.3,0l-1.3,1.7l-3.4-0.1l-1.6-1.7l1.7-4.3l-1.1,0L813.1,419.5z"
                />
                <polygon
                  className="WMst5"
                  points="426.1,292.2 428.1,294.7 430.2,295.7 431.2,297.9 431.2,302.1 430.5,305.9 428.1,306.3 424.6,309.9 
		422.5,310.2 420.2,312.1 417.7,312.4 414.8,311.5 412.3,309 409.7,308.4 408.8,303.4 410.5,302.1 410.7,299.4 407.9,299 
		406.4,297.8 405.8,294.3 408.6,292.4 412.8,298.5 414.6,297.9 415.1,294.8 416.9,295.3 420.1,294.5 422.1,295.9 423.2,294.2 
		425,294.4 	"
                />
                <path
                  className="WMst5"
                  d="M942.7,632.8l-2.3,0.4l0.1,1.7l-1.3,3l-1.8,2.8l-1.8,1.3l-1.8-1.2l1.5-2.3l-0.1-2.1l-3.8-2.5l2.3-1.9l0.8-3
		l-1.1-3.2l-0.1-2.4l-1,0.2l-2.7-4.1l0.9-1.4l3.3,3.6l0.2,2.6l2.3,2.1l0.9-1.2l1,2.6l2.7,1.5l2.3-1.7l1.5,0.4l-0.5,2.6L942.7,632.8z
		 M924.1,654.6l-1.6,3l-2.7,3.4l-3.4,0.2l-2.2-1.9l-2.4,0.2l-0.6-1.5l1.1-2.1l4.2-4.9l1.2-0.1l5.9-4.5l1.4-3.8l1.7-1.4l0.1-1.9
		l1.4-0.7l1.5,2.4l1.8-1.5l1.2,3l-2.6,4.2l-1.5,1l-0.3,2l-3.7,2.4L924.1,654.6z"
                />
                <polygon
                  className="WMst5"
                  points="564.1,527.6 565.2,526.5 568.3,526.5 569.5,526.5 569.5,526.6 569.2,529.3 571.3,532.6 571.6,531.3 
		570.2,530.2 570.2,527 571.6,527 571.7,527 572.5,527.2 575.5,529.3 576.7,529.2 579.4,529.9 580.3,528.6 582.8,527.4 583.9,528.4 
		585.9,528.3 583.4,531.4 583.4,541.4 585,543.7 582.7,545.2 581.2,546.7 579.2,551.7 578.5,552 574.5,549.1 573.9,547.3 564.4,542 
		564.2,538.5 566.9,534.6 566.8,532.4 564.4,528.6 	"
                />
                <path
                  className="WMst5"
                  d="M525.6,420.5l0.7-0.1l1.9-2.8l0.1-1.2l0.4-0.2l5-1.8l4.4-0.8l2.5,1.1l1.9-0.3l0.6-1.3l-0.8,3.6l-2.8-1
		l-2.7,1.1l-0.2,2.2l-3.9-1.3v1.7l2.1,2.9l-0.1,1.9l2.1,1.5l-2.9,1l-0.6-1.1l-2.3-0.6l-2.2,0.4l-0.4-1.3L525.6,420.5z M535.4,435.8
		l2-0.3l4.1,0.1l0.1,0.8l-2.9,0.6l-1-0.9L535.4,435.8z M530.1,430l-0.1-1.9l-1.4-1.2l2-1.6l3.1,1.4l-0.7,1.4l-0.1,2.6L530.1,430z"
                />
                <polygon
                  className="WMst5"
                  points="494.3,430.1 493.2,433.7 493.4,437.6 491.2,439.8 492,442.7 493.5,444.9 495.5,446.3 496.8,452.2 
		497.4,454.8 497.9,459.6 497.4,461.5 497.6,463.8 496.4,464.8 498.1,467.3 498.6,469.5 500.5,469.8 502.4,470.7 503.5,472.9 
		491.2,480.7 486.5,484.9 482.2,485.8 479.6,486.2 479.4,483.8 476.6,482.3 475.4,482.4 473.7,481.1 473.7,480 457.2,468.4 
		446.6,461.4 446.6,457 450.8,454.5 454.5,454.2 458.6,451.3 460.3,450.9 460.4,447.8 462.7,447.3 462.6,446.2 467.3,446.2 
		467.7,444.9 466.2,443.4 465.7,437.6 464.4,436.4 465.6,436.3 467.6,434.4 470.2,434 471.4,432.7 474.2,431.5 477.5,431.3 
		478.4,430.6 481.2,430.2 483.7,430.3 485.3,431.1 488.3,429.6 490.3,429.6 492,430.5 	"
                />
                <polygon
                  className="WMst5"
                  points="447.1,518.4 447.8,518.5 448.9,515.8 449.2,514.2 448,513 448.5,511.2 450,510.7 451.1,511.2 
		453.3,509.6 453.4,511 455.3,510.5 456.8,512 458.6,512.8 459.1,512.1 461.7,511.8 463.1,513.1 463.6,516.6 462.8,517.3 461.5,521 
		462.4,525.1 459.3,524.5 453.7,525.5 449.7,527.2 450.2,524.6 450,523.2 448.7,521.9 446.8,521.3 447.7,520 	"
                />
                <polygon
                  className="WMst5"
                  points="609.8,466 610,465 609.5,464.7 	"
                />
                <path
                  className="WMst5"
                  d="M305.2,515.7l-0.1,1.4l-1.9,1.3l1,1.7l-2.1,0.6l0.1,1.5l-0.8,0.6l1.8,2.1h0l-0.7,1.8l-0.9-0.1l-1.7,1.2
		l-5.6,0.7l-0.7,2.1l0.7,1.1l1.5,0.7l-1.6,1.3l-0.2,0.9l-5.6,2.5l-2-1.3l0-0.2l0-0.2l-0.5-1.3l0-0.1l-0.1,0l-1.1-2v0l0,0h0l0-3
		l-0.1-0.1l-0.3,0l0,0l-0.4-1.1l0-0.3l0.1-0.1l0-0.1v0l0-0.2l-0.1-0.1v-0.4l0-1.6v-0.1l0-0.1l0.5-0.4l0.1-0.2l0-0.3l0-0.1l0-0.3
		l0.6-0.7l-0.1-0.1v-0.4l-0.2-0.2h-0.1l-0.1,0l-0.2-0.1h-0.2l0,0l-0.2,0l-0.3,0.2l-0.1,0l0,0h-0.2l-0.6,0.1l-0.2,0l-0.8,0.1l-0.1,0
		l-0.1,0l-0.1,0l-1.7,0.1l-0.1,0l-1.9-2.4l-1.5-0.3l-2.2,0.2h-0.2l-0.1,0l0,0l-0.2,0h-0.1l-0.3-0.1l-0.1,0l-1.7-1l0.1-2.7l-1-1.9
		l-1.6-0.3l1.1-1.8l0.2-1.7l2.5-3.3l1.6-0.4l-1.6,0.7l0.9,3.1l-1.4,1.8l1.2,2.1l1.8-0.7l0.1-1.1l-1.5-3l0.4-0.5l3.9-1.3l-0.7-1.3
		l0.7-0.8l1.1,2l2.7,0.3l2,2.5l4.7-0.6l1,1.2l2.2,0.5l2.3-1.7l6.6-0.3l-2.6,0.9l2.8,1.8l2.6,0.8l-0.3,2.5L305.2,515.7z M283.6,524.7
		L283.6,524.7L283.6,524.7L283.6,524.7z"
                />
                <polygon
                  className="WMst5"
                  points="555.5,529.6 555.5,529.6 556.4,528.8 558.6,529.4 558.6,529.4 561.5,528.5 562.8,528.9 564.1,527.6 
		564.4,528.6 566.8,532.4 566.9,534.6 564.2,538.5 563.4,538.4 562.4,538.3 559.5,539.1 557.8,541.4 558,541.9 554.4,542.1 
		552.9,543.2 552,543 552.3,540.4 552.4,539.4 553.2,536.8 553.2,536.8 553.7,536.5 553.7,536.5 554.4,535.9 556.7,534.6 
		556.7,533.2 555.2,532.5 555.5,529.6 	"
                />
                <polygon
                  className="WMst5"
                  points="302.4,498.7 302.7,498.3 301.7,498.2 	"
                />
                <polygon
                  className="WMst5"
                  points="312.9,523.8 312.8,524 312.7,524.1 312.5,524.5 312.5,524.6 312.6,524.6 312.6,524.8 312.8,525.1 
		312.7,525 312.6,525 312.5,525.2 312.6,525.4 312.5,525.4 312.4,525.4 311.1,526.4 310.5,528.2 314.2,533.6 314.9,533.8 
		312.5,533.7 311.9,534.5 309.8,534.8 308.3,536 306,534.3 305.2,531.1 305.5,529.4 306.4,528.4 306,527.2 304.7,526.8 305.1,525.2 
		303.1,524.9 303.1,524.9 301.2,522.8 302,522.2 302,520.7 304.1,520.1 303.1,518.5 305,517.1 305.2,515.7 307.6,517.1 309.3,519 
		309.5,520.3 310.6,520.5 312.9,522.4 312.9,523.8 	"
                />
                <polygon
                  className="WMst5"
                  points="479.7,374.5 479.9,375 480.4,374.8 482.1,374.6 482.1,374.5 483.5,373.9 486.5,375.6 486.4,375.7 
		486.2,376.3 486.3,376.3 487.1,377.2 487.4,379.9 486.5,382.3 485.5,382.5 483.9,381 481.9,380.5 481.8,379.1 478.3,377.4 
		477.5,375.7 	"
                />
                <path
                  className="WMst5"
                  d="M255.8,519.4l2.1-2l-0.6-2l1.2,0.3l1.7-1l2.1-2.9l0.1-1.7l3.8-2.1l2.4,0.1l2.9-1.7l1.5-1.6l1.2,0.5l-0.4,1.3
		l-1.6,0.4l-2.5,3.3l-0.2,1.7l-1.1,1.8l1.6,0.3l1,1.9l-0.1,2.7l1.7,1l0.1,0l0.3,0h0.1l0.2,0l0,0l0.1,0h0.2l2.2-0.2l1.5,0.3l1.9,2.4
		l0.1,0l1.7-0.1l0.1,0l0.1,0l0.1,0l0.8-0.1l0.2,0l0.6-0.1h0.2l0,0l0.1,0l0.3-0.2l0.2,0.1l0,0h0.2l0.2,0.1l0.1,0h0.1l0.2,0.2v0.4
		l0.1,0.1l-0.6,0.7l0,0.3l0,0.1l0,0.3l-0.1,0.2l-0.5,0.4v0.1l0,0v0.1l0,1.6v0.4l0.1,0.1l0,0.2v0l0,0.1l-0.1,0.1l0,0.3l0.4,1.1l0,0
		l0.3,0l0.1,0.1l0,3l0.1,0.1l1.1,2l0.1,0l-0.1,0l0.1,0.2l0.5,1.3l0,0.2l0,0.2l-1.5-2.7l-2.1,1.4l-4.6,0v1.7h0.1l0.3,0l0,0l0.1,0l0,0
		l0.5,0.1l0.1,0h0.3l0,0h0l0.1,0l0,0l0.2,0.4l0.1,0v0l0,0l-2.5,0.8l0,2.1l1.2,0.9l0.5,2v0.6l0,0.2l0,0l-1.3,7.3l-0.1-0.1l0-0.1
		l-0.2-0.1l-0.1-0.2l-0.1-0.1l-0.1-0.2l-0.4-0.4h0l-0.2,0.1h0l-0.2,0.1l-0.1,0l-0.2-0.1l0,0l1.5-3l-0.3-0.3l-0.2-0.2l-0.6-0.2
		l-0.1-0.1l-0.2-0.1h0l-0.1,0h0l0.1,0.1l-0.8-0.5l0-0.1l-0.4,0.1v0.1l-0.5,0.2l-0.1,0l-0.1-0.1l-0.2,0.1v0l0,0h-0.2l-0.2-0.3v0.1
		l0,0l-0.1,0.1v-0.1l0-0.2l-0.4-0.1l-0.2,0l0-0.2l0,0.1l-0.4,0.4l-0.2,0l-0.2,0.1l-0.2,0.1l-0.6,0.3l-0.1,0l-0.5-0.2l-0.1-0.1
		l-0.2,0.2l-0.1-0.1l0-0.1l-0.2,0l-0.6-0.1l-0.1,0l-0.2,0l0,0l-0.1,0l0-0.1l0.1-0.5v-0.1h0v-0.1l0-0.1l0-0.1v-0.1l0,0v-0.1l0-0.1h0
		l0-0.1l-0.1-0.2l-0.1-0.1l-0.1,0.1l0-0.1l-0.1,0.1l0,0l-0.7-1.3l-0.1-0.1l-0.3-0.2v-0.1h0v0l0,0.1v0h-0.1l-0.1,0l-0.1,0l-0.3-0.4
		l-0.1-0.1l0-0.1v-0.1l-2.2-2.2l-1.2-0.2l-3.2-1l-3.1-0.4l-0.5-1.2l-1.3-0.3l-1.5-1.2l0,0l-0.2-1.2l1-2l1.7-0.4l2-2.6l-1.1-1.3
		l0.7-1.7l-0.5-4l0.4-1L255.8,519.4z M284.5,531.9L284.5,531.9L284.5,531.9L284.5,531.9z M269,544.4L269,544.4L269,544.4L269,544.4z
		"
                />
                <polygon
                  className="WMst5"
                  points="589.3,504.1 587.3,504.8 583.3,500.2 579.6,498.7 576.4,499.3 574.9,497.9 573.3,499.2 571.2,499.7 
		570.8,497.1 572.3,494 572.4,491.7 575.9,490.4 576.8,489 577.7,490.8 578.6,494.6 579.9,497.4 582.1,497.6 584,498.7 585.3,500.6 
		586.1,500.9 588.3,503.7 	"
                />
                <path
                  className="WMst5"
                  d="M281.4,720l1-0.5l5,1.3l3.4-1.2l-3.4-1.6l-3.4-3.1l-2.5-5.3V720z M270.4,693L270.4,693L270.4,693L270.4,693z
		 M314.5,622.6L314.5,622.6L314.5,622.6L314.5,622.6z M316.4,620.5L316.4,620.5L316.4,620.5L316.4,620.5z M318.5,618.7L318.5,618.7
		L318.5,618.7z M314.2,617.8L314.2,617.8L314.2,617.8L314.2,617.8z M313.6,617.7L313.6,617.7l0.1,0.1L313.6,617.7L313.6,617.7z
		 M314.1,617.8L314.1,617.8L314.1,617.8l0.2-0.1v0l-0.1-0.1L314.1,617.8z M311.3,617L311.3,617L311.3,617L311.3,617z M311.6,611.7
		L311.6,611.7L311.6,611.7L311.6,611.7z M297.4,626.5l1.6-0.4l-0.1,2l-1.8,0.3L297.4,626.5z M293.2,603.6l-0.8-2l-1-0.4l-3.6,0
		l-1.2,0.4l-1.2,1.7l0.5,0.6L285,607l-2.9,1.4l0.1,1.9l-0.7,0.9l0.6,2.3l-0.6,0.9l0.9,1.3l-1.6,0.7l-0.9,2.5l-1.4,1.4l-0.6,4.1
		l-1.1,4.3l-0.8,1.4l2.2,6.1l-1.7,6l0.2,2.2l-1.1,2.1l-0.9,0.1l-0.5,4.2l1.1,3.2l-1.7,1.2l-0.6,5.1l-0.6,1l0.4,5.3l-1.2,0.3l0.1,2.7
		l1.1,1.1l0.2,2.8l0,0.1l1,1.8l-0.2,3.5l-1.1,1.1l0.1,2.7l0.2,0.8l-1,2.9l0,0.2l-1.4,2.6l0.8,1.6l-0.9,2.1l-0.1,0.1l0.1,0.4
		l-0.4-0.2l-1.1,1.1h-1.4v2.1l0.5,0.5l0.1,2.5l0.8,1.8l2.1-0.7l-0.2,4.2l1.1,1.7l5.6,0.1l4.3,1.8l-1.5-3.5l-0.6-2.8l0.8-2.8l2.7-1.5
		l1-4.2l4.9-4.5l0-2.9l-2.9-0.8l-2-2.1l-0.2-1.9l1.7-2.8l3.4-1.8l1.4-1.7l-0.3-2.7l1-1.5l-0.1-1.8l1.2-1.1l1.2,1.4l1.4-0.4l-0.4-2.5
		l-1.9,0.6l-1.6-0.7l-0.2-4.5l3.7,1.2l1.9,0l1.9-0.9l-0.3-2.2l1.8-4.7l2.6,0l5.1-1.1l4.1-2l0.1-0.9l2.3-3.3l-0.2-1.8l-1.9-1.3
		l0.8-1.8l-1-1.4l-2.6-1.7l0.1-2l0-0.1l-0.1-2.6l0.8-0.1l0,0l0.1-0.1l0.1-0.1l0,0l0-0.1l-0.1-0.1l0-0.1l0-0.4l-0.1-0.2l0-0.4l0-1.4
		v-0.2l0-0.1v-0.4l0.3-0.5l0-0.2l0.2-1.4l0.4-2l-0.1,0l0-0.7l0.4-0.3l0.1-0.2l0-0.4l0.2-0.1l1-1.3l0.3-0.1l1.1-1.3l0.1-0.4l0.1-0.1
		l0.1-0.2l0.1,0l1.5-1.6v-0.1l0.2-0.3l0-0.1v-0.2l0-0.1h0.4l-0.1-0.4l0.1,0l0.2-0.2l0-0.1l0.4-0.1l0.1-0.1l0.2-0.3l0.1,0l0.1-0.1
		l0.1,0l0.3-0.1l0.1-0.1l0.3-0.1l-0.1,0l-0.1-0.1l0.1-0.1l0.1,0.1l0.1,0l0,0l0.2-0.1l0.1-0.1V618l0.2,0l0,0l0-0.1l0.4,0v-0.2h0.1
		v0.1l0.5-0.3l0.1,0l0,0l0,0l0.2,0.1v-0.1l1.3-0.8l0.1,0.1l0.6-2.9l-1.1-1.9l-0.2-0.1l-0.2,0l0,0.1l-0.1,0l0,0l0,0l0,0.1l-0.1-0.1h0
		l-0.2,0.1l0,0.1l-0.3,0h-0.1l-0.1-0.1l0,0.1l-0.6,3.2l-0.1,0l-0.9,0.9h-0.2l-0.6,0.2l-0.1,0.2l-0.2,0.4l-0.1,0.3l-0.4,0.3l-1-0.4
		l-1.6,0.6v0l0.1,0.1l0,0l-0.1,0.1l0,0l-0.1,0l0,0h0.1v0H314v0l-0.1,0l0,0l-0.1,0l-0.1-0.1l0,0l-0.1-0.1l0-0.1l0,0l0.1,0h0l0.2,0.2
		l0.1,0l0,0l0.1-0.1l0.1,0l0.1-0.1l-0.7-0.1l-0.1,0l0.1,0h0l-0.4,0l-0.1,0l-0.6-0.1l-0.1,0h0l0-0.1l-0.1,0l-0.1,0l0,0h0l0.2,0.1H312
		l-0.1-0.1l-1.2-0.5l-0.4,0h-0.5v0h0v0h0l0,0l-0.8,0l0.2-0.9l0.1-0.1l0-0.1v0l0.5-0.2l0-0.1l0.1-0.1l0.1-0.1l0.1-0.6l0-0.1l0.2-1
		l0-0.1l1-1.3l0.1-0.1l0.2-0.3h0.2l0.1-0.3l0-0.2l-0.8-1.1l-3.5-1.4l-2.5-1.8l-2.6-0.6l-3.3-3.3v-0.1l-0.1-0.1l-0.2-0.4l0,0
		l-0.1-0.1l-0.1-0.1h0l0,0h0l-0.2-0.1l0,0l-0.2-0.1l0,0l-0.1-0.1H298l0,0l-0.2-0.2l-0.1-0.1h-0.1v0l-0.2-0.2l0-0.2l-3.1-0.2
		L293.2,603.6z"
                />
                <polygon
                  className="WMst5"
                  points="272.7,489 272.3,487.7 272,487.3 273,485.5 272.7,484.1 274.8,483.5 277.7,484.2 278.6,485.9 
		280.9,486.3 282.2,487.3 281.3,488.4 279.7,487.7 277.9,487.7 277.2,488.4 274.6,488.1 273.7,490.2 	"
                />
                <polygon
                  className="WMst5"
                  points="561.3,565 564,565.9 565.1,571.3 564.2,572.8 564.9,574.4 565,576.1 566.5,576.4 569.3,579.8 
		569.3,580.3 569.2,581 569.2,582.1 569,583.7 567.8,584.2 567.3,585.9 565.3,584.3 564.9,583.3 565.8,581.5 565.1,579 563.4,579.3 
		562.1,577.9 561,576.6 561.2,574.4 562.4,573.8 562.1,569.2 563.3,568.2 562.4,566.2 	"
                />
                <polygon
                  className="WMst5"
                  points="272.7,484.1 273,485.5 272,487.3 272.3,487.7 272.7,489 271.9,488.4 269.8,488.6 268.2,488.3 
		266.9,489 265.2,487.8 266,487.1 269.6,487.8 271.2,487.1 269.8,486 271.2,484.1 	"
                />
                <polygon
                  className="WMst5"
                  points="587.3,504.8 589.3,504.1 590,506.1 589.7,507.6 588.8,508.9 585.6,508.6 585.7,508.1 585.7,506.8 	"
                />
                <path
                  className="WMst5"
                  d="M536.5,188.7l-8.6,3.1l1.9-6.2l3.5-4.5L536.5,188.7z M527.5,181.6l3.4-4.9l0.5,4.3L527.5,181.6z M516.7,199.3
		l-0.7,1.6l-2.9-2l-4.4-7.7l-0.9-7.3l10.6-5.3l-5.5-0.3l-6.8,3.5l-1.7-4.6l-2.4-2.7l-2.4-12l2.8-4.3l1.8,2.6l4-3.4l0.1,5.4l2.5-4
		l4.7,13.6l-2.2-13.7l1.8-4.1l4.8,4.9l2.5,9.5l2.7,1.7l4.1,4.7l-6.8,2.4l-1.7,13l-1.9-0.8L516.7,199.3z M532.4,150.6l0.9-3.3l1,6.5
		l3.1-4.1l8.2,4.9l-4.1,9.6l-5.1,3.4l-10.6-3.7l-3.6-3.8l0.7-10l1.7-2.8l3.5,5.1l2.4-1.1l1.2,4.7L532.4,150.6z"
                />
                <polygon
                  className="WMst5"
                  points="527.2,412.6 530,411.2 532.1,411 533.5,412 533.6,414.5 528.6,416.3 528.3,416.2 527.6,416.1 
		527.3,415.5 	"
                />
                <polygon
                  className="WMst5"
                  points="242.5,512.9 242.5,512.9 242.9,512.9 242.9,512.9 243,512.9 242.9,512.9 243,512.8 243.8,514.4 
		246.2,515.1 247.4,514.9 251.1,512.7 252.9,512.8 255.4,513.7 257.3,515.3 257.9,517.3 255.8,519.4 254.3,517 253.8,515 
		252.5,514.2 251,514.5 250.7,515.6 248.7,516.6 250,518.5 247.6,519.4 243.9,516.1 242,517.1 241.9,514.2 	"
                />
                <polygon
                  className="WMst5"
                  points="639.3,434.7 642.1,436 644.3,435.3 644.4,433.8 647,433.3 648.6,431.8 648.9,429.5 650.2,429.1 
		651.5,428.1 653.8,428.7 655,428.6 655.1,428.6 655.3,428.7 655.4,428.8 655.7,429.1 655.8,429.3 656.4,429.1 656.5,429 
		656.7,429.1 657.2,429.2 657.2,429.3 657.3,429.6 657.5,429.7 657.6,429.8 658.4,429.8 658.6,429.9 658.6,429.6 658.7,429.5 
		659.1,429.5 659.1,429.4 659.2,429.4 659.3,429.4 660.7,429 660.8,429.1 660.8,429.1 660.9,429.3 661.2,429.5 661.3,429.6 
		661.4,429.5 661.5,429.5 662.4,427.9 666.1,424.8 667.7,426.7 667.7,426.7 667.5,427.8 667.5,428 667.3,429.7 668.5,430.9 
		668.6,430.8 670.2,429.9 670.3,429.9 670.5,429.9 670.5,429.8 672.4,428.3 673.2,428.4 673.8,428.4 676.8,429.1 675.9,429.8 
		670.7,430.4 667.9,431.7 666.7,433.2 667.6,434.2 668,436 666.4,437.8 665.7,440.1 663.1,439.9 664.3,442.2 662,443.3 661.3,445.1 
		661.5,446.8 660.2,447.9 658.3,447.1 654.3,449.1 653.4,450 653,452.7 651.8,453.8 651.7,453.9 649.3,454.4 649.3,454.4 
		647.1,454.9 645.7,454.6 642.6,454.9 638.2,453.4 640.8,450.3 640.7,448.8 639.5,448.4 639.3,448.4 638.2,448.2 638.2,445.9 
		637.4,442.9 637.2,439.8 638.5,437.9 	"
                />
                <polygon
                  className="WMst5"
                  points="536.3,366.6 536.3,366.6 536.3,366.6 536.3,366.6 536.3,366.6 536.3,366.6 535.2,362.7 537.4,363 
		537.5,363 540.9,361.3 541.3,361.7 541.5,358.5 543.8,357.1 543.6,355.7 543.8,354.5 543.9,354.4 543.9,354.4 545.5,354 548,352.1 
		549.5,352.5 549.6,353 549.7,353.1 553,353.6 553.3,353.7 554.1,353.8 554.1,353.8 554.2,353.9 554.3,353.9 555.7,354.8 
		556.4,359.7 556.4,359.7 556.4,359.7 556.4,359.7 556.2,359.9 556.3,359.9 556.2,359.9 556.3,359.9 556.8,361.4 559.9,363.7 
		560.7,365.2 559.3,366.7 557,366.2 556.9,367.5 558,371.2 555.6,371.7 555.6,371.8 555.4,372.1 555.2,372.1 555.1,372.3 555,372.5 
		554.9,372.7 554.9,372.8 554.9,372.9 554.8,373 554.6,373.4 554.6,373.4 554.5,373.5 554.6,373.5 554.6,373.6 554.9,374.5 
		554.8,374.6 553.1,374 553,374 553,374 553,373.9 549.7,374 548.3,373.1 539.6,371.9 537.5,372.3 535.6,373.8 535.5,372.4 
		535.5,372.4 535.7,371.4 535.6,371.4 536.4,368.4 	"
                />
                <path
                  className="WMst5"
                  d="M506.6,555.3l0.5,0l0.3,0l8.4,0l0.1,0l0.7,1.3l0,0l0.4,1.5h0.1l0.1,0.4l0.1,0.1l0.7,1.1l-0.1,0.1l0.4,0.4
		l0.1,0v0.2l0,0l0.4,0.7l0.1,0.1l0.1,0.1l0,0l1.6,0.2l1.2-0.5l2.3,0.2l0.5-2.8h2l0.7,0.6l3.4,0.2l0,1.3v0.1l0,0.5l0,0l0.3,0.4l0,0
		l-0.2,3.4l1.1,1.4l0.9,3.1l1.9,0.2l2.2-0.6l0.2,5.9h-5.7v9.1l0.3,0.8l3.6,3.3l-5.5,1.1l-3-0.4l-4-0.1l-1.3-1.2l-12.4-0.1l-1.8-1.1
		h-0.1l-2.2,0.7l-1.8,0.1l-0.1-4l1.2-2l1-5l2.6-2.6l0.8-1.5l0.3-2.6l-1.5-2.9l-0.9-2.5l1.1-1.9l-1.5-3.9l-1.5-2.3L506.6,555.3z
		 M503.6,552.9l2.1-1.8l0.9,0.7v0.1l-1.8,1.1l-0.7,1.9L503.6,552.9z"
                />
                <polygon
                  className="WMst5"
                  points="301.1,510.8 302.3,510.6 302.3,509.7 300.7,509.6 	"
                />
                <path
                  className="WMst5"
                  d="M593.8,420.4l2.8,0.5l1,2.6l-2-0.8l-0.6-0.4l-1.1-1.5v-0.1l0,0L593.8,420.4z M594.5,414.7l0.6-0.5l3.5,1.4
		l0.6-0.8v0l-0.1-0.1h-0.1l-0.1-0.1h0l-0.8-0.5h0l-0.2-0.4v0l0,0h-0.2v0l0.6-1l0.9,0.2l1.5,2l1.3,0.4l2.2-2.4l2.6,4.4l-0.7,4.5
		l-1.4,1.7l0.2,1.6l-2.4-1.4l1-1.9l-1.8-0.7h-0.1l-3.2,2.5l0.3-1.3l-3.3-4.6l0.3-1.3L594.5,414.7z"
                />
                <polygon
                  className="WMst5"
                  points="280.7,505.9 281,506 279.9,505 	"
                />
                <path
                  className="WMst5"
                  d="M526.3,396.3l0.7-0.2l1.9-0.7l3.1-5.7l1.6-0.7l0.7-0.7l1.9,0.8l4,0.1l2.4-0.3l1.2-1.1l1.1,0.5l0,0l0.2,0.4
		l0.1,0.2v0.2l0.1,0l0.1,0.3l0.6,1.2l0,0l0.3,0.7l0.1,0.2v0h0.1l0.4,0.4l0.1,0.2l0,0l0.7,0.4v0l0.1,0.3v0.2l0.1,0.1h0l0.1,0.1h-0.1
		v0l0.1,0.2h0l0.2,1.5v0l-0.2,0.4h0l0,0.4v0l0,0l0,0l0,0.2v1l0,0.1v0.2l0,0v0.1l0.1,0.1l0,0.2v0l-0.2,0.5l0.1,0.1h0.1l0.2,0.4
		l0.3,0.4l0.1,0.2l0.2,0.1l0.3,0.1l0.2,0.1l0.4,0.1h0.1l0.1,0v-0.1l0-0.2l0-0.1l0.4,0.1h0l0.1,0v0l0.1-0.1l2,0.5l-0.3,1.4l-1.8,0.2
		l-1.1,2l0.1,2l-4.5-1.5l-0.2,0l-0.1,0l-0.3,0.1l-0.7,0.1l-0.8,0.2l-0.3,0.1l-0.6,0.7l-0.2,0.1l-0.2,0.2l-0.3,0.1l-0.1,0.1h-0.8
		l-0.1-0.1l-2.3-0.2l-0.1,0.1l-0.1,0.1l-1.4-0.3l-0.1,0l-0.1-0.1h-0.5l-0.2-0.1l-0.1,0h-0.7l-0.2,0.1l-0.1,0l-0.6-0.1l-0.1,0
		l-0.1-0.2l0,0l0.1-0.2l-0.5-1l0-0.1l-0.4-0.5l-0.1-0.3l0-0.1l0.2-0.1l0.1-0.2l0.2,0l0.2,0.1l-0.1-0.3l-0.3-0.1l-0.2-0.2l-0.1-0.1
		l-0.7,0.5l-0.2,0.3l0,0.1h0l-0.4-0.3v0l0-0.1l-1.7-0.7l-0.1-0.2l-1.5-3.7L526.3,396.3z M534.2,405.3L534.2,405.3L534.2,405.3
		L534.2,405.3z M531.7,402.6L531.7,402.6L531.7,402.6L531.7,402.6z"
                />
                <polygon
                  className="WMst5"
                  points="665.9,411.2 665.3,414.1 666.9,415.4 667.7,414.7 671.1,416.3 671.3,416.4 670,418 668.1,418.9 
		666.1,418.6 664.3,417.8 664.3,417.8 664.4,417.7 664.5,417.6 664.6,415.6 659.6,419.9 659.4,421 657,420.6 657,422.9 658.4,423.2 
		658,425.1 658.6,426.8 657.5,427.7 657.3,429.3 657.2,429.3 657.2,429.2 656.7,429.1 656.5,429 656.4,429.1 655.8,429.3 
		655.7,429.1 655.4,428.8 655.3,428.7 655.1,428.6 655,428.6 653.8,428.7 654,426.4 651.1,425.4 646.8,422.7 642.6,419.5 
		641.2,415.8 641.1,415.6 640.8,415.2 639.7,415 637.1,415 636,414.2 635.8,411.3 634.6,411 632,409.1 630.9,409.7 630.8,409.9 
		629.3,411.5 627.7,412.4 627.6,414.8 624.8,414.6 624.8,400.8 632,398.5 632.4,398.8 638.9,403.2 641.3,406.5 645,405.9 
		648.3,406.2 649.6,405.7 651.9,408.9 652.3,412.3 653.8,412.6 654.3,415.3 657.8,415.3 657.8,415.5 657.8,415.5 658,415.6 
		659.7,415.8 659.7,415.9 661,414.2 	"
                />
                <polygon
                  className="WMst5"
                  points="506.1,389 506.1,389 506.1,387.9 506.1,387.9 506.5,387.6 506.7,387.6 506.9,387.6 507.1,387.5 
		507.4,387.1 507.5,387.1 507.5,386.9 507.9,386.5 507.9,386.4 508.6,385.6 510.7,386.2 511.7,385 511.8,384.9 514.1,385.1 
		517,385.8 517.1,386.2 516.9,387.3 517,387.4 517.4,388.2 517.5,388.2 517.8,388.7 516.8,390.1 516.4,389.8 515.1,393.1 
		514.9,393.4 511.7,394.5 510.6,395.4 508.2,394.8 504.6,394 503.8,392.6 499.3,393.5 496.9,392.6 496.7,391.8 496.8,390.8 
		497.3,390.7 498.9,391.6 502.5,390.5 505.6,390.1 	"
                />
                <polygon
                  className="WMst5"
                  points="615,413 616.5,411.7 619.9,410.7 621.8,412.4 623.2,414.8 624.8,414.6 627.6,414.8 627.7,412.4 
		629.3,411.5 630.8,409.9 630.9,409.7 632,409.1 634.6,411 635.8,411.3 636,414.2 637.1,415 639.7,415 640.8,415.2 641.1,415.6 
		641.2,415.8 642.6,419.5 646.8,422.7 651.1,425.4 654,426.4 653.8,428.7 651.5,428.1 650.2,429.1 648.9,429.5 648.6,431.8 
		647,433.3 644.4,433.8 644.3,435.3 642.1,436 639.3,434.7 639.2,433.6 639.1,433.5 639,431.1 636.8,431.2 635.9,429.8 634.6,429.4 
		634,428.1 631.4,427.7 628.8,426.7 628.1,425.5 625.7,426.2 623.2,426.1 621.1,428.4 619.2,428.7 618.7,426.7 619.3,423.1 
		618,421.9 618.3,419.3 615.9,419.4 616.5,416.8 618.5,417.2 620.7,416.9 621.5,415.6 619.3,413.7 618.8,411.6 	"
                />
                <polygon
                  className="WMst5"
                  points="526,331.2 526.3,330.6 525.1,329.8 	"
                />
                <polygon
                  className="WMst5"
                  points="715.5,461.3 717.4,458.7 720.1,459.2 722.2,459 722.7,459.7 722.8,459.8 722.8,459.8 724,460.8 
		724.2,462.8 721.1,463 721.1,463 718.1,463.2 716.7,462.8 716.7,462.8 	"
                />
                <polygon
                  className="WMst5"
                  points="301.7,502.5 301.9,502.9 302,502.2 	"
                />
                <path
                  className="WMst5"
                  d="M714,463.6L714,463.6L714,463.6L714,463.6l0.9,0.9l0.6,0l0.1,0.1l2,0.2v0l0.4,0.5l0.1,0.2l-0.1,0.2v0.5l0,1.3
		l2.3,0.4l3.9,0l0,2.3l-2.1,0.9l-0.6,1.1l0.5,1.9l1.2-0.4l1.3-1.5l0.9,5.2l-1.2,2.4l0.1,0.1h0l-0.8-1.9l-0.2-1.2l-1.2-1.9l-2.1,1.5
		l-1.1,1.4l-1.8-2.2l-1.4,1l-0.2-0.3v0l-0.8-5.3v-0.1l0-0.1l0-0.1v0l0.1-0.2l-0.1-0.1l-0.8-0.2l-0.1-0.1l-0.3-0.2l-0.6-0.6l1.7-2.5
		l-1.5-1.3L714,463.6z M715.6,464.5L715.6,464.5l-0.1,0v0L715.6,464.5z"
                />
                <polygon
                  className="WMst5"
                  points="625,465.2 625.5,466.5 625.8,468.5 624.3,468.7 623.6,472.5 622.6,475.3 615.3,474.6 612.6,470.7 
		614,471.6 615.4,470.8 616.9,471.3 619.2,471.2 620.7,470.5 622.8,467.3 	"
                />
                <polygon
                  className="WMst5"
                  points="558.6,612.8 559,615.5 558.5,617 558.4,617 556.3,616.6 555.3,614.7 556.8,612.1 	"
                />
                <path
                  className="WMst5"
                  d="M540.1,588.7l1.2,0.1h0v0l0.1,0.1l0.2,0.1v0v0l0.2,0.2l2.2,0.4l0.2,0l0.2-0.1l0.1,0l0.8-0.3l2.8-3l1.8-0.9
		l0.3-0.5l0-0.1l0-0.2l0-0.1l0.1-0.7l0.4-0.1l1-0.7l0.1-0.1l1-0.2l0.1-0.1l1.7,0.1l0,0v1.1l2.4,0l1.7,1.1l2.5,0.8l0.7,1.8l0.1,2.9
		l-0.7,3.8l0.1,1.8l-1,1l0,2h-0.2l-3,3.2l-0.6-0.2h-0.1l-4-0.6l-0.1,0l-0.6,0.1l-0.1-0.1l-0.8-1.1l-2.9-0.7l-0.9-1.4l0.1-1.7
		l-1.4-1.2l-2.9-1.6l-0.5-1.7l-1.8-2.6L540.1,588.7z M551.4,601.5L551.4,601.5L551.4,601.5L551.4,601.5z"
                />
                <polygon
                  className="WMst5"
                  points="486.5,382.3 488,382.7 488,382.5 488,382.4 488,382.2 488,382.2 488.2,382 488.4,381.6 488.4,381.6 
		488.4,381.6 488.4,381.6 488.4,381.5 488.4,381.3 488.5,381.2 487.5,380.6 487.5,380.6 487.4,379.9 	"
                />
                <path
                  className="WMst5"
                  d="M249.4,548.6L249.4,548.6L249.4,548.6l0.2,2.3l1.8,0.6l1.3,1.4l1-1.2l0.9-3.3l1.4-1l3.2-1.1h0l3.1-2.9l0.9-2.1
		l0-0.1l0-0.5l0,0l-0.1-1.3l1.2,0.2l2.2,2.2v0.1l0,0.1l0.1,0.1l0.3,0.4l0.1,0l0.1,0h0.1v0l0.1,0l0.3,0.2l0.1,0.1l0.7,1.3l0,0
		l0.1-0.1l0,0.1l0.1-0.1l0.1,0.1l0.1,0.2l0,0.1h0l0,0v0l0,0v0.2l0,0.1l0,0.1v0.1h0v0.1l-0.1,0.5l0,0.1l0,0.1h0.1l0.2,0l0.1,0
		l0.6,0.1l0,0.1l0.1-0.1l0.1,0l0,0.1l0.1,0.1l0.2-0.2l0.1,0.1l0.5,0.2l0.1,0l0.6-0.3l0.2,0l0.2-0.1l0.2,0l0.4-0.4l0-0.1l0,0.2l0.2,0
		l0.4,0.1l0,0.2v0.1l0.1-0.1l0,0v-0.1l0.2,0.3h0.2l0.1,0v0h0.1l0-0.1l0.1,0.1l0.1,0l0.5-0.2v-0.1l0.4-0.1l0,0.1l0.8,0.5v-0.1
		l0.2,0.1l0.1,0.1l0.6,0.2l0,0.2l0.1,0l0,0l0.3,0.3l-1.5,3l0.4,0.1l0.2-0.1h0l0.2-0.1h0l0.4,0.4l0.1,0.2l0.1,0.1l0.1,0.2l0.2,0.3
		l-0.1,0.2l-0.1,0.1l-0.1-0.2l0.1,0l-0.1-0.1h-0.1l-0.1,0l-0.1,0.1l-0.1,0.1l-0.1,0l-0.2-0.1l0-0.1l-4.5,0.6l-2.7,1.7l-1,2.5
		l0.3,1.3l-1.6,0.9l-0.7,1.9l1.2,2.3l1.6,1.7l-0.7,1.2l2.3,0.2l0.5,1.4l2.7-0.1l1.9-1.3l0,0l-0.1,0.1l0,0l0,0.1l0,0l-0.1,4l2.9-0.1
		l2.5,4.3l-1.1,3.3l0.2,1.6l-1,1.5l0.1,2.1l-1.5-0.7l-0.4,1.6l2.6,1.1l0.3-0.1l-0.2,1l0,0.2v0.1l-1.7,1.7l0.5,0.6l-1,0.6l-0.1,1.3
		l-1.4,0.5l-2.8-1.8l-0.2-1.2l-2.6-1.7l-3.5-1.3l-4-2.4l-3.1-3.4l0.2-2.3l-2.8-4.9L255,567l-2.2-5.3l-1.3-1.4l-1.4-2.7l-3.2-2.1
		l0.8-1l-1-1.1l-0.1-2.6l2.1-2.1L249.4,548.6z M267.2,542.5L267.2,542.5L267.2,542.5L267.2,542.5L267.2,542.5z M276,545.8L276,545.8
		L276,545.8L276,545.8L276,545.8z M276.4,549.7L276.4,549.7L276.4,549.7L276.4,549.7L276.4,549.7z"
                />
                <polygon
                  className="WMst5"
                  points="613.8,486.2 622,483.3 623.9,477.4 622.6,475.3 623.6,472.5 624.3,468.7 625.8,468.5 627.7,471.4 
		632.4,472.9 635.3,476.7 634,479.1 632.1,481 631.7,482 629.8,482.7 629.4,484.1 629.8,486.3 627,486.9 625.7,489.3 623.2,489.6 
		622.1,491.9 619.8,491.9 616.8,492.9 	"
                />
                <polygon
                  className="WMst5"
                  points="543.8,387.7 547,386.9 548.1,387.9 550.9,388.8 550.8,390.8 553,394.1 553,394.5 552.8,394.7 
		552.8,394.7 552,395.4 550.3,394.9 550.3,396.8 548.8,398.8 548.8,398.8 548.2,398.9 548,398.5 548,398.5 547.9,398.5 548.1,398 
		548.1,397.9 548,397.8 547.9,397.7 547.9,397.6 547.9,397.6 547.9,397.4 547.9,397.3 547.9,396.2 548,396.1 548,396.1 548,396 
		548,395.7 548,395.7 548.2,395.2 548.2,395.2 548.1,393.7 548.1,393.7 547.9,393.5 547.9,393.5 548,393.5 547.9,393.3 547.9,393.3 
		547.9,393.3 547.9,393.1 547.7,392.8 547.7,392.7 547,392.3 547.1,392.2 547,392 546.6,391.6 546.5,391.6 546.5,391.5 546.4,391.4 
		546.1,390.7 546.1,390.7 545.5,389.5 545.4,389.2 545.3,389.1 545.3,388.9 545.2,388.7 545,388.3 544.9,388.3 	"
                />
                <polygon
                  className="WMst5"
                  points="598.7,455.8 600.4,452.9 602.6,452.9 603.9,457.6 601.9,457.6 601.3,456.1 	"
                />
                <polygon
                  className="WMst5"
                  points="760.4,499.5 762.5,500.7 762.5,500.7 762.6,499.4 764,498.8 764.9,499.6 766.8,498.5 766.2,500.1 
		767,502.4 766.8,505.1 765.8,505.2 763.8,507 762,507.1 761.9,508.8 760.5,509.2 760.5,509.1 760.1,509.1 760.1,509.1 759.4,510.2 
		758.3,510.5 756.2,509.3 754.6,509.2 754,507.1 752.9,504.2 752.5,501.7 753.2,501.6 754.8,499.5 759.3,499.2 	"
                />
                <polygon
                  className="WMst5"
                  points="222.1,501.2 223.8,499.8 223.7,499.6 224.2,499.3 226.6,500.7 228.8,501 228.5,502.1 228.2,502.8 
		223,501.8 	"
                />
                <path
                  className="WMst5"
                  d="M311.7,626l1.4-0.2v-0.1l0.7,0l2.2,2.2l1.2,0.1l0.9,1.4l1.8,0.6l2.3,2l1.1,1.6l0,0l0.5,0.2l-1.4,1.6l0.4,1.5
		l0.4,0.5l-1.1,2.2l-3.2,1.9l-2.1-0.7l-1.3,0.6l-2.7-1.6l-2,0.1l-1.6-1.9l0-0.1l0.7-2.7l0,0l0.2-0.2l0-0.1l-0.1-0.1l0-0.1l0-0.4
		l-0.1-0.2l0-0.4l0-1.4v-0.2l0-0.1v-0.4l0.3-0.5l0-0.2l0.2-1.4l0.4-2l-0.1,0l0-0.7l0.4-0.3l0.1-0.2l0-0.4L311.7,626z M310.3,635
		l0-0.2l0,0.1L310.3,635L310.3,635z"
                />
                <polygon
                  className="WMst5"
                  points="502.3,442.8 502.3,442.8 502.1,443.3 502.3,445.1 499.8,446.6 498.4,448.2 498.8,450.1 497.5,451.9 
		497.3,452 496.8,452.2 495.5,446.3 493.5,444.9 492,442.7 491.2,439.8 493.4,437.6 493.2,433.7 494.3,430.1 497.7,429 499.1,430.9 
		499.2,432.9 500.9,434.6 501.2,435.9 500,437.9 498.1,439.6 499.2,441.3 500.8,441.2 	"
                />
                <polygon
                  className="WMst5"
                  points="564.9,449.1 565.5,447.9 567.2,443 569,442.2 569,444.1 568.4,445.3 567.1,445.1 566.7,448.7 
		568,448.2 568.1,448.8 568,449 568.1,449.6 566.9,454.4 566.6,454.6 	"
                />
                <polygon
                  className="WMst5"
                  points="488.3,538.5 488.8,538.9 489.1,538.3 488.8,538 	"
                />
                <polygon
                  className="WMst5"
                  points="296.6,488.9 296.8,488.9 296.8,488.9 296.7,488.7 	"
                />
                <polygon
                  className="WMst5"
                  points="600.2,582 600.1,581.2 602,579.6 602.2,578.5 605.2,575.8 605.2,573.8 606.2,572.6 608.1,575.2 
		608.6,577.3 608.7,580.1 609.6,581.5 607.2,582.3 607.9,584.2 606.7,587.2 606.9,588.4 602.5,602.2 600.2,609.9 595,611.8 
		592.7,610.7 590.8,608 591.2,605.6 590,603.5 589.6,601.7 590.3,599.1 593.1,595 591.5,588 592.9,585.6 595.2,583.4 596.3,583.8 
		598.5,582.2 	"
                />
                <polygon
                  className="WMst5"
                  points="511.8,474.4 514.6,472.9 525.7,478.7 536.6,484.7 536.6,495.6 534.2,495.6 533.9,497 532.1,498.9 
		532.6,500.1 531.3,501.1 531.9,502.3 530.6,503.8 532.4,504.3 532.6,507.1 533.8,508.1 533.5,509.1 532.4,508.9 530.3,509.9 
		530.3,510.8 526.8,514 522.7,514.5 523.2,515.3 521.8,517.1 519.3,517.2 516.9,518.5 516.2,517.5 514.5,518.6 513.1,518.5 
		513.4,518.1 512.1,515.4 510.4,514.3 509,512.7 509.6,511.6 513.6,511.6 513.5,511.5 512.2,510 512.2,509.8 512,509.5 512,509.4 
		512,507.7 512,507.6 512.2,507.4 512.2,507.3 512.1,507.2 512,507.1 512,506.9 512,506.9 512,506.8 512.1,506.8 512.1,506.5 
		512,506.5 511.9,506.2 512,506.1 511.8,505.7 511.6,505.7 511.5,505.6 511.5,505.6 511.4,504.5 511.4,504.4 510.6,503.6 
		510.6,503.5 510.5,503.4 509.9,503 509.3,503 508,501.3 507.6,499.2 510.1,495.5 513.2,492.2 513.9,483.5 514.6,482.2 512.3,478.9 
			"
                />
                <polygon
                  className="WMst5"
                  points="463.1,513.1 462.7,508.8 468.8,509.1 470.1,508.5 470.3,509.9 471.6,510.8 471.1,513.2 472,513.3 
		471.9,520.4 473.8,522.4 472.5,523.3 470.7,523.5 464.8,526.2 462.4,525.1 461.5,521 462.8,517.3 463.6,516.6 	"
                />
                <path
                  className="WMst5"
                  d="M837.3,440.3l1.2-1.2l1.6-0.5l1.2,0.5l-0.8,2.2l-2.1,0.1l-2.5,2.6l-0.7-1.8l1.4-2.6L837.3,440.3z M839.6,438
		l-3.7,1.4l-1.4,1.2l-2-2l4.7-4l0.9,0.5l3.1-0.7l3.2,0.6l1.1-2.6l2.4-2.1l0.6,0.4l3.6-2.1l0.8-1.6l1.5-1l1.3-2.8l0.7-2.9l-0.6-3.2
		l1.3-0.9l0.1-1.4l2.4,1.1l1.7,2.5l0.7,2.6l-0.4,1.6l-2.7,3.3l0.1,4.1l-1.2,2.5l0.8,1.8l-1.3,1.9l-1.7-0.4l-3,0.6l-1.3,1.8l-3.3,0
		l-0.9-1.6l-1,2.9l-1.5,2.5l-1.9-1.5l1-2.1l-2.6-1L839.6,438z M829.5,442.8l0.7-2.4h1l1.7,2l1.6,1.1l-1.1,1.2l-0.9,3.8l-1.9,1.2
		l-0.9-1.8l0-1.8l0.9-1.7L829.5,442.8z M865.2,412.3l-4.2-2.7L859,411l-1.4-1.1l-1,2.3l-0.9-2.4l1.9-1.4l1.8-0.6l0.5-2.2l0.9-0.8
		l0.4-2.6l-0.6-2.4l1-1.1l2.9,3.7l2.1,1.7h1.4l2.3,1.3l0.6,1.9l-0.9,1.2l-1.9-0.1l-2.2,1.7L865.2,412.3z"
                />
                <polygon
                  className="WMst5"
                  points="497.5,532.8 501.8,533.2 501.7,536.4 497.5,536.4 497.4,536.3 497.4,536.3 496.2,535.9 497.5,533.9 	
		"
                />
                <polygon
                  className="WMst5"
                  points="471.1,497.6 473.1,497.7 474.1,496.8 478.8,496.4 480.1,496.6 481.2,495.6 482,493.6 482.2,485.8 
		486.5,484.9 491.2,480.7 503.5,472.9 507.8,473.9 509.7,475.6 511.8,474.4 512.3,478.9 514.6,482.2 513.9,483.5 513.2,492.2 
		510.1,495.5 507.6,499.2 508,501.3 505.8,502 504.7,503.1 502,502.2 499.8,502.3 498,502.8 497.1,503.8 494.4,503.5 492,502.3 
		489.6,503.3 488.2,501.6 485.6,500.8 482.8,501.4 481.8,503.3 480.5,504.6 480.4,506.9 480.3,506.9 480.3,506.8 480.2,506.8 
		479.5,506.2 479.5,506.1 478.3,505 477.1,506.4 476.2,505.1 474.8,504.4 472.2,501.3 470.9,499 	"
                />
                <polygon
                  className="WMst5"
                  points="474.5,410.5 475.2,410.3 474.4,409.9 	"
                />
                <polygon
                  className="WMst5"
                  points="590.2,415.3 594.5,414.7 596,416.2 595.7,417.5 599,422.1 598.7,423.4 597.6,423.5 596.6,420.9 
		593.8,420.4 592.6,419.3 590.8,419 590.8,417.3 590.9,417.1 	"
                />
                <polygon
                  className="WMst5"
                  points="147.7,444.8 154.3,444.3 154.2,445 164.4,448.7 172.3,448.7 172.3,447.3 176.9,447.3 181.3,451.1 
		182.5,454.1 185.8,456.2 187,455.4 187.5,453.8 188.5,453.3 190.7,453.7 190.7,453.7 191.2,454 191.2,454 191.3,454.3 191.4,454.3 
		191.5,454.2 191.6,454.5 191.7,454.5 192,454.7 193.1,455.9 194.1,458.3 196.3,460.6 196.4,462.1 196.4,462.2 196.7,462.6 
		196.9,462.9 197.4,464.1 199,464.7 199.1,464.8 199.1,464.7 199.4,464.9 199.4,464.9 199.7,465.1 199.8,465.1 201.4,465.4 
		202.1,465.9 202.5,465.5 202.6,465.5 202.7,465.5 202.7,465.5 202.8,465.5 202.1,467.2 200.9,467.6 201.2,470.6 200.9,476.4 
		201.3,478.3 202.7,481.4 204.4,483.5 205.1,485.3 206.4,486.7 209.2,487.5 209.7,488.6 214.4,487.8 218.6,486.5 220.3,485.3 
		221.2,483.4 221.1,481.8 221.7,480.2 223.3,479.5 227.6,478.5 229.1,478.9 231.3,480.3 228.7,484.2 229.5,485.3 228.4,488.4 
		227.1,487.6 224.8,489.6 219.7,489.6 219.8,492.3 219.8,492.3 220.6,493 220.8,493.4 220.8,493.4 221.4,493.8 221.4,493.8 
		221.3,494 221.2,494 221.2,494.6 217.8,494.6 216.4,496.9 216.3,498.9 212.3,494.8 209.1,493.5 207.5,494.8 204.4,495.7 
		202.6,494.9 201,494.8 198.3,493.2 196,492.7 193.9,491.6 192,491.2 189.5,489.1 188.9,489.3 185.3,488.1 184.6,486.9 181.3,485.3 
		179.2,482.1 180.2,481 180.6,479 180.2,476.8 177.2,473.9 175.2,471 172.9,469.5 172.8,468.2 171,466.8 169.9,466.7 168.9,465.4 
		168.7,463.1 166.2,461.4 165.9,459.7 164.3,459.4 162.6,457.8 160.7,455.1 158.8,450.8 158.9,449.3 155.9,448.2 154.1,447.2 
		153.7,448.8 154.4,450.1 154.8,452.9 157.3,455.2 159.7,459.7 163.1,463.2 163.7,466.1 165.4,468.8 165.8,470.8 167.8,471.3 
		168.9,473.1 167.3,474.7 166.4,472.8 161.4,468.5 161.9,466.9 161.3,465.4 158.4,463 157.4,463.2 155.1,461.8 156.2,457.8 
		153.7,455 151.6,453.8 150.6,450.4 148.9,448 	"
                />
                <polygon
                  className="WMst5"
                  points="756,535.8 757.1,535.6 756.4,535.2 	"
                />
                <polygon
                  className="WMst5"
                  points="761.3,568.1 761.6,568.3 761.7,567.9 	"
                />
                <path
                  className="WMst5"
                  d="M522.9,401.3h0.9v0.1l-0.1,0.3v0.1l-0.3,0.6l0,0l0.3,1.3h0l0.6,0.7h0l-0.4,0.4l-0.1,0l-0.4,1.7l-0.9,0.1
		l-1.2,2.5l0,0.2l-0.1,0.8l-2.2-1.2l-0.2-0.2l-1.2-2.2l0,0l-2.5-2.7l-1.3-2.4l3.2-1.6v0h0.3v0.1l0.1,0h0l1.3,0.3v0.1l1.2,0.1v-0.1
		l0.3-0.2h0l0.5,0.2l0,0l0.9,0l0,0l0,0l0,0v0l0.1,0v0l0.1,0h0.1L522.9,401.3z M521.7,400.5L521.7,400.5L521.7,400.5L521.7,400.5
		L521.7,400.5z M521.7,400.5L521.7,400.5L521.7,400.5L521.7,400.5z M521.9,400.5L521.9,400.5L521.9,400.5L521.9,400.5L521.9,400.5z"
                />
                <polygon
                  className="WMst5"
                  points="908.7,561.4 907.9,560 910.9,562.1 910.6,562.3 	"
                />
                <polygon
                  className="WMst5"
                  points="455.3,510.5 455.3,508.6 456,506.7 458.3,505.2 458.5,502.9 459.5,502.2 461,502.8 461,502.7 
		461.5,501.3 463.7,499.6 466.9,498.4 468.5,497.4 471.1,497.6 470.9,499 472.2,501.3 474.8,504.4 476.2,505.1 477.1,506.4 
		476,507.7 474.8,507.6 474.8,507.6 473,508.9 470.1,508.5 468.8,509.1 462.7,508.8 463,513.1 461.7,511.8 459.1,512.1 458.6,512.8 
		456.8,512 	"
                />
                <polygon
                  className="WMst5"
                  points="588.3,493.6 589.6,492.9 589.9,490.3 591.2,491 595.1,490.7 597.5,491.2 599.3,491.1 600,492.1 
		601.3,491.6 603.2,488.6 605.8,487.3 613.7,486.2 616.8,492.9 614.4,494.2 614.3,495.9 612,497 606.2,498.7 604.6,500.3 
		602.7,500.3 601.1,501.4 599.1,502.1 596.3,502.3 594.1,504.1 591.6,504.4 590.2,504.2 588.8,497.9 588.1,496.6 	"
                />
                <polygon
                  className="WMst5"
                  points="526.5,409 527,408.5 527,408.5 527,408.5 527.9,407.4 529.4,409.4 530,411.2 527.2,412.6 525.8,410 	
		"
                />
                <polygon
                  className="WMst5"
                  points="450.5,357.5 450.1,358 450,358.1 449.9,358.3 450,358.4 448.8,360 448.8,360 448,360.5 448.1,360.6 
		450,361.8 450,361.8 450,361.9 450.1,361.9 451.1,360.6 453.1,362 453.9,367.3 452.9,370.1 449.6,371.7 447,373.4 445,374 
		443.7,370.9 444.9,366.5 443.5,365.8 444.1,363 447.1,359.8 447.6,357.1 449.7,356.4 	"
                />
                <polygon
                  className="WMst5"
                  points="521.5,410.6 521.3,410 521.4,409.3 521.3,409 522.6,406.5 523.4,406.4 525.9,408.5 526.5,409 
		525.8,410 524.6,409.8 523.8,412.3 523.8,412.4 523.8,412.6 	"
                />
                <polygon
                  className="WMst5"
                  points="424.3,503.1 426.9,502.8 428.9,501.6 424.9,501.6 423.1,498.6 424.9,495.4 425,494.6 425.1,494.6 
		425.5,493.4 428.9,493 429,493 431,493.1 432.3,494.5 433.8,495 433.8,495 433.9,495.3 433.9,495.4 434.4,496 434.4,496.1 
		436.2,497.9 436.2,498 436.7,498.3 437.6,500.7 439.2,503.3 439.1,504.9 435.9,505 434.4,504.3 432.7,504.2 428.7,504.1 
		427.3,504.9 424.5,505.1 425.1,504.7 	"
                />
                <polygon
                  className="WMst5"
                  points="508.2,394.8 510.6,395.4 511.7,394.5 514.8,393.4 516.2,394.9 515.1,395.3 515,395.3 513.7,395.9 
		513.7,397.5 512.4,399.1 507.9,398.9 508.3,398.5 507.4,395.6 	"
                />
                <polygon
                  className="WMst5"
                  points="424.9,501.6 424.3,503.1 426.9,502.8 428.9,501.6 	"
                />
                <path
                  className="WMst5"
                  d="M660.3,470.5l3,0.4l0.6-0.5l-0.2,1.2l2,0l0.8,1.4l-2.3,0.7l-1.7,1.4l-2.6-1l-0.8-1.4l1.5-0.6L660.3,470.5z
		 M665,470.6l1.3-0.3l-0.2-0.3l-0.9-2.8l-1.6-1.6l0.2-1.9l-1.8-0.6l0.2-1.4l2.1-2.6l1.4,1l2.8-0.8l1.3-2.5l1.6-0.8l1.2-2.9l1.6-0.8
		l0.9-1.8l0.1-0.1l1-2L676,447l1.9-0.9l-1.7-1.7l-0.1-0.1l-1.8-1.6l-0.1-4.9l0.9-0.4l4,0.9l3.4-1.4l-0.6-2.4l2.5,0.7l1.4,2.4
		l2.3,1.4l-0.8,2l-0.2,0.2l2.1,3.2l-1.6,1l-0.3,3.5l3,1.1l0.9,1.2l2.3,1.2l-1.3,1.1l-1.2,2.8v0.5l2,1h0l2.5,1.7l0,0l2.7,1.3l3.1,0.4
		l0.8-0.5l1.3,1.4l1.9,1l1.8,0.3v0v0v0h0.1l2.2,0.6l0,0.1l0.4-0.3l1.1,0.5l2.1-0.7l0-0.1l0.1-0.3l0,0v-0.1l-0.5-1.5l0.1-0.6h0h0h0
		l0.1-0.1l0.2-1.4h0l2-0.4l0.2,2.1l1.2,1.4h0l1.3,0.5l3-0.3l0.1,0l3.1-0.2l-0.2-1.9l-1.2-1.1v0l2.5,0.1l0.6-1.1l3.4-1.9l2.1-1.7
		l1.7,0.7l2.4-0.9l1.4,2.3l1.9,1.2l0,1l-2,1.6l-1.4,0.5l-2.6,1.9l0.1,1.7l-1.5,2l0.3,1.2l-1.6,3.5l-2.3-0.7l0.1,2.9l-0.7,0.2
		l0.2,2.4l-1.7,0.8l-0.9-5.2l-1.4,1.5l-1.2,0.4l-0.5-1.9l0.6-1.1l2.1-0.9l0-2.3l-3.9,0l-2.3-0.4l0-1.3v-0.5l0.1-0.2l-0.1-0.2
		l-0.4-0.5v0l-2-0.2l0.1-0.1h-0.1l0,0v0l0,0.1l-0.6,0l-0.9-1l0,0v0l0,0l-0.8,2l1.5,1.3l-1.7,2.5l0.2,0.1l0.1,0.3l0.3,0.1l0.3,0.2
		l0.1,0.1l0.8,0.2l0.1,0.1l-0.1,0.2v0l0,0.1l0,0.1v0.1l0.8,5.2v0l0.2,0.3l-2.2,1.4l-1.3,0.1l-2.5,1.1l-0.2,2.8l-1.2,1.2l-2.5,0.9
		l-0.6-0.4l-3.1,4.3l-4.9,3.5l-0.4,1.6l-2.2,0.6l-1.2,1.5l-1.3-0.4l-1.4,2l0.5,1.8l-0.2,1.4l0.7,2.1l-0.6,2.4l-1.1,2.5l0.3,3.5
		l-1.7,0.1l-1.2,2.7l-1.8,0.8l-0.4,1.6l-2.1,0.7l-2.1-2.2l-2.2-6.8l-1.5-1.8l-1-2.4l-1.2-4.8l-0.7-0.5l-1.8-3.7l-1.6-7.5l0.5-0.8
		l-1.1-2.5l0.8-2.7l-2.3-1.3l-3.6,1.5l-1.7-1l-3.4-3.5l3.3-0.8l2.5-3.3l0.3-1.8L665,470.6z"
                />
                <polygon
                  className="WMst5"
                  points="429.3,508.7 430.1,507.5 432.7,506.9 432.4,505.3 432.5,505.4 432.7,504.2 434.4,504.3 435.9,505 
		439.1,504.9 441.1,506.4 442,505.4 443.8,506 445.8,505.1 446.4,507.1 446.5,507.1 447.3,507.8 447.4,508.1 447.5,510 448.5,511.2 
		448,513 449.2,514.2 448.9,515.8 447.8,518.5 447.1,518.4 445.4,519.4 444.5,518.5 444.3,516.2 442.1,515.9 442.1,515.8 
		442.1,515.8 441.1,513.6 439.6,511.6 436.2,512 435.5,513.3 433.8,514.3 432.8,511.7 430.6,511.1 	"
                />
                <polygon
                  className="WMst5"
                  points="802.8,476.3 801.2,474.3 801.6,472 804,468.3 805.5,467.5 806.6,468.4 805.6,471 805,474.1 
		803.8,475.8 	"
                />
                <polygon
                  className="WMst5"
                  points="563.9,436.8 560.6,437.9 559.4,436.5 561.2,435.4 564,435.7 	"
                />
                <polygon
                  className="WMst5"
                  points="536.6,484.7 536.6,483.3 539.4,483.3 539.4,477.4 556.7,477.4 557.2,477 561.9,477.4 563,478.2 
		564.4,477.4 572.1,477.4 572.7,479.7 573,484.4 573.5,486.5 576.8,489 575.9,490.4 572.4,491.7 572.3,494 570.8,497.1 571.2,499.7 
		570,504.1 568.8,504.2 567.1,506.6 566.8,508.2 566.8,508.2 564.9,510.2 564.5,513 564.1,511.2 562.1,509.5 561.8,507.6 
		562.2,505.5 560.7,505.5 560.7,505.6 559.7,506.9 559.9,508.8 558.6,509.8 556.8,512.3 555.4,512.3 553.1,510.8 551.9,512.3 
		550.4,512.6 549.7,513.5 547.7,513.5 547.4,512.7 543.2,512.9 541.4,510.4 539.6,510.8 538.9,512.2 537.3,515.3 535.2,515.2 
		535.8,512.6 534.7,510.4 533.5,509.1 533.8,508.1 532.6,507.1 532.4,504.3 530.6,503.8 531.9,502.3 531.3,501.1 532.6,500.1 
		532.1,498.9 533.9,497 534.2,495.6 536.6,495.6 	"
                />
                <path
                  className="WMst5"
                  d="M761.7,567.9l-0.1,0.4l-0.4-0.2L761.7,567.9z M849.6,645l-2.5,0.2l-0.3-1.1l2.8-0.6L849.6,645z M876.4,662.4
		l2.9,0.1l0,4.4l-0.8-0.3l-0.8,2.9l-0.9,0l-1.8,2.8l-2.2-0.3l-1.5-2.2l-0.7-2.9l-1.7-4.4l1.8-1.1l3.1,1.9L876.4,662.4z M830.1,571.2
		l2.1-1.2l0.6,1.2l-1.4,0.9L830.1,571.2z M861.3,576.1V576l0.1-0.1l-0.1,0.1V576.1l-0.7-1.2l1.5-3.9v-1.6l1.1-0.8l0.7,1.1l0.2,2.2
		l1.9,2.8l0,2.6l0.7,1.8l2-0.6l0.4,1.1l1.8,1.1l-0.4,1.5l0.7,1.7l-0.2,1.1l2,3.4l-0.5,1.3l0.7,2.1l3.9,2.9l2.5,0.7l0.4,1.8l1.5,1.1
		l0.7,1.4l0.1,2.4l1.5-0.6l2.2,1.7l-0.2,2.5l1.8,1.7l1.2,0.2l1.6,2l2,3.4l-0.4,1.4l0,2.7l0.8,1l0.8,3.9l-1.8,5.8l-0.1,2.6l-1.1,2.9
		l-2.1,1.6l-1.4,3.6l-3,5.8l-0.6,6.2l-1.3,0.9l-4.8,0.7l-2.4,2.3l-2.9,0l-3.2-1.3l-1.7,0.7l-1.4,1.3l-3.3-1.8l-2.3,0.3l-1.4-1.3
		l-1.2-0.1l-2.3-2.9l0.3-1.7l-0.6-2l-1.7-1.9l-1.5-0.7l0.1-1.9l-1-2.2l-0.9,3.3l-0.9-0.7v-2.6l1.5-1.9l-0.9-2l-1.2,2.3l-2.3,1.3
		l-1.1,3.1l-1.5-1.4l-0.2-1.9l-1.3-1.3l-0.4-1.5l-3-3.5l-1.3,0.4l-1-0.8l-1.5,0.3l-2.9-1.8l-1,0.4l-4.8,0.2l-5,1.9l-3.5,0l-4.7,2.3
		l-0.7,1.8l-1.2,1.3l-1.4-0.3l-2.5,0.5l-0.3-0.6l-5.3,0.1l-2.3,2.2l-1.1-0.3l-2.5,2.3l-3.6-0.2l-1.7-0.7l-1.2-1.4l-1.2-0.1l-0.4-2.8
		l1.2,0.4l0.8-1.1L789,634l0.2-3.2l-1.8-3.8l-0.3-3.7l-1.1-2.6l-1.1-1.3l0-1.3l-1.6-3.2l-0.2-3.5l2.1,1.1l-2.4-4.4l1-2.8l-0.4-2.7
		l1-2.1l0.9,1.7l1.4-1.7l1.8-0.9l1.9-1.7l2.7-1.1l1.8,0.2l1-1l1.9-0.1l0.7-1l1.3,0.4l4.2-1.6l2.9-4.5l0-2l2.2-1.9l1.7,2.6l0.7-1.4
		l0.3-2.3l1.3,0.4l0.1-2.3l1.9-0.8l2.3-1.6l0.8-2.1l1.5-0.5l1.8,0.4l1.5,1.9l3.1,0.9l0.8-1.6l2.5-2.9l1.1-1.9l1.7-1.1l2.3,0.3
		l1.4-0.8l0.2-1.6l6.5,2.1l3.8-0.8l0.7,1.3l-0.1,1.5l-1.6,1.9l-0.5,1.5l-1.5,1.5l2.6,2.6l3.9,1.7l1.6,1.6l2,0.3l0.6,1.2l2.8,1.3
		l1.6-0.7l1.2-2.8l0.9-3.8l-0.3-3.7L861.3,576.1z M847.8,618.7l-0.1,3.4l2.5-0.4l-0.9-2.6L847.8,618.7z"
                />
                <path
                  className="WMst5"
                  d="M772.6,533.5l0,1.3l2.5,2.1l1.8-0.7l1.7,0.3l1.8-1.6l3.1,1l1-0.6l1.6,0l1.5-3.8l1.3-0.9l0-2.1l0.9-1.3l3.8,0
		l0.9,0.5l0.7,1.3l-0.8,1.1l0.2,1.3l1.3,1.3l-0.7,1.3l3.1,2.4l-0.6,0.5l-2.9,0.1l-0.8,1.8v2.2l-2.8,2.9l0.2,2.2l-1.5,2.9l-3.6,1.6
		l-0.7-1.9l-2.2-0.1l-1.6-0.9l-1.1,0.7l-3.4-1.4l-3.2,0.2l-0.5-4.4l-2.2-1.3l-1.2-4.5l0.6-1.9L772.6,533.5z M859,546.3l0.1,17.9
		l-2.8-2.5h-1.7l-1.3-0.8l0.5-1l-1.2-1l0.7-1l-1.4-1.3l-0.3-1.5l-1.1-1.4l-5.6-2.3l-2-0.1l-3.4-1.6l-0.9-1l-1,1.6l-2.5-3.1l3.2-1.9
		l-3.3,0.1l-1.7-1.9l-2.1-0.4l0.8-1.7l1.7-0.3l1.6-1l2.7,1.1l1.6-0.1l0.9,1.7l-0.6,0.9l0.3,1.9l1.9,2.4l1.7,0.3l2.5-3.1l2.2-0.3
		l0-0.9l1.9-0.8l5.3,2.5l1.1-0.1L859,546.3z M814.8,563.8l0.4,1.4l-1.9,2l-2.6,0.5l0.6-2l1-0.8l1.2-0.5L814.8,563.8z M852.1,562
		l-2.4,0.3l1.3-2.4l1.8-0.4l0.9,0.5l-0.5,1.4L852.1,562z M821.8,536.7l0.1-2.2l1.3,1.1l2-0.7l-0.1,1.4l-2.7,2.1L821.8,536.7z
		 M763.5,547.2l-1-0.4l-0.5-1.9l-1.7-0.2l0.7-1.3l1.5-0.3l1.1,2.5L763.5,547.2z M825.9,548.2l-1.4,0.5l-0.8-1.6l3.8-0.2l2.9,1l0.7,2
		l-2.5-1.4l-1.1,0.4L825.9,548.2z M820.6,548.3l-1,1.5l-1.4-0.7l-0.2-1.4l1.9-0.1L820.6,548.3z M800.1,550.7l-0.4-2l-1.5,0.1
		l-0.2-2.5l1.4-1.8l0-2.2l1.1-1.4l0.1-2.4l0.7-1.4l1.5-0.1l0.9-1.7l2.1,0.9h2.2l4.2,0.5l1.6-1.4l2-0.4l-2,2.8l-3.2,0.4l-0.8-0.6
		l-3.5,0.3l-4.1,0l-0.7,1.3l0.1,1.5l1.7,2.2l1.2,0.1l1.5-1.8l3.6-0.1l-1.6,2l-1.5,0.5l-0.1,1.7l1.4,2.6l-0.4,1l1.3,0.8l-0.2,1.4
		l-2.9,1l0.2-1.9l-2-1.4l0.5-1.5l-0.8-1.1l-1.7,1l0.6,0.8l-0.3,2.3l0.4,1.5l-0.4,2.3l-1.7,0.5l-1-1L800.1,550.7z M801.8,565.7
		l-0.2,1.7l-2.8-2.4l1.7,0.1L801.8,565.7z M803.6,562.1l-0.2,1.3l-2.6,0.1l-0.1-1.2l1.6-0.5L803.6,562.1z M797.9,563.4l-1.8,0.1
		l-3.2,0.7l-0.5-1.6l2.1-0.3l1-0.9l1,0.8l2-0.2L797.9,563.4z M765.6,555.5l1.5,0.7l2,0.1l1,1.5l2.2-0.1l2.5,0.5l0.8-1.4l3.8,1.3
		l1.2-0.2l1,2.2l1,0.4l2.1-0.5l1.1,0.5l-0.3,2l-3.4-0.7l-1.3,0.5l-5.3-0.7l-3.8-1.4l-4.1,0.1l-1.2-0.7l-2.7-0.3l0.3-1.2l-2.9-0.4
		l1.9-2.2L765.6,555.5z M755.8,539.2l-0.7,1.9l1.3,1l1.5-0.1l0.7,2.7l0.9,1.1l1.9,0l1.3,2.4l-0.7,0.9l0.2,3.7l-0.5,2.7l-1.6-0.3
		l-6.2-3.6l-1.7-1.5l-0.2-0.8l-1.6-1.2l-2-2.5l-0.1-1.1l-1.4-2.1l-0.1-0.9l-1.7-2.3l-1.6-0.7l-1.2-3.6l-2-1.9l-2.7-3.5l-1.5-0.6
		l-2.9-2.9l-0.5-2l1.1-0.2l2.1,1.2l3.1-0.1l2.1,2.3l1.1,1.8l2.9,1.6l1.8,2.5l1.7,0l1,1.6l2,0.9l0.7,1.6l3.6,1.4L755.8,539.2z
		 M739.9,537.6l-2-2.4l1-0.3l1.3,1.3L739.9,537.6z"
                />
                <polygon
                  className="WMst5"
                  points="253.5,535.4 253.5,535.4 255,536.6 256.3,536.9 256.8,538.1 259.9,538.5 263.1,539.5 263.2,540.8 
		263.1,540.8 263.1,541.3 263.1,541.4 262.2,543.4 259.2,546.3 259.1,546.3 256,547.4 254.6,548.4 253.7,551.7 252.7,552.9 
		251.4,551.6 249.6,550.9 249.3,548.7 249.3,546.7 248,544.8 247.5,542.1 249,541 248.7,540.2 250.3,538.5 249.9,536.9 252.3,536.2 
			"
                />
                <polygon
                  className="WMst5"
                  points="300.2,506.1 300.6,505.9 300.6,505.4 	"
                />
                <polygon
                  className="WMst5"
                  points="426.4,479.3 434.6,479.3 434.3,474.7 435.8,473.6 437.4,473.1 437.4,466.2 438.3,465.4 446.6,465.4 
		446.6,461.4 457.2,468.4 452.4,468.4 455,493.4 455.8,493.8 455.3,496.2 444.8,496.2 440.9,496.4 440.4,497.3 438.7,495.8 
		437.9,497.9 436.7,498.3 436.2,498 436.2,497.9 434.4,496.1 434.4,496 433.9,495.4 433.9,495.3 433.8,495 433.8,495 432.3,494.5 
		431,493.1 429,493 428.9,493 428.9,493 425.5,493.4 425.1,494.6 425,494.6 426.3,489.1 425.9,486.4 425.1,484.9 425.8,482.7 
		425,481.2 423.5,481 423.7,479.5 	"
                />
                <path
                  className="WMst5"
                  d="M229.9,503.3l1.6-0.9l-0.1-1.3l2.8-0.5l1.6-0.9h0l0-0.1l0.1-0.8h0l0.5-0.5l0.1-0.1l0.5,0l0,0.1v0l0,0l2.8-0.3
		l0,0l0-0.1l0,0l0.4-0.2l0-0.1h0l0,0l0.7-0.1l0,0h0.2l0,1.9l-1.1,3l0.3,2.4l-0.6,4.1l-0.4,0.6l-0.1,0l-0.4-0.1h-0.2l-0.1-0.1h-0.1
		l-4.2-0.8l-2.3-2L229.9,503.3z M236.8,508.4l-1-1.7l-2-0.9l0.4,2.2L236.8,508.4z"
                />
                <polygon
                  className="WMst5"
                  points="514.9,393.4 515.1,393.1 516.4,389.9 516.8,390.1 517.8,388.7 518,388.7 518.2,388.9 518.4,388.9 
		518.4,389 518.7,389.3 518.8,389.4 520,389.8 520.1,389.8 520.3,389.8 520.4,389.8 520.9,389.9 521.1,389.9 521.3,389.8 
		521.7,389.8 522,389.7 522.1,389.6 522.1,389.6 522.4,389.5 523,388.5 525.6,388.1 527,386.6 529.8,386.6 531.4,387.2 531.5,387.2 
		531.5,387.1 533.6,389 532,389.7 528.9,395.4 527,396.1 526.3,396.3 525.9,396.2 525.8,396.2 524.4,396.1 522.5,397.2 522.3,397.2 
		522.3,397.2 522.3,397.3 520.7,397.8 520.6,397.7 519.4,397.6 519.4,397.6 518.3,397 516.2,394.9 	"
                />
                <path
                  className="WMst5"
                  d="M666.1,418.6l2.1,0.3l1.9-0.9l1.2-1.6l-0.1-0.1l-3.4-1.6l-0.9,0.7l-1.5-1.3l0.6-2.9l0.9-1.9l1.6-0.2l4.5,1.5
		l0.1-1.7v-0.1l1.9-1.4l4.2,1.8l3.4-0.7l6.1,0.7l0.8,1.3l1.8,0.9l0.1,0.6l-5.6,2.4l-1.1,1.4l-2.5,0l-1,2.1l-2.2,0.5l-1.3-0.6
		l-3.5,1.5l-0.9,2l-5,0.6l-0.8-1.2l-1.7,0.8l-1-0.9l-3.3,0.3l-0.1-1.4l2-1.1l1.5,0.7L666.1,418.6z M685.8,409.3l-5.4,1.1l2,1.1h1.7
		L685.8,409.3z"
                />
                <polygon
                  className="WMst5"
                  points="566.9,454.4 568.1,449.6 568,449 568.1,448.8 568.4,447.3 568.4,445.3 569,444.1 572,445.6 
		577.4,442.1 578.8,445.8 578,446.6 572.4,448.2 575.2,451.4 573.8,453 571.7,453.4 569.9,455.5 566.8,455 	"
                />
                <path
                  className="WMst5"
                  d="M497.3,390.7l-1.5-0.5l-0.2,0h-0.7l-0.7,0.1h0l-2.8,0.2l0-0.2l-0.1,0l0.1-1.8l0-0.2l0.4-1l0-0.1h0l0-0.3
		l0.1-0.3l0-0.1l0-0.2l0.3-0.4l0.1-0.1l0.2-0.3l0.1-0.1l0.1-0.1l0.1-0.3l0.1-0.1l0.1-0.1l-2-1l-2,0.1l-1-1.3v-0.2h0v-0.1l0-0.2h0
		l0,0l0.1-0.1l0.2-0.4l-0.1,0h0.1l0-0.1l0-0.2l0.1-0.1l-0.9-0.6l0,0l-0.1-0.7l-0.3-2.7l0.5-3.3l-0.2-1.7h0l1.7-0.1v-3l1.3-2.8l0-0.1
		v-0.3l-0.1-1.8l2.3-0.4l1.5,0.8l1.3-4.5l-1-2l0.4,0.1h0l1.7,0.3l1.5,0.2l2.2,3.5l1.9,0.7l4.3-2.6l2.2,2.9l1.3,0.6l0.3,2.9l0,0
		l-0.5,0.4l-0.1,0.1l0,0.3v0.1l0.1,0.2l0.1,0l1.1,1.4v0l0,0v0.1l-0.1,0.6l0.1,0l0,2.1l1,3.5l-0.4,0.7l-0.9-0.8l-5.9,3.5l0,0.9v0v0v0
		l0.8,2.5l3.3,2.8l-0.7,0.8l-0.1,0l-0.4,0.5l0,0.2l-0.4,0.4l-0.2,0.1h-0.2l-0.2,0l-0.4,0.3h-0.1v1.1l0,0l-0.4,1.1l-3.1,0.3l-3.6,1.2
		L497.3,390.7z M491.8,387.3L491.8,387.3L491.8,387.3L491.8,387.3z M488.3,381.6L488.3,381.6L488.3,381.6L488.3,381.6z"
                />
                <path
                  className="WMst5"
                  d="M296.8,488.9L296.8,488.9l-0.2,0l0.1-0.2L296.8,488.9z M320,532.8l1.1-1.2l0.3-1.4l0.1-0.1l-1-3.2l0-0.2
		l0.1-0.1v0l0-0.3l0-0.1l0,0l-0.1,0l0-0.3l0-0.1l0.3-0.7l0-0.1l0.9-1.1l0.4-0.5l2.6,0.8l1.7,1.8l1.4,0.5l0.3,1.6l-0.8,1l0,0
		l-1.5,3.1l-1.1,1l-2.1-0.5l-1,0.7L320,532.8z M477.5,375.7l0.9,1.7l3.4,1.8l0.1,1.4l2,0.5l1.7,1.5l1-0.2l1.5,0.3l1,1.3l2-0.1l2,1
		l-0.1,0.1l-0.1,0.1l-0.1,0.3l-0.1,0.1l-0.1,0.1l-0.2,0.3l-0.1,0.1l-0.3,0.4l0,0.2l0,0.1l-0.1,0.3l0,0.3l0,0v0l-0.4,1l0,0.2
		l-0.1,1.8l0.1,0l0,0.2l-1.8,1.3l-0.6,0.7l0,0H489l0,0l-1.6,2.3l0.4,0.8l1.5-0.4l0.7,1.9l0.4,2l-1.5,1.1l1.2,1.6l1.2,3.5l-2.1,1.4
		l-0.3,0.9l-2.2,0.4l-1.4-1.2h-2.1l-1.8-0.8l-2.3,1.9l0.2,2.4l-2,0.3l-2-0.5l-0.8-0.4l-4.8-0.9h-0.1l-0.8,0l-3.3-2l0.9-1.1l1-7.4
		l0.4-1.4l-3.3-3.6l-1.1-1.9l-2-2l-3-0.1l-1.1-3l4.7-1.5l1.1,1.6l3.1-1l0-2l1.3-0.5l2.5,0.3l1-1.7l2.7-1.1l1.3-1.5v-2.6L477.5,375.7
		z M496.1,413.6l-1.4,0.1l-0.7-3l2.1-1.2l0.7,2L496.1,413.6z M595,574.3l-0.2,0.7l-0.2-0.8L595,574.3z"
                />
                <polygon
                  className="WMst5"
                  points="746.5,482.4 746.6,482.4 747.6,482.8 747.4,484.6 749.3,485 749.8,486 748.9,487.8 749.1,490.6 
		750.6,489.3 750.8,489.3 750.8,489 750.9,488.9 751.1,488.9 751.3,488.9 751.6,488.5 751.8,488.4 751.9,488.5 752,488.5 752,488.6 
		752,488.6 752.1,488.7 752.8,489.1 753,489.1 753.4,489.6 753.4,489.6 753.5,489.4 753.5,489.4 754.3,489.1 754.4,489.1 
		755.1,488.1 754.9,488 755.7,487.8 755.9,487.9 757,488.1 759.2,490.8 759.1,491.8 759.1,492.3 759.1,492.3 759.1,492.5 
		759.1,492.9 759.1,493 759.5,493.8 759.6,493.8 759.8,494 759.9,494.1 759.9,494.4 760,494.5 760,494.5 760.2,494.6 760.3,494.6 
		760.6,494.7 761,494.8 760.9,494.8 760.9,494.8 760.8,494.8 761,495.5 761.1,495.5 761.6,495.8 761.3,498.9 760.4,499.5 
		759.3,499.2 754.8,499.5 753.2,501.6 752.5,501.7 752.9,504.2 754,507.1 752.4,505.1 750.9,504.1 748.3,504.2 748.7,501.9 
		746,502.2 746.1,505.5 744.8,507.9 743.7,512.4 744.1,513.3 745.6,513.6 745.9,515.5 746.6,516 747.7,519.4 749,520.4 750.3,520.4 
		751.8,522.1 749.2,523.8 748.1,521.3 746.4,521.6 744.3,519.1 743.5,517.4 741.3,516.6 741.1,515.1 742.4,511.2 742.5,511 
		742.7,509.8 743.9,508.6 745.1,506.6 744.5,504.4 743.5,503.1 743.6,500.8 741.2,498.1 742.1,496.5 742.4,494 742,492.5 742,492.5 
		739.8,489.2 739.8,489.1 739.7,488.9 739.7,488.8 738.7,487.4 739.6,486.3 740.6,483.8 743.2,484 744.5,482.1 746.2,482.2 
		746.2,482.2 	"
                />
                <polygon
                  className="WMst5"
                  points="513.1,518.5 514.5,518.6 516.2,517.5 516.9,518.5 519.3,517.2 521.8,517.1 523.2,515.3 522.7,514.5 
		526.8,514 530.3,510.8 530.3,509.9 532.4,508.9 533.5,509.1 534.7,510.4 535.8,512.6 535.2,515.2 537.3,515.3 537.1,516.3 
		539,516.7 539.9,518.6 543.3,520.9 543.5,522.5 545.4,523.5 546.1,525.4 545.2,524.9 543.5,525.3 540.5,524.6 540.1,525.4 
		537.3,525.7 535,526.6 533.6,526 533,526.8 532.9,526.9 532.7,527.1 532.7,527.2 532.7,527.3 532.6,527.4 532.6,527.5 532.3,527.9 
		531.2,527.6 530.8,527.5 530.6,527.5 530.2,527.4 530,527.4 529.4,527.4 529.2,527.3 529,527.3 529,527.4 528.8,527.4 528.7,527.3 
		528.5,527.1 527.8,527 527.8,527.1 527.1,527.1 526.9,526.8 526.8,526.6 526.7,526.4 526.6,526.1 526.4,526.1 526.3,526 
		526.1,525.8 525.9,525.7 525.6,525.5 525.5,525.5 525.4,525.5 525.3,525.5 525.1,525.2 525,525.2 524.8,525.1 524.4,525.1 
		523.6,525.4 523.4,525.5 523.2,525.6 523.1,525.7 523,525.7 523,525.8 522.3,526.7 522.3,526.9 521.7,527.7 521.8,527.8 
		521.8,527.9 521.8,528 521.8,528 521.8,528.4 521.8,528.4 521.7,528.4 521.7,528.7 521.7,528.9 521.8,529.6 521.8,529.6 518.6,529 
		516.4,529.5 515.1,533.1 515.1,533.1 514.7,530.9 512,528.2 510.5,524.7 510.8,523 512.4,519.3 	"
                />
                <polygon
                  className="WMst5"
                  points="257.8,463.8 257.8,464.9 257.2,465.4 257.7,465.8 258.2,463.7 	"
                />
                <path
                  className="WMst5"
                  d="M275.1,716.1l1.7,0.7l-0.7-3L275.1,716.1z M269.5,716.4l1.1-0.1l0.4-2.2l-1.8-1.2L269.5,716.4z M269.8,710.3
		l0.4,2.5l1.8-1l-0.4-2.2L269.8,710.3z M276.4,711.3l-0.1,1.7l1.7,4.2l-1.2,2.8l4.7,0.1v-10.4l-2.3-1L276.4,711.3z M265.7,671.1h1.8
		l-0.4-2.9l1.1-1l-1.8-1.7L265.7,671.1z M278,588.4l-0.1,1.3l-1.4,0.5l0.9,9l-1.4,9.3l0.4,2.1l-0.9,1.7l0.3,1.6l-0.9,2.5l-0.5,3.7
		l-1,1.7l0.7,3.1l-1,1.2l-0.2,1.4l0.8,6.2l-0.9,1.5l0.4,1.6l-1.1,1.8l-0.5,3.3l-1.2,1.5l-1.5,5.3l-1.4,0.6l0.6,2.7l-0.1,1.8l0.8,2.9
		l-1.4,2.2l-0.6,3.8l0.5,2.5l1.6,0.2l1.1,4.4l-0.3,2.3l-1.1,2.1l1.2,0.5l0.4,1.8l-2.2,2.8l-0.7,3l-2.2-1.5l-3.1,3.5l3.5,0.2l1.1,0.7
		l-2,3.1l0.9,3.6l-0.1,3.4l2.1,1.1l-1.9-0.1l0,3.6l0.9,4.4l1.7,3.2l0.9,2.8l2-1.4l2.1,0.1l1.2,1.6l-1.7,1.4l-1,2.2l2.3,1l1.1-1.3
		l0.5-3.9l2.9-1.1l1.2-1.5l2.2,0.9l-4.3-1.8l-5.6-0.1l-1.1-1.7l0.2-4.2l-2.1,0.7l-0.8-1.8l-0.1-2.5h1.3l-0.4-2.7l1.1-1.1l-1.2,0
		l1.4-0.3l0,0l0.1,0l0.9-2.1l-0.8-1.6l1.4-2.6l0-0.2l1-2.9l-0.2-0.8l-0.1-2.7l1.1-1.1l0.2-3.5l-1-1.8l0-0.1l-0.2-2.8l-1.1-1.1
		l-0.1-2.6l1.2-0.3l-0.4-5.3l0.6-1l0.6-5.1l1.7-1.2l-1.1-3.2l0.5-4.2l0.9-0.1l1.1-2.1l-0.2-2.2l1.7-6l-2.2-6.1l0.8-1.4l1.1-4.3
		l0.6-4.1l1.4-1.4l0.9-2.5l1.6-0.7l-0.9-1.3l0.6-0.9l-0.6-2.3l0.7-0.9l-0.1-1.9l2.9-1.4l0.9-3.1l-0.5-0.6l-1.8-0.8l-0.9-3.7
		l-1.5-2.5l0.1-2.1l0.8-0.9l-1.5-1.4l-1.4-4.1L278,588.4z"
                />
                <polygon
                  className="WMst5"
                  points="241,476.4 239.2,476.9 238.4,475.7 241.1,474.4 243.9,473.9 248.4,474 250.6,474.7 251.8,476.2 
		253.6,476.3 255.7,477.7 260,479.5 261.7,481.2 264.5,481.4 266.2,482.7 263.3,483.6 261.4,483.2 256.4,483.8 257.8,482.4 
		257.3,481.2 255.1,481 254.2,480.3 253.5,478.5 250.5,478.4 248.7,477.3 245.1,476.9 242.4,475.3 	"
                />
                <path
                  className="WMst5"
                  d="M615.6,374L615.6,374l0.3-0.2h0.1l1.4,0l3.4,2.8l3.3,1.3l2.2-2.3l5.8,0.2l0.1,1l3.2,1.1l0.5-1.2l2.2,0.7
		l1.9-1.3l0-0.2l0.5-1.1l-3.2-2.4l1.3-2.3l-0.8-2l1.3-2.7l-0.5-1.5l1.3-2l3.1,0l3.8-0.6l4.2-2.2l4.3-0.6l0.2-0.1l3.2-1.4l0,0
		l1.3-1.2l0.1,0l0.4,0.2l0.2-0.1l0.4-0.2l0.1,0l2.1,0.8l2.4-0.4l1.3,3l0,2.5l3.4,0l2.1,0.9l0.2,2.2l4.6-1.5l1.1-1.4l2.4-1.2l0.7,1.7
		l3.6,3.1l3.7,6.5l2.4,5.1l1.6-2.5l1.4,0.6l1.1,1.9l2.7,0l1.5-1.1l1.8,0.5l1.3,2.7l2.1,0.9l0.6,2l2.6,0.5l1.2-0.4l1.8,1.9l-1.5,0.8
		l-0.4,1.6l-2,0.5l-0.7,1.1l-0.1,4.5l-1.6,0.8l-2.8-0.5l-2.1-1l-0.6,1.2l-1.8,5.5l-6,2l0.9,1.6l0.3,3l0.8,2.4l-1.6,1.7l-0.2,1.9
		l-1.8-0.9l-0.8-1.3l-6.1-0.7l-3.4,0.7l-4.2-1.8l-1.9,1.4v0.1l-0.1,1.7l-4.5-1.5l-1.6,0.2l-0.9,1.9l-4.9,3.1l-1.4,1.6v0l-1.7-0.2
		l-0.2-0.1v0l-0.1-0.2l-3.5,0l-0.5-2.7l-1.5-0.2l-0.4-3.4l-2.3-3.2l-1.3,0.6l-3.2-0.3l-3.7,0.5l-2.5-3.2l-6.5-4.5l-0.4-0.3l-7.2,2.3
		v13.9l-1.6,0.1l-1.4-2.4l-2-1.7l-3.4,1L615,413l0.8-3.5l-2.3-0.4l-2.9-5.2l0.7-1.1l0.6-2.9l1.2-0.7h3.7l0.8-4.2l-1.4-2.2l-2.9,0.3
		l-1.8-0.8l-2,0.6l-3.3,2.8l-2.2-4.6l-1.1-1.3l-2.5-0.1l-0.2-2.1l-1.7-0.7l1.5-2.7l-0.4-3.3l2-2.6l2.3,2.8l1.3-0.9l-0.2-2.5l1.8-2.3
		l2.5-0.9l1.1-1.9l2.5,1.4l1.9-1.5L615.6,374z M687.5,395.3l-2.4-1.1l-2.1,0.5l-2.6-1.1l-2.3,0.4l-1.3-0.6l-2.3,1.8l-1.6,3.3l1.7,1
		l0.5-2.6l1.8-1.7l3.8-0.7l3.1,0.3l1.7,0.8L687.5,395.3z M695.2,394.9l-0.5,1.9l2.1,1.1l-0.4-2.3L695.2,394.9z"
                />
                <polygon
                  className="WMst5"
                  points="424.5,505.1 427.2,504.9 428.7,504.1 432.7,504.2 432.5,505.4 432.4,505.3 432.7,506.9 430.1,507.5 
		429.3,508.7 427.7,507.9 426.9,506.8 	"
                />
                <path
                  className="WMst5"
                  d="M296.6,488.9l0.2,0h0h0l-0.1,0.1L296.6,488.9z M490.3,366.1v0.3l0,0.1l-1.3,2.8v3l-1.7,0.1h0l0.2,1.7l-0.5,3.3
		l-0.8-0.9h-0.1l0.2-0.6l0-0.1l-3-1.7l-1.4,0.5l-0.4-2.7l1.4-2.2l0.3-2.2l1.5,0.9l0.8-2.4l3.3-0.8L490.3,366.1z M482.1,374.6
		l-1.8,0.2l-0.4,0.2l-0.2-0.5L482.1,374.6z M282.2,505.5l-0.2-0.3l0.5,0.6L282.2,505.5z M280.7,505.9l-0.8-0.9l1.2,1L280.7,505.9z"
                />
                <polygon
                  className="WMst5"
                  points="528.5,352.6 531.4,350.8 535.7,351.1 540.8,352.2 542.7,353.8 542.7,353.8 543.6,354.5 543.8,354.5 
		543.6,355.7 543.8,357.1 541.5,358.5 541.3,361.7 540.9,361.3 537.5,363 537.4,363 535.2,362.7 534.3,361.1 533.3,360.8 
		533.2,360.7 533.2,360.7 533.1,360.6 533,360.4 532.9,357.9 532.9,357.9 529.1,356.6 	"
                />
                <path
                  className="WMst5"
                  d="M532.7,384.3l0.5-2.3l3.7-4.4l-0.5-1.5l0,0l-0.6-1.1l-0.2-1.1l2-1.5l2.1-0.4l8.7,1.2l1.3,0.9l3.3-0.1l0.1,0.1
		v0h0.1l1.7,0.7l0-0.1l-0.2-0.9v0l-0.1,0l0-0.1h0.1l0.2-0.4l0-0.1l0.1-0.1l-0.1,0l0.1-0.3l0-0.2l0.2-0.2l0.1,0l0.2-0.3l0.1,0
		l2.4-0.5l1.7-1l4-0.1l1.6,2.4l-0.3,2l2.7,1.3l1,3.1l1.4-0.4l1.4,0.9l2.1-0.9l1.7,2.3l0.8-0.8l4.7,2.6l-0.8,2.1l0.5,2.6l-0.5,2h-2.5
		l-1.5,1.2l-0.2,1.9l-1.8,0.1l-2,1.6l-2.7,0.2l-3.7,2.1l-2.2-0.3l3.6,2.2l1.3,2l-3.8,2.7l-1.1,0.2l-0.6-3.3l-2.9-0.5l3.1-2.9
		l-2.9,0.2l-1.9-1.8l-2.7-0.4l-1.2,2.2l-1.9,1.7l-0.3,1.7l-2-0.5l-0.1,0.1l-0.1,0.1l-0.4-0.1l0,0.1l0,0.2v0.1l-0.1,0h-0.1l-0.4-0.1
		l-0.2-0.1l-0.3-0.1l-0.2-0.1l0.2-0.7l1.5-2v-1.9l1.7,0.6l0.8-0.8h0l0.2-0.2l0.1-0.4l-2.2-3.3l0-2l-2.7-0.9l-1.2-1l-3.1,0.8
		l-1.2,1.1l-2.4,0.3l-4-0.1l-1.9-0.8l-0.7,0.7l-2-1.9L532.7,384.3z M548.5,399.3l-0.3-0.4l0.6-0.1L548.5,399.3z"
                />
                <path
                  className="WMst5"
                  d="M278.8,569.3h0.5l0,0h0.3v0l0.3,0v0l1.7,0.4l1.4-1.3l0.9,0.1l3-2.3l2.3-0.4l1.3,0.3l0,0l-0.3,1.7l0,0v0.1
		l0.1,0.1l0,0.2l0.2,2.4l0.2,0.1l0,0.1v0.1l0.1,0.4l0-0.1l0.1,0l0.2,0.7v0.1l0,0l0.1,0h0.2l0,0l1.9,1.3l0.2,0l2.9,0.4l1,1.1l1.7,0.3
		l1,1.2l1.9,0l1.2,0.6v0v0l0,0l0.2,0.1l0.1,0l0.1,0.1h0.1l0.1,0.1l-0.1,0.1h0l0,0.1h0.1l0.1,0.2l0,0l0.4,1.8l0.3,4.7h5.1l-0.4,1.9
		l0.9,1.4l0,0.1l0.5,0.1l0.4,0.3l0,0l0.1,0.2l0,0l0,0.1l0.1,0.3l0.3,1.5l0,0.1l-0.3,1.9v0.1l-1.2,2.1l0,1.1l-0.1,0l0-1l-2.5-1.6
		h-2.5l-4.9,1l-1.5,2.7l0,1.5l-1,3.5l-0.1,0l-0.1-0.1l-0.1,0l-0.2-0.2l0-0.2l-3.1-0.2l-1.1,2.6l-0.8-2l-1-0.4l-3.6,0l-1.2,0.4
		l-1.2,1.7l-1.8-0.8l-0.9-3.7l-1.5-2.5l0.1-2.1l0.8-0.9l-1.5-1.4l-1.4-4.1l-0.5-0.6l1.7-1.7v-0.1l0-0.2l1-0.3l-1.8-2.6l-0.1-2.1
		l1-1.5l-0.2-1.6l1.1-3.3L278.8,569.3z M311.2,588.1L311.2,588.1L311.2,588.1L311.2,588.1z"
                />
                <polygon
                  className="WMst5"
                  points="751.9,476.2 752.9,475.1 754.4,476.1 755.2,475 757,475.9 759.1,475 760.7,473.3 762.2,474.7 
		764.8,475 764.1,476 764.4,477.4 766.3,478.6 768.2,478.7 764.9,480.4 764.1,482.6 762.4,483.5 761.5,486.2 762.3,487.8 
		763.7,488.7 764.1,490.3 768.8,494.9 771,498.4 771.6,500.7 771.4,502.1 772.1,504.3 771.2,504.9 771.6,506.4 770.9,507.9 
		766,510.6 765.1,510.1 762.9,512.4 763,513.5 761.3,514.1 760.1,515.4 759.2,515 759.4,512.5 760.1,511.8 758.3,510.5 759.4,510.2 
		760.1,509.1 760.1,509.1 760.5,509.1 760.5,509.2 761.9,508.8 762,507.1 763.8,507 765.8,505.2 766.8,505.1 767,502.4 766.2,500.1 
		766.8,498.5 767,496.5 765.9,495.5 766.6,494.5 764.4,493.5 764.1,491.9 761.9,490 760.2,487 756.7,485.3 759.3,483.9 758.8,481.3 
		757.3,480.4 756.2,481.3 753.8,479.6 754.2,478.2 	"
                />
                <path
                  className="WMst5"
                  d="M319.3,264.7l-0.2,2.8l3.2,1.6l0.6,3.1l4.7-3.3l-4-4.5l-2.7-0.9L319.3,264.7z M403.3,243.8l6,4.3l0.6-3.3
		l-3.9-3.3L403.3,243.8z M321.5,118.8l4.5,1.8l-4-6.4L321.5,118.8z M377.2,83.4l-1.8,4.2l-2.4-3.2l-8.9,2l-3.2,2.4l1.7,15.8
		l-10.9-11.1l-8.7,3.7l-0.5,8.2l1.3,5.2l-2.9-2.8l-3.9,0.6l7.3,13.5l0.2-2.2l0.2-5.6l0.7,2.8l-0.3,11.5l-13.8-17.7l-3.6,1.7
		l3.9,11.2l-8.8-3.1l-3.2,8.3l-1.2-15.5l-11.4,4.9l-0.9,4.9l-5,0.2l-1.2,9.4l0.6,8.2l-5-5.7l-1.6,1.4l-9.4,13.4l1.3,4.5l3.3,0.8
		l5.7-2.2l-3.8,12.1l-2.5,3.8l-7.5,1.4l-5.3,6l-4.6,0.7l-1.8,5.1l7.6,7.9l0.4,4.2l-1.2,5.5l7.4,1.2l-4.7,3.2l3.1,3.9l5.6,1.9
		l0.8-4.2l6,2l2.8-3.4l5.3,2.1l0.9,2.1l3.3,0.6l3.3,3.2l0.6,6.8l5.5,5.7l0.6,5.2l2.5,6.7l0.9,9.3l-2.5,3.1l2.2,5.9l2.5-0.8l1.4-3.6
		l1.1,3.9l3.7,0.5l-0.9,2.9l3.6,2.4l-0.2,3.5l-6.1-3.7l-3.3-0.5l-1.3,1.5l6.2,4.9l4,0.2l0.2,2.6l-1.3,7.5l-3.2,4.3l-1.9-0.2l-2.3,8
		l0.9,4.1l-0.1,2.8l1.3,2.4l2.1,0.5l-0.2,3.2l0.8,2.5l0.1,3.5l1.2,0.1l1-3.1l1.9,1.8l-2.4,4.7l1.5,3.4l2.4,0.9L332,318l2.7,1.2
		l0.2,3.3l4.6,4.2l2.6,0.5l2.7-1.4l0.1,3.8l2.7,2.7l2.6-0.9l2.8-5.3l1.2-4.4l0.1-3.1l-1.4-1.7l2.5-5.4l2.7,0.4l-0.6-3.6l1.8-1.8
		l-2.3-3.8l2.6-0.3l1.5-1.6l1.1-3.3l1.1,1.5l1.9-0.7l1.2-2.8l1.6,2l6.7-3.9l1.8-4.7l1.5-0.6l0.9-4.3l3.3-1.8l3.5-2.7l2,1.2l6.6-2.6
		l5.3-2.9l6.7-6.1l0.6-2.3l-6.1-3.8l-2.9,1.8l-1.2-2.4l-4,1.1l0.8-4.2l2.9-0.5l-0.6,0.3l-2.8,3.6l5.9-0.7l0.7-4.7l-2.5,1.2l3.3-2.7
		l2.2-0.7l1.6,5.7l1.9,1.8l2,0.1l0.3-3.9l0.3,3.8l2,0.2l0-8.1l-2.7-1.4l0.3-3.2l-6.4-5l-0.5-5.4l-1.7-1.2l3.5,1.5l-0.9-3.9l-2.8,2.4
		l-0.8-0.5l5.3-4.3l4.5,4.1l2.5-2.2l3.1,0.1l0.4-4l-4-1.7l-1.9-2.5l3.9-3.4l1.2-5.8l2.6,0.6l0.7-6.5l-1.1-4.6l-3.4-2l-2.1,1l0.4-4.9
		l3.1-3.1l1.9-0.4l3.6,2.7l0.6-6.8l-3.1,0.7l0.7-6.6l-4.3-3.3l-0.9,4.8l-2.3,0.6l3-13.6l-1-2.5l4.8-7.8l1.5-11.8l-4.5,5.3l0.2-6.1
		l3-2.4l7.2,1.5l3.1-4.1l0.6-3.3l3.7-2.6l2-3.5l5.1-5.9l-0.6-4.1l-10.9-6.3l-4.5,9.2l-3-2.4l-2.5,2.2l-0.3-3.5l-9.4,11.9l-0.5,5.5
		h-2.4l7.2-15.5l0.1-11.3l-5.3,1l-0.5,5.6l-3.3-5.6h-11.1l-9.6,7.2l-2.4-2.7l8.4-6.3l14.9-1.2l8.4-3.3l4.5-6.1l-6.6-6.6l-5.3-3.4
		l-3.7-7.9L377.2,83.4z"
                />
                <polygon
                  className="WMst5"
                  points="473,508.9 474.8,507.6 474.8,507.6 476,507.7 477.1,506.4 478.3,505 479.5,506.1 479.5,506.2 
		480.2,506.8 480.3,506.8 480.3,506.9 480.4,506.9 481,510 480.3,511.9 478.1,514.2 477.9,521.7 475,522.1 474.8,520 474.9,514.3 
		474.2,512.9 474.2,511.7 472.6,510.6 	"
                />
                <polygon
                  className="WMst5"
                  points="746.2,482.2 746.3,482.2 746.4,481.7 746.4,481.6 746.5,481.6 748,479.4 749.2,478.7 749.4,479.7 
		751,479.8 750.3,476.7 751.9,476.2 754.2,478.2 753.8,479.6 756.2,481.3 757.3,480.4 758.8,481.3 759.3,483.9 756.7,485.3 
		760.2,487 761.9,490 764.1,491.9 764.4,493.5 766.6,494.5 765.9,495.5 767,496.5 766.8,498.5 764.9,499.6 764,498.8 762.6,499.4 
		762.5,500.6 762.5,500.6 760.4,499.5 761.3,498.9 761.6,495.8 761.1,495.5 761,495.5 760.8,494.8 760.9,494.8 760.9,494.8 
		761,494.8 760.6,494.7 760.3,494.6 760.2,494.6 760,494.5 760,494.5 760,494.5 759.9,494.4 759.9,494.1 759.8,494 759.6,493.8 
		759.5,493.8 759.1,493 759.1,492.9 759.1,492.5 759.1,492.3 759.1,492.3 759.1,491.8 759.2,490.8 757,488.1 755.9,487.9 
		755.7,487.8 754.9,488 755.1,488.1 754.4,489.1 754.3,489.1 753.5,489.4 753.5,489.4 753.4,489.6 753.4,489.6 753,489.1 
		752.8,489.1 752.1,488.7 752,488.6 752,488.6 752,488.5 751.9,488.5 751.8,488.4 751.6,488.5 751.3,488.9 751.1,488.9 750.9,488.9 
		750.8,489 750.8,489.3 750.6,489.3 749.1,490.6 748.9,487.8 749.8,486 749.3,485 747.4,484.6 747.6,482.9 746.6,482.4 746.5,482.4 
			"
                />
                <polygon
                  className="WMst5"
                  points="566.8,455 569.9,455.5 571.7,453.4 573.8,453 575.2,451.4 572.4,448.2 578,446.6 578.8,445.8 
		580.7,446.4 588.9,450.6 588.9,451.4 593.7,455.5 598.7,455.8 601.3,456.1 601.9,457.6 603.9,457.6 605.1,460.5 608.2,463.1 
		608.9,464.3 608.2,465.4 610.5,469.2 611.8,469.9 612.6,470.7 615.3,474.6 622.6,475.3 623.9,477.4 622,483.3 613.7,486.2 
		605.8,487.3 603.2,488.6 601.3,491.6 600,492.1 599.3,491.1 597.5,491.2 595.1,490.7 591.2,491 589.9,490.3 589.6,492.9 
		588.3,493.6 587.1,490.6 585.6,489.5 584.2,487.3 582.9,484 579.9,482.1 578.5,480 578.3,476.2 576.4,472.1 575,470.8 573.6,470.3 
		573.1,467.8 571,465 567.5,459.1 565.7,459 	"
                />
                <polygon
                  className="WMst5"
                  points="434.1,460.4 446.2,460.3 446.6,460.3 446.6,465.4 438.3,465.4 437.4,466.2 437.4,473.1 435.8,473.6 
		434.3,474.8 434.6,479.3 426.4,479.3 423.7,479.5 423.5,481 423.5,479.3 424.1,476.9 425,476.4 427,471.7 429.5,469.3 429.6,467.5 
		430.6,464.8 433.1,463.1 	"
                />
                <polygon
                  className="WMst5"
                  points="480.4,506.9 480.5,504.6 481.8,503.3 482.8,501.4 485.6,500.8 488.2,501.6 489.6,503.3 492,502.3 
		494.4,503.5 497.1,503.8 498,502.8 499.8,502.3 502,502.2 504.7,503.1 505.8,502 508,501.3 509.3,503 509.8,505 509.9,505.1 
		510.9,505.6 510.7,507.4 508.3,508.9 506.9,512.8 505.9,513.4 505.7,515.1 504.2,516 503.2,519.7 502.2,521 501.1,521.3 
		499.6,519.5 497.4,520.5 494.8,523.2 494.2,525.8 494.2,525.8 494.2,525.9 494.2,526 494.2,526 493.3,526.7 490.5,526.8 
		487.2,527.5 485.6,525.9 485,523.8 482.5,521.7 477.9,521.7 478.1,514.2 480.3,511.9 481,510 480.4,506.9 	"
                />
                <polygon
                  className="WMst5"
                  points="436.7,498.3 437.9,497.9 438.7,495.8 440.4,497.3 440.9,496.4 444.8,496.2 455.3,496.2 455.8,493.8 
		455,493.4 452.4,468.4 457.2,468.4 473.7,480 473.7,481.1 475.4,482.4 476.6,482.3 479.4,483.8 479.6,486.2 482.2,485.8 482,493.6 
		481.2,495.6 480.1,496.6 478.8,496.4 474.1,496.8 473.1,497.7 471.1,497.6 468.5,497.4 466.9,498.4 463.7,499.6 461.5,501.3 
		461,502.7 461,502.8 459.5,502.2 458.5,502.9 458.3,505.2 456,506.7 455.3,508.6 455.3,510.5 453.4,511 453.3,509.6 451.1,511.2 
		450,510.7 448.5,511.2 447.5,510 447.4,508.1 447.3,507.8 446.5,507.1 446.4,507.1 445.8,505.1 443.8,506 442,505.4 441.1,506.4 
		439.1,504.9 439.2,503.3 437.6,500.7 	"
                />
                <polygon
                  className="WMst5"
                  points="496.8,452.2 497.3,452 497.5,451.9 498.8,450.1 498.4,448.2 499.8,446.6 502.3,445.1 502.1,443.3 
		502.3,442.8 502.3,442.8 504.6,443.9 507.3,443.6 512.4,445.4 513.3,447.9 514.6,448.9 518.4,449.5 523,452.1 525,451.6 526,449.2 
		525.4,447.3 525.7,446.2 527.1,444.8 530.1,443.5 531.5,443.5 534.1,444.5 534.7,446.1 539.3,446.7 539.7,447.6 539,448.6 
		539.4,450.5 538.5,452.5 539.4,455.3 539.4,483.3 536.6,483.3 536.6,484.7 525.7,478.7 514.6,472.9 511.8,474.4 509.7,475.6 
		507.8,473.9 503.5,472.9 502.4,470.7 500.5,469.8 498.6,469.5 498.1,467.3 496.4,464.8 497.6,463.8 497.4,461.5 497.9,459.6 
		497.4,454.8 	"
                />
                <polygon
                  className="WMst5"
                  points="491.4,390.5 494.2,390.3 494.2,390.3 494.9,390.1 495.6,390.1 495.8,390.2 496.8,390.8 496.7,391.8 
		496.6,392.6 496.9,392.6 499.3,393.5 497.9,395.3 496.5,394.9 496.4,395 494.6,396.4 494.4,396.4 493.7,395 492.1,397.2 
		489.9,397.2 489.2,395.3 487.7,395.6 487.3,394.9 488.9,392.5 489,392.5 489,392.5 489,392.4 489.6,391.7 	"
                />
                <polygon
                  className="WMst5"
                  points="438.9,520.1 439.2,519.7 439.2,519.7 439.2,519.6 439.2,519.5 439.3,519.4 439.4,519.4 439.4,519.3 
		441.2,517.8 442.1,515.9 444.3,516.2 444.5,518.5 445.4,519.4 447.1,518.4 447.7,520 446.8,521.3 448.7,521.9 450,523.2 
		450.2,524.6 449.7,527.2 445.5,525.5 442.7,522.8 439.1,520.7 	"
                />
                <polygon
                  className="WMst5"
                  points="320,532.8 321.1,531.6 321.4,530.2 321.5,530.1 320.4,526.9 320.4,526.7 320.5,526.6 320.5,526.6 
		320.5,526.3 320.4,526.2 320.4,526.2 320.3,526.2 320.4,525.9 320.3,525.8 320.6,525.1 320.7,525 321.6,523.9 322,523.4 
		324.6,524.2 326.3,526 327.7,526.5 328.1,528.1 327.2,529.1 327.2,529.1 325.7,532.3 324.5,533.2 322.4,532.7 321.4,533.4 	"
                />
                <polygon
                  className="WMst5"
                  points="241.2,497.7 241,497.7 241,497.6 240.3,497.8 240.3,497.8 240.2,497.8 240.2,497.9 239.8,498 
		239.8,498.1 239.8,498.1 239.7,498.1 236.9,498.4 236.9,498.4 236.9,498.3 236.9,498.3 236.5,498.2 236.4,498.3 235.9,498.8 
		235.9,498.8 235.8,499.6 235.8,499.7 234.1,500.6 231.4,501.1 231.5,502.4 229.9,503.3 228.5,502.1 228.8,501 226.6,500.7 
		224.2,499.3 224.8,497.4 227.3,495.6 228.7,495 231,495.5 236.2,494.8 238.1,495.3 239.6,497.1 	"
                />
                <polygon
                  className="WMst5"
                  points="787.4,525.8 786.4,528.2 784.8,526.6 	"
                />
                <path
                  className="WMst5"
                  d="M502,337.6l0.5,0.4l0.1-0.2l0.5-4.8l1.7-1.3l1-7.4l-1.9-2l0.3-2.3l0.1-0.9l0-0.1h0l-0.1-0.2l0-0.2l-0.7-5.5
		l0.8-2.4l0.1-0.1l0-0.1l0-0.1l1.6-2.1l3.3-0.5l0-0.1v0.1l0.2-0.4l-1.3-2.9h0l1.7-3.2l0.6-6.1l0.2-0.7l4.8-6.2l0.3-3.9l0-0.1h0
		l0.1-0.2l2-3.4l0-0.1l1.7,0.9l0.4-0.7l1-3.8l4.3,1.6l0.1-1.5l0.3-3.7l1.4-0.1l1,1.2h0.1l0.2,0.1l0.1,0.1l0.6,0.7l0,0.1l1.2,1.2
		l0,0.1l0.4,0.1l0,0.1l0.3,0.2l0.1,0.5l0.7,0.1h0.2l2,1.3l1.6,2.9l-0.5,2.5l0,0.1v0.7h0.1l0.1-0.1l0.1,0.1h0.1l0.3,0.7h0.1l-0.5,0.6
		l1.1,3.2l-0.1,0.1l-0.2,0.9v0.2l0,0.1l0,0.3l-0.1,0.1l-0.1,0.1l-0.2,0.4l-0.1,0.1h-0.1l0,0.3v0.1l0.1,1l0.1,0.2l0.1,0.1l0,0.2
		l0.3,0.1l0.2,0.1l0,0.1l0.1,0.2v0.1l0.1,0.3l0,0.1l0.1,0.5l0.1,0.2l0.1,0.1v0.1l-2.8,1.4l-2.2-1l-2.1,5.2l0.2,4.1l-2.9,4.4
		l-7.3,5.4l-0.7,3.6l-1.7,3.8l0.9,4.7l1.8,0.8l3,4.8l-2.1,2l-0.9,1.8l-3,2.3l-1.2,9.5l-1.7,3.5l-2.3-0.6l-1.8,1.2l-0.4,2.8l-3.4-0.1
		l0.4-1.3l-1.7-3l1.4-1.4l-1.6-1.7l-1.2-3.9V341l-1.8-0.1L502,337.6z M507.9,339.3l1-0.7l0.2-2.8l-1.2-0.3l-2.1,1.6l-0.4,2.4
		L507.9,339.3z M535.6,292.5L535.6,292.5L535.6,292.5L535.6,292.5z M522.2,344.4l0.4,1.5l-1.7,1.5l-0.5-2.2L522.2,344.4z"
                />
                <polygon
                  className="WMst5"
                  points="539.4,588.8 539.4,588.8 539.7,588.8 539.7,588.7 540,588.7 540.1,588.7 540.2,589.5 542.1,592.1 
		542.6,593.8 545.4,595.3 546.8,596.6 546.8,598.3 547.7,599.7 550.5,600.4 551.3,601.4 551.4,601.5 551.4,601.5 548.6,602.6 
		546.9,604.6 544.9,605.8 544.4,607.7 543.2,608.9 541.7,609.1 540.9,611.8 537.6,612.2 535.1,610.8 534,610.8 532.7,613.6 
		530.3,615.6 527.3,615.4 527.9,613.3 526.7,610.2 525.6,609.2 525.6,600.9 528.3,600.9 528.3,590.2 534.7,589.3 535.5,590.7 
		537.1,589.3 	"
                />
                <path
                  className="WMst5"
                  d="M553.5,268.8l-1.2,2.4l-0.4,0.2l-0.5,0.2l-0.1,0.8l-1,1.2l0.3-5.2l-3.9-2.9l-3.3,1.4l0,0.2l-0.7,1l-0.2,0.2h0
		l-0.2,0.2l-0.2,0.3h0.1l-0.2,0.9l0,0.1l-0.1,0.7l0,0.1l0,0.2l-0.4,3.9l-1.5,1.9l-3.1-1.2l-1.8,1.1l-2.6-0.5l-2-4l-3.1,1.5l-1.3,0.1
		l-0.3,3.7l-0.1,1.5l-4.3-1.6l-1,3.8l-0.4,0.7l-1.7-0.9l0,0.1l-2,3.4l-0.1,0.2h0v0.1l-0.3,3.9l-4.8,6.2l-0.2,0.7l-0.6,6.1l-1.7,3.2
		h0l1.3,2.9l-0.2,0.3v0.1h0l-3.3,0.5l-1.6,2.1l-0.1,0.1l-0.1,0.2l-0.8,2.4l0.7,5.5l0,0.2l0.1,0.2h0h0l0,0.1l-0.1,0.9l-0.3,2.3l1.9,2
		l-1,7.4l-1.7,1.3l-0.5,4.8l-0.1,0.2l-0.5-0.4l-2.6-1.8l-0.6,1.4l-3.3,1.8l-2.3,3.1l-1.8,0.6l-1.9-1.5l-1.5,0.1l-2-1.4l-0.1-3.8
		l-1.2-1.5l3-3.3l-1.6-2.9l-1.8-1l-0.3-4.8l2.8-3.5l3.9-2.1l2-0.3l0-2.6l1.4-1.8l3.1-1.5l0.6-2.6l3.7-3.7l1.9-2.7l0.6-3.4l2.1-3.3
		l0.5-4.5l2.1-0.5l2.2-3.1l1-2.8l1.9-0.6l2.1-3.4l-0.4-2.7l2.8-3.4l2-1l0.7-2.5l1.9-2.4l3.3-1.7l0.4,1.6l2.2-2l2.5,2.2l0.6-4.2
		l2.3,0.3l1.9-2.2l1.2,0.3l0.9-4.5l1.7,1.6l-0.6,6.2l4.6-7.6l-0.5,5.1l1.7-0.9v-3.8l1.5-1.7l2.5,1.4l2,2.7l2.5-0.3l2.4,3.4l-3.9,2.4
		L553.5,268.8z M504.4,310.5l0,0.1L504.4,310.5L504.4,310.5z M536.5,188.7l-8.6,3.1l1.9-6.2l3.5-4.5L536.5,188.7z M527.5,181.6
		l3.4-4.9l0.5,4.3L527.5,181.6z M516.7,199.3l-0.7,1.6l-2.9-2l-4.4-7.7l-0.9-7.3l10.6-5.3l-5.5-0.3l-6.8,3.5l-1.7-4.6l-2.4-2.7
		l-2.4-12l2.8-4.3l1.8,2.6l4-3.4l0.1,5.4l2.5-4l4.7,13.6l-2.2-13.7l1.8-4.1l4.8,4.9l2.5,9.5l2.7,1.7l4.1,4.7l-6.8,2.4l-1.7,13
		l-1.9-0.8L516.7,199.3z M532.4,150.6l0.9-3.3l1,6.5l3.1-4.1l8.2,4.9l-4.1,9.6l-5.1,3.4l-10.6-3.7l-3.6-3.8l0.7-10l1.7-2.8l3.5,5.1
		l2.4-1.1l1.2,4.7L532.4,150.6z"
                />
                <polygon
                  className="WMst5"
                  points="692.9,513.7 694.6,515.8 694.7,516.8 696.1,519.2 695.2,521.7 692.2,522.9 691.1,522.2 690.4,520.1 
		690.7,514.6 691.6,512.1 	"
                />
                <polygon
                  className="WMst5"
                  points="564.5,513 564.9,510.2 566.8,508.2 566.8,508.2 567.1,506.6 568.8,504.2 570,504.1 571.2,499.7 
		573.3,499.2 574.9,497.9 576.4,499.3 579.6,498.7 583.3,500.2 587.3,504.8 585.7,506.8 585.7,508.1 585.6,508.6 588.8,508.9 
		588.2,509.9 589.8,512.7 591.9,514.5 599.9,517.2 602.7,517.2 595.6,524 594.4,525.7 591.2,525.7 589.3,526.5 588.5,527.5 
		585.9,528.3 583.9,528.4 582.8,527.4 580.3,528.6 579.4,529.9 576.7,529.2 575.5,529.3 572.5,527.2 571.7,527 571.6,527 570.2,527 
		569.7,526.9 569.6,526.8 569.5,526.6 569.5,526.5 569.3,524.6 567.8,524.6 566.7,521.2 564.9,520.1 563.4,518.1 561.5,517.7 
		562,516 563.5,516.2 564.5,515.5 	"
                />
                <path
                  className="WMst5"
                  d="M489.9,397.2h2.3l1.6-2.1l0.7,1.4h0.2l1.8-1.5l0.1,0l1.4,0.4l1.4-1.9l4.4-0.9l0.8,1.4l3.7,0.8l-0.9,0.9
		l0.9,2.8l-1.7-0.2l-2.7,1l0.9,1.9l-0.2,2.4l3.5,2.7l1.4,3.9l2.6,2.2l2.9,0.1l-0.5,1.7l5.6,2.9l1.4,1.9l-4.5-1.1l-1.1,2.4l1.8,1.3
		l0.1,1.3l-1.7,0.7l-0.1,1.3l-1.4,1.8l-1.2-1l1.6-2.4l-1.5-4l-2.1-0.8l-0.4-1.6l-2-0.4l-0.9-1.7l-1.8,0.1l-1.2-0.8l-2.8-3.2
		l-3.1-2.4l-0.9-3.8l-4-1.9l-1.9,2.1l-1.5,0.4L490,402l-1.2-1.6l1.5-1.1L489.9,397.2z M512.6,429.7l-0.5,1.4l-2.3-1.4l-4.4-1.8
		l-0.7-0.8l2.5-1.5l1.2,0.9l5.3-1.1l-1.5,2.7L512.6,429.7z M494.2,419.8l-0.1-3.4l1.9-1.6l1.2,1l0.5,1.7l-0.9,5.1l-2.5,0.7l-0.7-1.2
		L494.2,419.8z"
                />
                <polygon
                  className="WMst5"
                  points="302.2,500.8 302.5,501.3 302.6,500.2 	"
                />
                <polygon
                  className="WMst5"
                  points="224.8,489.6 227.1,487.6 227.7,488.4 227.1,490.1 227.3,492.5 225.5,495.1 224.7,495.1 	"
                />
                <polygon
                  className="WMst5"
                  points="547.7,335 548.1,335.7 547.6,336.1 547.6,336.1 547.5,336.1 547.5,336.1 547.4,336.2 547,337.4 
		546.9,337.5 546.9,337.6 544.7,338.5 546.6,342.8 546.7,342.7 546.7,342.8 546.8,342.8 546.8,343.3 545.8,345.3 543.8,345.4 
		540.2,342.4 538.9,342.9 538.7,342.9 537.6,343.5 535.2,339.2 535.2,336.3 541.3,333.9 544.8,335.3 	"
                />
                <polygon
                  className="WMst5"
                  points="234.3,508.6 238.6,509.5 238.6,509.5 238.7,509.5 238.9,509.5 239.3,509.6 239.4,509.6 239.8,509.1 
		240.6,510.7 243,512.8 242.9,512.9 242.9,512.9 242.5,512.9 242.5,512.9 241.9,514.2 242,517.1 239.7,515.5 240,514.3 237.3,512.8 
		236.9,511.6 234.4,511.9 233.8,510.6 	"
                />
                <polygon
                  className="WMst5"
                  points="548.7,621.1 549.4,620.9 551.6,623.3 550.8,625.1 548.7,625.8 547.9,627.5 546.9,627.3 544.9,624.2 
		545.9,623.8 546.9,621.9 	"
                />
                <polygon
                  className="WMst5"
                  points="470.1,508.5 473,508.9 472.6,510.6 474.2,511.6 474.2,512.9 474.9,514.3 474.8,520 475,522.1 
		473.8,522.4 471.9,520.4 472,513.3 471.1,513.2 471.6,510.8 470.3,509.9 	"
                />
                <path
                  className="WMst5"
                  d="M552.2,551.4l1-0.5l2.2-3.6l-0.8-1.6l0.9-0.3l-0.3-2.1l-0.8-1.3l3.6-0.2l0.2,0.7l-0.7,2.1l0.4,1.6l1.4-1
		l1.9,0.4l1.9-1.7l1.2-2.1l9.5,5.3l0.7,1.8l3.9,2.9l-1.1,3.7l0.2,1l1.9,1.7l-0.8,1.1v3.2l1,1.7l0.2,2.2l1.9,1.5l-0.8,0.6l-0.1,0
		l-0.1,0.1l-0.1,0.1l-0.9,0.4l-0.2,0l0,0l-0.1,0.1h0l-0.2,0.1l0,0l-0.1,0.1l-0.4,0.3l0,0h-0.2l-0.9,0.1l-0.1,0.1l-0.1,0.1l-0.2,0.1
		H577l-0.2,0.2l-0.1,0l0,0l0,0.1l-0.1,0.1h-0.1l-0.1-0.1l-0.1,0l-0.4-0.3l-0.2,0h-0.3l-0.1,0l-1,1l-2.8,0.4l-0.1-0.1l-4.5-0.4
		l-0.8-1.2l-0.4-2.8l0-0.1l-1.6-1.3v0.1l0,0.2l-2.7-0.9l-2.7-0.9l-2.2-1.3l-1.5-2.6l-0.2-1.8l-1.2-1.4l-1.2-0.5l0.7-1.4l-1-2.4
		L552.2,551.4z M557.9,559.6l0.7,2l1.7-0.4L557.9,559.6z"
                />
                <polygon
                  className="WMst5"
                  points="535.8,512.6 538.9,512.2 539.6,510.8 541.4,510.4 543.2,512.9 547.4,512.7 547.1,511.2 550.4,511.2 
		550.4,512.6 551.9,512.3 553.1,510.8 555.4,512.3 556.8,512.3 558.6,509.8 559.9,508.8 559.7,506.9 560.7,505.6 560.7,505.5 
		562.2,505.5 561.8,507.6 562.1,509.5 564.1,511.2 564.5,513 564.5,515.5 563.5,516.2 562,516 561.5,517.7 563.4,518.1 564.9,520.1 
		566.7,521.2 567.8,524.6 569.3,524.6 569.5,526.5 568.3,526.5 567.8,525.4 565.2,526.5 564.1,527.6 562.8,528.9 561.5,528.5 
		558.6,529.4 558.6,529.4 556.4,528.8 555.5,529.6 555.5,529.6 553.7,528.4 552.2,526.4 551,527.3 549.8,526.7 548.7,527.4 
		546.1,525.4 545.4,523.5 543.5,522.5 543.3,520.9 539.9,518.6 539,516.7 537.1,516.3 537.3,515.3 535.2,515.2 	"
                />
                <polygon
                  className="WMst5"
                  points="693.7,452.3 696.7,451.9 696.9,452.7 699.9,454.3 700.8,455.5 705,458.2 706.4,458.4 707.4,459.5 
		709.4,458.9 710.6,459.8 713.3,459.6 713.3,459.6 713.1,461 713.1,461.1 713.1,461.1 713.1,461.1 713.1,461.1 713,461.7 
		713.4,463.2 713.4,463.2 713.4,463.2 713.3,463.6 713.3,463.6 711.1,464.3 710,463.8 709.6,464 707.5,463.4 707.4,463.4 
		707.4,463.4 707.4,463.4 707.4,463.4 705.6,463.1 703.7,462.2 702.3,460.7 701.5,461.2 698.5,460.8 695.8,459.5 695.8,459.4 
		693.3,457.7 693.2,457.7 691.2,456.7 691.2,456.2 692.4,453.4 	"
                />
                <polygon
                  className="WMst5"
                  points="666.1,418.6 664.9,419.3 663.4,418.6 661.4,419.7 661.5,421 664.8,420.8 665.8,421.6 667.5,420.8 
		668.3,422 673.3,421.3 674.9,424.2 676.3,425 677.2,427.2 676.8,429.1 673.8,428.4 673.2,428.4 672.4,428.3 670.5,429.8 
		670.5,429.9 670.3,429.9 670.2,429.9 668.6,430.8 668.5,430.9 667.3,429.7 667.5,428 667.5,427.8 667.7,426.7 667.7,426.7 
		666.1,424.8 662.4,427.9 661.4,429.5 661.4,429.5 661.3,429.6 661.2,429.5 660.9,429.3 660.8,429.1 660.8,429.1 660.7,429 
		659.3,429.4 659.2,429.4 659.1,429.4 659.1,429.5 658.7,429.5 658.6,429.6 658.6,429.9 658.4,429.8 657.6,429.8 657.5,429.7 
		657.3,429.6 657.3,429.3 657.5,427.7 658.6,426.8 658,425.1 658.4,423.2 657,423 657,420.6 659.4,421 659.6,419.9 664.6,415.6 
		664.5,417.6 664.4,417.7 664.3,417.8 664.3,417.8 	"
                />
                <polygon
                  className="WMst5"
                  points="638.2,453.4 642.6,454.9 645.7,454.6 647.1,454.9 649.3,454.4 649.3,454.4 651.7,453.9 651.8,453.8 
		653,452.7 653.4,450 654.3,449.1 658.3,447.1 660.2,447.9 661.5,446.8 661.3,445.1 662,443.3 664.3,442.2 663.1,439.9 665.7,440.1 
		666.4,437.8 668,436 667.6,434.2 666.7,433.2 667.9,431.7 670.7,430.4 675.9,429.8 678.2,430.1 679.7,431.3 680.3,433.9 682,434.5 
		682.6,436.9 679.2,438.3 675.2,437.4 674.3,437.7 674.4,442.7 676.2,444.3 676.3,444.4 678,446.1 676,447 676.2,448.4 675.2,450.4 
		675.1,450.5 674.3,452.3 672.7,453.1 671.5,456 669.9,456.8 668.6,459.4 665.7,460.2 664.4,459.2 662.2,461.8 662,463.1 
		663.8,463.7 663.6,465.6 665.2,467.2 666.1,470 666.3,470.3 665,470.6 664.7,470.2 664.5,470.3 663.9,470.4 663.4,470.9 
		660.3,470.5 658.6,471.2 656.8,470.4 656.7,469.2 654.1,468.9 653.7,467.2 649,467.4 645.9,467.2 645.4,467.8 640.3,467.9 
		641,464.6 642.5,463.6 644.6,463.4 645,462 643.5,461.6 643.4,459.1 643.5,458.4 640.9,457.3 	"
                />
                <path
                  className="WMst5"
                  d="M502.9,587.1l1.8-0.1l2.2-0.7h0.1l1.8,1.1l12.4,0.1l1.3,1.2l4,0.1l3,0.4l5.5-1.1l2.3-0.5h0.1l0.1,0l0.1,0
		l0.8,0.1l0.1-0.1l1,0.3l0,0l0.5,0.5l0,0l-0.3,0.1l-0.1,0.1l-0.3,0v0l-2.2,0.5l-1.7,1.4l-0.8-1.4l-6.4,0.9v10.7h-2.8v19.5l-1.2,0.3
		l0,0l-1.1,1.3l-3-0.2l-1.7-0.9l-0.1,0l-1.6-0.7l-0.1,0.1l-0.6,0.5l-0.2,0.1l-0.1,0.1l-2.5-2.6l-1.6-4.4l-0.2-3.7l-1.2-3.1l-0.1-5
		l-2.8-4.3l-2.3-5.1l-1.6-1.9l-0.6-1.5L502.9,587.1z M516.2,590.5l-1.9,0.9l0,1.2l2.7-0.8L516.2,590.5z"
                />
                <path
                  className="WMst5"
                  d="M725.6,477.4l1.6-0.8l-0.2-2.4l0.7-0.2l-0.1-2.9l2.3,0.7l1.6-3.5l-0.3-1.2l1.5-2l-0.1-1.7l2.6-1.9l1.4-0.5
		l2-1.6l0-1l0.4-0.9l0,0l0.6,0.1l2.7,2.8l0.2,2.9l-0.2,2.1l-2.5,2.4l-0.6,1.2l1.5,2l2-0.1l0.2,2.8l1.7,0.3l-0.9,2.8l2.2,0.3l0.5,1.7
		l2.7-0.2l-1.2,0.7l-1.5,2.2h0v0.1l-0.1,0.5h-0.1l-1.7-0.1l-1.3,1.9l-2.7-0.2l-1,2.5l-0.9,1l1,1.4v0l0.1,0.3l0,0.1l2.2,3.3v0
		l0.4,1.5l-0.3,2.5l-0.9,1.6l2.4,2.7l0,2.3l0.9,1.4l0.6,2.1l-1.2,2l-1.2,1.2l-0.2,1.2l-0.7-1.2l1-3.2l-0.7-1l0.4-1.7l-1.3-2.5
		l-1.1-2.9l-0.3-3.2l-2.3-3l-0.6,1l-2.6,1.3l-0.9,1.2l-2.9-0.8l-0.4-1.5l1.2-2.7l-1.6-3.9l0.1-1.6l-1.6-1.5l-0.6-1.2l-1.8-0.9
		l-1.1-1.4h0l-0.1-0.1L725.6,477.4z M746.5,481.6L746.5,481.6L746.5,481.6L746.5,481.6z"
                />
                <polygon
                  className="WMst5"
                  points="536.6,569.2 537.8,570.8 540.3,570 540.3,571.2 542.1,572.1 544.5,572.2 548.9,573.7 550.4,576.2 
		552,575.6 552.6,572.7 551.2,573.4 551.1,573.3 550.8,573.3 550.7,573.4 549.7,572.3 549.7,572.2 548.8,571.7 548.9,571.6 
		548.9,570.4 548.9,570.3 549.3,567.2 549.3,567.2 549.4,567.1 549.2,565.3 549.2,565.3 549.1,565.2 550.7,563.4 550.2,562.5 
		554.7,562 556.4,562.8 558.6,564.1 561.3,565 562.4,566.2 563.3,568.2 562.1,569.2 562.4,573.8 561.2,574.4 561,576.6 562.1,577.9 
		553.8,580.8 554.1,582.2 554.1,582.3 554.2,582.4 554.3,582.4 554.3,582.5 552.6,582.4 552.5,582.5 551.5,582.7 551.4,582.7 
		550.4,583.4 550.1,583.5 549.9,584.2 550,584.3 549.9,584.5 550,584.6 549.7,585.1 546.6,586.3 545.1,589 544.3,589.3 544.3,589.3 
		544.1,589.4 543.9,589.5 541.7,589.1 541.5,588.9 541.5,588.9 541.4,588.8 541.3,588.8 541.2,588.7 541.3,588.7 541.2,588.7 
		540.1,588.7 540,588.7 540,588.6 539.5,588.2 539.5,588.2 538.5,587.8 538.4,587.9 537.6,587.8 537.5,587.8 537.4,587.8 
		537.3,587.8 535,588.2 531.4,584.9 531.1,584.1 531.1,575.1 536.8,575.1 	"
                />
                <path
                  className="WMst5"
                  d="M536.9,296.3L536.9,296.3l-0.1-0.1l-0.1-0.2l-0.1-0.5l0-0.1l-0.1-0.3v-0.1l-0.1-0.2l0-0.1l-0.2-0.1l-0.3-0.1
		l0-0.2l-0.1-0.1l-0.1-0.2l-0.1-1v-0.3h0.1l0.1-0.1l0.2-0.4l0.1-0.1l0.1-0.1l0-0.3l0-0.1v-0.2l0.2-0.9l0.1-0.1l-1.1-3.2l0.5-0.6
		h-0.1l-0.3-0.7h-0.1l-0.1-0.1l-0.1,0.1h-0.1v-0.7l0-0.1l0.5-2.5l-1.6-2.9l-2-1.3h-0.2l-0.7-0.1l-0.1-0.3l-0.1-0.1v-0.1l-0.3-0.2
		l0-0.1l-0.4-0.1l0-0.1l-1.2-1.2l0-0.1l-0.6-0.7l-0.1-0.1l-0.2-0.1h-0.1l-1-1.2l3.1-1.5l2,4l2.6,0.5l1.8-1.1l3.1,1.2l1.5-1.9
		l0.4-3.9l0-0.2l0-0.1l0.1-0.7l0-0.1l0.2-0.9h-0.1l0.2-0.3l0.2-0.2h0l0.2-0.2l0.7-1l0-0.2l3.3-1.4l3.9,2.9l-0.3,5.2l-1.1,3.4
		l0.3,3.1l1.9,1l1.9,2.9l-2.5,6.1l1,1.9l0.6,1.7l0,0.1l0.3,0.5l0.1,0.1l0.3,0.9l0,0.1l-0.2,2.4l-0.1,0.1l-0.4,0.3l0,0.1l-0.4,4.5
		l1.2,1.3l0,0.1l0,1.9l0,0.2l0.2,0.2h0l1.1,1.7l-0.5,3.3l0.1,0.1h0h0.1l0.1,0.2l1.1,0.8l0.1,0.1h0h0l0.9,0.7l0,0.1l1.2,2.1l-0.9,2.3
		l-0.3,0.5l-2.7,3.5l-0.4,0.6l-0.8,0.9l-0.1,0.1l-0.1,0.2l-5.3,5.8l-1.7-0.3l-2.9,1.4l-4.3,0.9l-3.2,1.4l-5-4.1l-0.3-5.4l-1.1-6
		l1.3-3.9l1.3,0.7l3.9-5.8l0.6,0.2l2.5-4.9l2.6-0.9l-0.9-4.1L536.9,296.3z M549.2,272.6l-2.7,1.2l-0.5,2l1.2-0.4L549.2,272.6z
		 M552.4,323.2l-0.1,0.1L552.4,323.2L552.4,323.2z M525.1,329.8l1.2,0.7l-0.3,0.6L525.1,329.8z"
                />
                <polygon
                  className="WMst5"
                  points="509.8,363.9 509.6,363.1 509.7,362.9 515,361.3 516,360 520,358.6 521.2,358.8 522.2,360.9 
		524.6,360.4 524.6,360.4 525,360.5 533.3,360.8 534.3,361.1 535.2,362.7 536.3,366.6 536.3,366.6 536.3,366.6 536.3,366.6 
		536.3,366.6 536.3,366.6 536.4,368.4 535.6,371.4 535.7,371.4 535.5,372.4 535.5,372.4 535.6,373.8 535.8,374.9 536.4,376 
		536.4,376 536.8,377.6 533.2,381.9 532.7,384.3 530.1,382.7 527.8,383.2 527.8,383.2 525,383.8 524.1,382.1 522.4,382.4 521,380.7 
		521,380.7 517.3,379.5 516.5,380 514.6,377.8 512,376 511.3,376.7 511.7,375.9 510.7,372.4 510.6,370.2 510.6,370.2 510.7,369.6 
		510.7,369.5 510.8,369.5 510.8,369.4 509.6,368 509.5,368 509.5,367.8 509.5,367.6 509.4,367.3 509.5,367.2 510,366.8 510.1,366.8 
			"
                />
                <polygon
                  className="WMst5"
                  points="515.8,620.9 515.9,620.8 516.1,620.8 516.7,620.3 516.8,620.2 518.4,620.9 518.5,620.9 520.2,621.8 
		523.3,622.1 524.3,620.8 524.4,620.7 525.6,620.4 525.6,609.2 526.7,610.2 527.9,613.3 527.3,615.4 530.3,615.6 532.7,613.6 
		534,610.8 535.1,610.8 537.6,612.2 541,611.8 541.7,609.1 543.2,608.9 544.4,607.7 544.9,605.8 546.9,604.6 548.6,602.6 
		551.4,601.5 551.4,601.5 552,601.4 552.1,601.4 556.1,601.9 556.2,601.9 556.7,602.2 557.4,605.3 558.6,607.8 558.7,610.4 
		558.6,612.8 556.8,612.1 555.3,614.7 556.3,616.6 558.4,617 558.5,617 559,615.5 559.5,615.6 561.1,615.6 559.7,620.7 556.8,623.4 
		553.2,629.5 549.1,633.6 545.2,636.7 543.4,637.5 541.6,637.3 541.3,638.4 539.5,638.2 538.9,639 535.4,638.2 532.7,638.3 
		530.6,639.6 527.7,639.6 525.6,641.1 522.3,639.6 519.6,634.5 521,633.7 520.8,631.4 518.1,626.5 516.8,622.5 	"
                />
                <polygon
                  className="WMst5"
                  points="641.4,141.3 634.9,142.3 634.9,149.4 639.4,148.9 	"
                />
                <polygon
                  className="WMst5"
                  points="731.1,153.3 738.6,152 738.9,142 734.5,135.1 726.4,141.7 724.4,148.9 724.4,153 728.9,155.6 	"
                />
                <polygon
                  className="WMst5"
                  points="727.6,159.3 727.7,155.6 721.2,154.6 721.7,158.1 	"
                />
                <polygon
                  className="WMst5"
                  points="729.1,161.6 732,170.1 734.1,169.2 742.2,173.4 746,171.8 745.5,166.7 746.1,158.1 742.6,154.4 
		741.4,158.2 739.6,152.8 733.3,155.1 	"
                />
                <polygon
                  className="WMst5"
                  points="649.5,135.8 644.1,145.1 650,141.7 	"
                />
                <polygon
                  className="WMst5"
                  points="966.5,258.1 968.6,258.9 972.2,257.7 971.2,253.5 966.5,253.4 962.7,257.3 963.1,259.7 	"
                />
                <polygon
                  className="WMst5"
                  points="746.1,185.3 749.5,182.3 754.7,181.6 760,179.7 758.2,170.8 752.8,164.4 750.6,165.6 744.3,184.4 	"
                />
                <polygon
                  className="WMst5"
                  points="885.6,221.5 886.4,218.7 881.3,217.6 877.2,215.3 875.3,216.5 874.1,213.7 873.1,217.5 879.2,222.5 	
		"
                />
                <polygon
                  className="WMst5"
                  points="859.3,231.9 858.7,234.4 855.6,236.3 865.2,238.4 865.9,235.6 861.9,231.3 	"
                />
                <polygon
                  className="WMst5"
                  points="853.7,223.9 855.3,220.5 856,222.3 861.4,220.1 863.1,222.2 869.3,218.5 869.4,215.8 867.4,211.3 
		859.1,209.1 858.6,213.7 853.9,206.8 852,208.6 849.3,209.9 847.8,217.3 851.2,222.6 	"
                />
                <polygon
                  className="WMst5"
                  points="621.9,235.9 626.8,237.9 633.4,226.1 634.3,222.3 636.5,222.9 639.4,216.7 639.8,217.8 645.7,212.3 
		646.3,213.4 658.7,206.2 660.5,202.8 660.1,198.8 658,197.4 655.2,198 647.4,205.8 642.8,207.2 638.8,206 638.8,208.6 630.3,213 
		627.2,216.2 625.9,219.6 624.5,218.2 624.3,223.5 621.6,230.9 622.8,233.2 	"
                />
                <polygon
                  className="WMst5"
                  points="632,265.7 637.2,268.6 637.1,267.1 633.2,262.4 	"
                />
                <polygon
                  className="WMst5"
                  points="563.4,396 563.1,396.3 560,399.2 562.9,399.8 563.4,403.1 564.5,403 568.3,400.3 567,398.3 	"
                />
                <polygon
                  className="WMst5"
                  points="864.8,372 865.4,368.5 863.9,363.9 861.1,365.4 861.5,367.4 860.7,372.2 862.5,375.7 861.9,378 
		862,384 861.3,385.6 862.1,387.3 861.9,392.5 861.2,394.5 862,397.3 862.9,394.4 865.1,394.1 864.6,391.8 863.2,389.8 863.3,388.1 
		864.4,384.2 865.8,383.3 867.5,383.6 866,375.1 	"
                />
                <polygon
                  className="WMst5"
                  points="533.2,360.7 533.1,360.6 533.1,360.7 533,360.4 532.9,357.9 532.9,357.9 529.1,356.6 528.3,356.5 
		528.2,356.5 525.2,359.5 525,360.5 533.3,360.8 533.2,360.7 	"
                />
                <polygon
                  className="WMst5"
                  points="921.8,337.5 921.6,339.6 924.3,338.1 924,336.3 	"
                />
                <polygon
                  className="WMst5"
                  points="820,375 820.2,374.9 820.1,374.8 820.1,374.7 820.1,374.6 	"
                />
                <polygon
                  className="WMst5"
                  points="524.6,360.4 524.6,360.4 525.2,359.5 	"
                />
                <polygon
                  className="WMst5"
                  points="616.3,254.7 617.8,253 618,259.7 622.5,261.7 625.4,260.1 625.4,256.4 623.4,250.3 623.3,245.3 
		624.5,243.4 625.9,238 621.8,236.1 617.3,238.5 615.8,244.4 615.2,249 613.3,247.9 612.7,253.4 614.9,253.8 	"
                />
                <polygon
                  className="WMst5"
                  points="609.1,143.4 605.5,142.7 603,150.7 600.1,152.8 610.9,146.6 	"
                />
                <polygon
                  className="WMst5"
                  points="603.3,274.3 603.6,275.9 604.7,276.4 609.1,273 605.4,270.1 603.7,271.8 	"
                />
                <path
                  className="WMst5"
                  d="M760.4,372l4.8-5.1l3.4-4l2.5-5.3l0.3-2.5l2-1.1l-1,7.8l-1.5,3.3l-2.1,1.5l-0.9,1.7l-1.3,0.1l-2,1.8l-1.2-0.1
		l-1.2,2.7L760.4,372z M553.2,325.8l1.7-2.6l0.5-1l2.4,2.5l2.4,1.2l0,3.5l-0.7,2.2l-1.6-0.8l-1.8,1.9L553.2,325.8z M567.2,321.2
		l1.4-2l-2-2l2.4,0.5l-0.2,3.1l2.2,5l-1.6,1.6L567.2,321.2z M889.3,292.1l1.1-0.8l-1.6,2.1L889.3,292.1z M619.2,281.4l-0.7,1
		l-1.6,0.4L619.2,281.4z M711.4,279.8l4.4-1.4l-2.7,2.3l-1.9,4.9L711.4,279.8z M705,268.1l0.2,0.2l-2.1,1l-0.1-0.1L705,268.1z
		 M706,267.9l1.8,2.7l-0.6,4.8l1.9,4.4l-0.9,4.2l1.6,7.4l1.3,0.8l-1.4-0.6l-1.8-7.4l1-4.5l-2.1-4.4l0.6-4.9l-2.3-2.1L706,267.9z
		 M749.8,195.9l-1.2,7.1l-3.2,1.1l-2.3-0.8l-0.2,2.8l-6.6,4.6l-0.6-2.7l-4.5-0.7l-2,3.3l-6,1.6l-6.7,2.4l-3,4l-2.8,1.7l-0.6,4
		l-3-2.6v5.3l3.9,2.6l-0.5,2.3l-18,2.8l-0.8,3.8l1.5,2.1l0.1,4.9l4,0.9l0.9,3.9l2.8,2.2l-1.4,4.5l1.7,5.1l0.5,5.8l1.2,1.2l-0.8,0.4
		l-4.4-4.7l-0.7-9.1l2.1-1.4l0.8-2.4l-5.9-0.7l-1-2.7l-6.3-2.8l-5.9,3.4l-0.2,3.9l-2.8,2l-0.2-5.2l1.3-3.1l-0.7-4.2l-1.4-1.2
		l0.1,6.5l-4.1,3.2l-1.4,3.5l3.6,6.8l-2.1,7l0.7,4.5l2.8,0.7l3.4-1.3l4.5,2.7l1.4,4.8l-1.8,1l-0.7-2.8l-1.9-3.6l-5.8,1.9l-0.5,2.6
		l1.4,2.7l-0.2,2.3l-2.3,2.8l-0.1,2.1l-3.9,2.9l-1,2.7l-7.4-2l5.4-3.3l1,0.5l2.2-4.9l1.6-0.7l-0.1-3.7l1.4-1.6l-2.9-4.4l-0.5-9.8
		l1.2-5l-2.7-5.5l2.8-6.8l0-4l-3.4-1.9l-1.7,0.8l-4.4-1.3l-2.7,11.5l-4.6,4.9l2.2,3.4l-1.6,5.6l0.2,2.6l3,1.2l1,4.4l-0.8,4.5
		l-2.9-3.4l-5.6-3.4l-2.6-2.1l-8.4-2.6l-1,1.6l1.1,6.5l-3.3,0.9l-0.7,3.2l-1.5-0.9l-0.2-4.3l-4.8,3.4l-3.6-0.8l-1.7,0.7l-1.4,3.1
		l-1-1.1l-1.4,2l0-6.1l-1.2-0.7l-2.5,2.2l-5.1,2l-2.1,2l-5.7,3.4l-1,5.5l-3,0.5l-2.2-0.7l-1-5.8l3.7-0.7l-0.4-2.3l-2-2.6l-4.8-0.4
		l0.8,4.7l-1.6,4.8l2.1,2.3l-1.3,6.3l-2.4-2.9l-3.9,1l-2.9,1.8l-2.8,2.9l2.6,6.9l-2.3-1.1l-0.8,0.8l-7.4-3.9l-0.9,2.8l1.9,2.3
		l1.5-0.5l0.5,3.2l-1.5,0.9l-3.1-1.2l-1.3-2.2l-3.1-1.2l0.4-3.3l-0.5-5.1l-1.5-3l0.1-3.9l3.9,2.8l7.5,2.2l4.7-1.3l3.3-3.9l0.5-2
		l-1.2-4.3l-1.3-0.1l-5-4.8l-0.6,0.6l-6-6.1l-7.4-1.5l-1.4-3.5l-3.2-1.7l-0.3,2.4l-2.7-1l-1.9,0.9h0l-1.2,2.4l-0.4,0.2l-0.5,0.2
		l-0.1,0.8l-1,1.2l-1.1,3.4l0.3,3.1l1.9,1l1.9,2.9l-2.5,6.1l1,1.9l0.6,1.7l0,0.1l0.3,0.5l0.1,0.1l0.3,0.9l0,0.1l-0.2,2.4l-0.1,0.1
		l-0.4,0.3l0,0.1l-0.4,4.5l1.2,1.3l0,0.1l0,1.9l0,0.2l0.2,0.2h0l1.1,1.7l-0.5,3.3l0.1,0.1h0l0.1,0.2l1.1,0.8l0.1,0.1h0l0.9,0.7
		l0,0.1l1.2,2.1l-0.9,2.3l-0.3,0.5l-2.7,3.5l-0.4,0.6l-0.8,0.9v0.1l-0.1,0.1l-0.1,0.1l-5.3,5.8l3.7,3.1l-0.8,1.2l-2.1-0.1l-0.2,1.7
		l0.4,0.6l-0.5,0.4h0l-0.1,0.1h0l-0.1,0.1l-0.4,1.1l-0.1,0.1l0,0.2l-0.3,5.1l0.1,0l0.1,0l0.1,0.5l-1,2h0.6h0l1.6,6.8l1.5,0.3
		l0.1,0.6l0.1,0l3.3,0.5l0.1,0l0.2,0.1l0.8,0.1l0.2,0.1l1.4,0.9l0.7,4.9h0l-0.2,0.2h0l0.5,1.5l3.1,2.3l0.8,1.5l-1.4,1.5l-2.3-0.5
		l-0.1,1.3l1.1,3.7l1.7-1l4-0.1l1.6,2.4l-0.3,2l2.7,1.3l1,3.1l1.4-0.4l1.4,0.9l2.1-0.9l1.7,2.3l0.8-0.8l4.7,2.6l-0.8,2.1l0.5,2.6
		l-0.5,2h-2.5l-1.5,1.2l-0.3,1.9l2.6-0.7l0.4,0.9l-4.3,1.5l0.6,2.6l-2.2,3.5l0.8,1.7l3.7,1.7l3.4,3.4l0.6-0.8l3.8,1.4l3.4,0.2l3,2.4
		l1.6-0.8l1.7,0.2l1.3,1.9l2.1,1l0.9,0.2l1.5,2l1.3,0.4l2.2-2.4l-3.1-4.4v-3l-2.1-3.3l1-0.6l1.2-3.2l3.4,0.2l1.6-2.6l-2.2-4.6
		l-1.1-1.3l-2.5-0.1l-0.2-2.1l-1.7-0.7l1.5-2.8l-0.4-3.3l2-2.6l2.3,2.8l1.3-0.9l-0.2-2.5l1.8-2.3l2.5-0.9l1.1-1.9l2.5,1.4l1.9-1.5
		l0.8,1.4h0l0.2-0.2h0.1l1.4,0l3.4,2.8l3.3,1.3l2.2-2.3l5.8,0.2l0.1,1l3.2,1.1l0.5-1.2l2.2,0.7l1.9-1.3l0-0.2l0.5-1.1l-3.2-2.4
		l1.3-2.3l-0.8-2l1.3-2.6l-0.5-1.5l1.3-2l3.1,0l3.8-0.6l4.2-2.2l4.3-0.6l0.2-0.1l3.2-1.4l0-0.1l1.3-1.2l0.1,0l0.4,0.2l0.2-0.1
		l0.4-0.2l0.1,0l2.1,0.8l2.4-0.4l1.3,3l0,2.5l3.4,0l2.1,0.9l0.2,2.2l4.6-1.5l1.1-1.4l2.4-1.2l0.7,1.6l3.6,3.1l3.7,6.5l2.4,5.1
		l1.6-2.5l1.4,0.6l1.1,1.9l2.7,0l1.5-1.1l1.8,0.5l1.3,2.7l2.1,0.9l0.6,2l2.6,0.5l1.2-0.4l1.8,1.9l1.4-0.2l1.1-1.3l2.6-0.1l1.2-1.7
		l5-2.4l1.1-1.1l3.2,0.2l0.3,0.2l3.3,0.2l1,2.3h1l0.1,0l0.1,0.2h0l0,0l2.3-0.2l3.9,1.2l2.3-1.2l0.7-1.8L740,376l0.6-1.9l2.4-3.1
		l8.8,3.5l0.5,3l2.7,2.1l2.4,0.2l3.3-1.5l4,0.8l1.1,1.3h0.1l1.4,0.1l0,0l2.1,2.7l1.8-0.1l2.8,0.8l7.1-1.5l2.8-2.5l2.1-0.6l2.2,1.3
		l0.4,0.2l1.9-0.6l1.3,0.9l3.2,1.4l1.7-1.4h0.1l0.3-0.4l0-0.1h0.1l1.2-0.2l0,0l0.1-0.1h0l0.6-1.2h0v0l0-0.1v0h-0.5l0.2-0.7l0-0.1
		l0.6-1.2l0,0l0.5-0.8l0-0.1l0.1-0.1l0,0l0.1-0.4l0,0l0-0.2h0.1l0.6-1.7l1.9-2.1h0.1l-0.3-1.4l0,0l-0.9-2.2l1.4-1.6V366l0.4-0.1
		l0.2,0l2.6-0.6l0.2,0l0.3-0.2l0.1,0l0.2-0.2h0.1l0.6,0.2h0.1l0.9-0.1l0.2-0.1l0.2,0h0.3l0,0l0.1-0.1l0.2-0.1l0.1,0l0.3,0.1h0.1
		l0.8,0.1l0.2,0l0.4,0.2l0.1,0l0.4,0.4h0.1l0,0h0l0.4,0.1l0.1,0.1l0.2,0.3h0v0l0.4,0.1h0l0.5,0.3l0.2,0.1l0.1,0.1h0l0-0.3l0.3-0.2
		h0.2l1.2,0.5l0.1,0.2v0.1l0.1-0.1l0.3,0.1l0.1,0l0,0l0.1,0l-0.1,0.3l-0.1,0l0.1,0.3l0.1-0.1l0.5,0.3l0,0.1v0l0.2,0.1v0l0.1-0.1
		l0.3,0.1l0,0.1l-0.1,0.2l-0.1,0.2v0.4h0.1l0.4,0.2l0,0.1l0,0l0.1,0.1l0.3,0.6l0,0.2h0.2l-0.1,0.1l-0.2,0.4l0.2,0l0.1,0l0.1,0l0,0.8
		l0,0.2l0.5,0.8l0,0.1h0.1l0,0.2v0.3l-0.1,0.1l0.1,0.2l0.1,0.1l0.4,0.7l0,0.2l-0.1,0l0.1,0l-0.1,0.4l0,0.1l1.1,2.1l-0.1,0.2l0,0.1
		l0.1,0.6l0,0.1l0,0.2l0.1,0.3l-0.1,0.1v0.1l0.2,0.2l0.1,0l0.4,0.2l-0.1,0.4l-0.1,1.4l0.4,0.2v0.3l0,0.1l0.3,0.2l0.1,0.1l0.2,0.1
		l0.2-0.1l0.1,0.1l0.2,0.1h0.1l0.8-0.2h0.2l0.8,0.2l-0.1,0.3h0.1l0.4,0.1h0l0.3,0.2l0.7,0.2l0.2-0.3h0.2l0.2,0.2l0.6,0.8l0.1,0
		l0.8,0.9l0.2,0.1l0.1,0.1l0.4,0l0.2,0l0.2,0.2h0.2l0.3,0l0.4,2.2v0.2l-0.4,0.8l0,0.1l0,0l0.1,0.1l1.1,1.4l1-0.2l1,0.3l0.2,0h0.2v0
		l0.1,0V390l0,0l0,0h0l0,0l0.1,0h0l1-0.1h0l0.4,0l0-0.1l0.7-0.8v0l1.1-0.5l0.5,0l0.4-0.1l0.6-0.5l0.1-0.1l0.4-0.1h0.1l0.5-0.3h0
		l0.9-0.2l0.1,0l0.6,0.2l-0.1,0.3l-0.2,0.6l0,0l0,0.1l-0.2,0.4l0,0.1l0,0l0.1,0.2l0.1,0v0.1l0,0l0,0.2l0.1,0.1l0.1,0.1l-0.1,0.3
		l0,0.1l-0.1,0.1l-0.1,0.2l-0.6,0.5h-0.3l-0.4,0.5l-0.1,0.1l0.1,0.3l0.1,0.2l-0.4,0.7l-0.1,0.2l-0.4,2.2l0,0.1l-0.1,0.4l-0.1,0.1v0
		l-0.1,0.1l-1.1,1.7l0.1,0l-0.1,0.3l0.1,0l-1.6,2.5l-1,2l-1.2-0.8l-0.1-1.9l-2.9,1.6l0.9,3.1l-0.4,4.2l-1.6,1.5l0,0l0.1,0.1h0
		l0.1,0.2l0.1,0.1v0.3l3.1-3.2l1.5-0.5l2.3,2.4l2.1-0.7l3.4-2.4l1.9-3.3l0.9-0.5l4.2-5.1l4.3-8l2.5-2.7l1-4.7l-0.3-5l0.8-3.3l2.3-3
		l-1.2-1.2l0.9-4l-2.5-1.6l-2.2-3.1l-3.2,1.5l-3.5-0.3l-1.5,1.4l0.2-4.1l-3,0.3l-1.4-1.6l8.3-7.4l1.9-3.6l4.3-3.6l0.8-2.4l2.1-1.6
		l1.4-2.3l3.2-1.9l9-0.3l2.8,1.2l2.4-0.1l2.7-2.8l3.8,1.1l1.8-0.3l1.8,3.9l2.3-0.1l1.3-1.8l1.8,1.1l0.2-2.2l2-4.7l2.9-2.2l2.1-2.8
		l0.1-1.8l2.2-1.5l1.6,0.3l2.4-1.2l1.7,0.6l2.2-0.8l0.2,5.3l1,1.8l4.4-5.4l1.6-0.8l0.9-4.2l3.2-1l-0.8,2.6l-0.3,5.3l-2.9,3.3l-2.8,2
		l-0.1,1.2l-3.9,3.6l-3.4,5.9l-2.8,2.3l-1.5,0l-2.6,4.8l-2.1,2l-1.2,7.3l1.6,11l0.9,1.4l0.5,7.4l4.4-4.8l0.3-3.1l3.4-2.8l1-4.1
		l1.8-1.6l2.9-0.1l1.2-1.1l-1.2-3.4l1.6-3.6l2,0.9l0.9-0.8l-0.4-2.8l-1.2-0.2l-0.1-2.8l1.6-2l-1.7-1.1l-2.2-0.1l0.9-3.4l2.8-2.2
		l-0.1-2.8l1.8-2.3l3.3-0.6l3.4-2.1l0.1,3.6l2-3.4l6.1-1.1l3,3.8l0.8-2.8l2.8-1.6l2-2.8l1.7-0.3l1.5-2.7l3-0.5l0.2-0.9l4.5-1.8
		l1.2-1.4l2.6-0.2l4,1.8l1.4-2.3l-1.7-4.1l-0.8-3.7l-3.3-3l0.4-1.9l3.3,0.3l3.2-2.5l1.6-3.5l-1-3.5l2.4,0.3l1.8,4l3.6-1l2.8,1.3
		l0.1,2.7l1.3,1.5l1.9-0.3l3,3.1l1.5,0.6l1.2-6.3l2.7-2l3.1-0.6l0.6-4.8l-3.6-4.4l-3.1,0.3L984,288l-0.1,4.8l-2.1-0.7l-0.9-5.8
		l-1.3-2.2l-5.7-4.3l-0.9,0.7l-2.9-2.9l-0.3-1.6l-3.2-1.8v0.1l-3.4-3.4l-7.2-3.5l-7.9,0.7l-1.5-1.6l-6.4-1.2l0.6,4.3l1.4,4.1
		l-1.3,1.4l-3,0.7l-0.6-2.1l-2.9-1.2l-1.1-4.4l-3.3,2.1l-6.4-0.7l-0.9-1.2l-4.8,0.6l-2.5,2.6l0.6,3.6l-1.6,2.8l-1.7,0.3l-4-1.4h-3
		l1.6-1.1l5.6,2.4l1.6-0.4l-0.3-8l-3.9-2.3l1.4-3.1l-0.9-2.8l-2.6-2.5l-3.7-1.2l-4.5-0.3l-9.2,2.8l-3.9-5.5l-3.4-0.7l0.1-4.8
		l-4.2-2.7l-3.4,0.1l-3,4.8l-0.7-4l-1.6-0.4l-2-3.4l-7-0.8l-1.8,1.3l-4.7,0.8l-0.6,4.8l1.8,0.9l0.2,3.7l-2.4,0.3l-1.2-2.1l-1.9,0.3
		l-1.5,2.1l-4.6-2.5l-2.6,1.6l-3.7,0.3l-2.4-3.1l-2.1,4.6l-1.5,4.8l-4.8-3.2l-1.3-4.6l-4-6.5l-2.6-0.7l1.3,6.1l1,8l-2.1,2.6
		l-2.4,0.1l-0.1,0.9l0.3,2l-2.5,1.8l-0.9,3.6l-2,2.9l-1,6.5l-1.9,5.2l2.4,8.4l1.4,6.1l-0.1,2l-3.9-15.9l-0.1-4.1l2.4-3.2l0.4-4.9
		l1.8-2.3l1.1-4.4l2.4-1.9l0.2-1.9l-0.2-0.9l0.3,0l0-0.4l2.7-0.2l1.7-2.1l-3.1-13.9l2.5-3.3l2.4-0.5l0.4-5.2l-7.9-0.2l-3.4-4.2
		l-3,3.9l1,5.1l-2.3,0.4l-8.3-1.7l-3.6-1.7l0.8-3.5l-8.8-1.7l-5.7,2l-1.7-2.1l-2.8,0.1l-5.2-2.8l-1.4,5.8l-3,1.9l-5.5,0.2l2.4-3.3
		l2.5-1l4.9-5.7l8.1-7.9l2.5-5.3l-0.4-5.2l-2.2-4.6l-4.4-5l-3.1,1.1l-5.7-1.1l-1.3-2.1l-4.4-2.7v-5.3l-5.1-2.2L749.8,195.9z"
                />
              </motion.g>
              <motion.g style={{ y: el1 }}>
                <text x="680" y="380" className="mapText">
                  30%
                </text>
              </motion.g>

              <motion.g style={{ y: el2 }}>
                <text x="835" y="450" className="mapText">
                  30%
                </text>
              </motion.g>
              <motion.g style={{ y: el4 }}>
                <text x="450" y="327" className="mapText">
                  28%
                </text>
              </motion.g>
              <motion.g style={{ y: el5 }}>
                <text x="260" y="460" className="mapText">
                  20%
                </text>
              </motion.g>
            </svg>
            <div className="row mb-3">
              <div className="col-3"></div>
              <div className="col-9">
                <motion.img
                  ref={viewRef}
                  animate={controls}
                  initial="hidden"
                  variants={retailVariants}
                  src={IranRetail}
                  alt="Online Retail Share in Iran"
                />
              </div>
              <div ref={viewRef}></div>
            </div>
          </div>
          <div>
            <h3 className="text-center color-dk-gray dk-medium pt-3">
              Share of
              <span className="color-dk-r"> Online retail </span>in Iran has
              increased from 3.2% to 4% with
              <span className="color-dk-r"> 25% growth </span>
              in 2021-22.
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Retail;
